import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type BreadcrumbInfo = {
  __typename?: 'BreadcrumbInfo';
  itemCollectionName: Scalars['String'];
  itemCollectionNumber: Scalars['String'];
  originGuid: Scalars['String'];
  originName?: Maybe<Scalars['String']>;
  originNumber: Scalars['String'];
};

export type ConditionCheck = {
  __typename?: 'ConditionCheck';
  conditionCheckJsonResponse: ConditionCheckJsonRequest;
  guid: Scalars['String'];
  itemGuid?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  titleGuid?: Maybe<Scalars['String']>;
  titleName?: Maybe<Scalars['String']>;
};

export type ConditionCheckInput = {
  athugasemdir?: InputMaybe<Scalars['String']>;
  dagsetning?: InputMaybe<Scalars['String']>;
  heildarastand?: InputMaybe<Scalars['JSONObject']>;
  itemGuid: Scalars['String'];
  meginskemmdir?: InputMaybe<Array<Scalars['JSONObject']>>;
  skodunarmadur?: InputMaybe<Scalars['JSONObject']>;
};

export type ConditionCheckJsonRequest = {
  __typename?: 'ConditionCheckJsonRequest';
  athugasemdir?: Maybe<Scalars['String']>;
  dagsetning?: Maybe<Scalars['String']>;
  heildarastand?: Maybe<SelectItemInt>;
  meginskemmdir?: Maybe<Array<SelectItemInt>>;
  skodunarmadur?: Maybe<Person>;
};

export type ConditionCheckList = {
  __typename?: 'ConditionCheckList';
  items?: Maybe<Array<ConditionCheck>>;
  pageInfo: PageInfo;
};

export type ConnectedItem = {
  __typename?: 'ConnectedItem';
  connectedItems?: Maybe<Array<Scalars['String']>>;
  itemGuid: Scalars['String'];
  itemInfoResponse: Array<ItemInfo>;
};

export type ConnectedItemsInput = {
  connectedItems?: InputMaybe<Array<Scalars['String']>>;
  isItemCopyOfConnectedItem: Scalars['Boolean'];
  itemGuid: Scalars['String'];
};

export type ContentAnalysis = {
  __typename?: 'ContentAnalysis';
  contentAnalysisJsonResponse: ContentAnalysisJsonResponse;
  guid: Scalars['String'];
  itemGuid?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  itemNumbers?: Maybe<Array<Scalars['String']>>;
  titleGuid?: Maybe<Scalars['String']>;
  titleName?: Maybe<Scalars['String']>;
};

export type ContentAnalysisInput = {
  efnislysing: Scalars['String'];
  itemGuid: Scalars['String'];
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  tcFra?: InputMaybe<Scalars['String']>;
  tcTil?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
  yearTo?: InputMaybe<Scalars['String']>;
};

export type ContentAnalysisJsonResponse = {
  __typename?: 'ContentAnalysisJsonResponse';
  efnislysing?: Maybe<Scalars['String']>;
  samtalsTimi?: Maybe<Scalars['String']>;
  tagsGuid?: Maybe<Array<Scalars['JSONObject']>>;
  tcFra?: Maybe<Scalars['String']>;
  tcTil?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
  yearTo?: Maybe<Scalars['String']>;
};

export type ContentAnalysisList = {
  __typename?: 'ContentAnalysisList';
  items?: Maybe<Array<ContentAnalysis>>;
  pageInfo: PageInfo;
};

export type ContentAnalysisListAndGuids = {
  __typename?: 'ContentAnalysisListAndGuids';
  list: ContentAnalysisList;
  totalGuids: Array<Scalars['String']>;
};

export type CopyItemsInput = {
  itemCollectionGuid: Scalars['String'];
  itemCopyInfos: Array<Scalars['JSONObject']>;
  itemGuid: Scalars['String'];
  itemTypeGuid?: InputMaybe<Scalars['String']>;
  locationsGuid?: InputMaybe<Array<Scalars['String']>>;
  numberOfCopies?: InputMaybe<Scalars['Float']>;
};

export type Credit = {
  __typename?: 'Credit';
  creditDateCreated?: Maybe<Scalars['String']>;
  creditJsonResponse?: Maybe<CreditJsonResponse>;
  creditName?: Maybe<Scalars['String']>;
  customerGuid?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customersGuid?: Maybe<Array<Scalars['String']>>;
  guid: Scalars['String'];
  tagsGuid?: Maybe<Array<DropDownDto>>;
  titleGuid: Scalars['String'];
  titleName?: Maybe<Scalars['String']>;
};

export type CreditForTitleInput = {
  comments?: InputMaybe<Scalars['String']>;
  customerName: Scalars['String'];
  dropdownItemName: Scalars['String'];
  titleGuid: Scalars['String'];
};

export type CreditInput = {
  comments?: InputMaybe<Scalars['String']>;
  customerGuid?: InputMaybe<Scalars['String']>;
  customersGuid?: InputMaybe<Array<Scalars['String']>>;
  dropdownItemId: Scalars['String'];
  dropdownItemName?: InputMaybe<Scalars['String']>;
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  titleGuid: Scalars['String'];
};

export type CreditItem = {
  __typename?: 'CreditItem';
  creditGuid?: Maybe<Scalars['String']>;
  creditName?: Maybe<Scalars['String']>;
  customerGuid?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  itemGuid?: Maybe<Scalars['String']>;
  itemNumber?: Maybe<Scalars['String']>;
  titleGuid?: Maybe<Scalars['String']>;
  titleName?: Maybe<Scalars['String']>;
};

export type CreditJsonResponse = {
  __typename?: 'CreditJsonResponse';
  comments?: Maybe<Scalars['String']>;
  dropdownItemId?: Maybe<Scalars['Float']>;
  dropdownItemName?: Maybe<Scalars['String']>;
};

export type CreditListAndGuids = {
  __typename?: 'CreditListAndGuids';
  list: CreditsList;
  totalGuids: Array<Scalars['String']>;
};

export type CreditsList = {
  __typename?: 'CreditsList';
  items?: Maybe<Array<Credit>>;
  pageInfo: PageInfo;
};

export type Customer = {
  __typename?: 'Customer';
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  contactsGuid?: Maybe<Array<Scalars['String']>>;
  deceased?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  identity?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  tagsGuid?: Maybe<Array<DropDownDto>>;
  tagsId?: Maybe<Array<Scalars['String']>>;
};

export type CustomerInput = {
  active: Scalars['Boolean'];
  address?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  contactsGuid?: InputMaybe<Array<Scalars['String']>>;
  deceased?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  identity?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  tagsId?: InputMaybe<Array<Scalars['String']>>;
};

export type CustomerListAndGuids = {
  __typename?: 'CustomerListAndGuids';
  list: CustomersList;
  totalGuids: Array<Scalars['String']>;
};

export type CustomersList = {
  __typename?: 'CustomersList';
  items?: Maybe<Array<Customer>>;
  pageInfo: PageInfo;
};

export type DropDownDto = {
  __typename?: 'DropDownDto';
  guid: Scalars['String'];
  title: Scalars['String'];
};

export type DropDownItem = {
  __typename?: 'DropDownItem';
  id: Scalars['Float'];
  value: Scalars['String'];
};

export type DropDownTypeItem = {
  __typename?: 'DropDownTypeItem';
  code: Scalars['String'];
  description: Scalars['String'];
  dropDownItemResponse: Array<DropDownItem>;
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type FilterContentAnalysisInput = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  efnislysing?: InputMaybe<Scalars['String']>;
  itemNumber?: InputMaybe<Array<Scalars['String']>>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  titles?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterCreditsInput = {
  comments?: InputMaybe<Scalars['String']>;
  creditType?: InputMaybe<Array<Scalars['String']>>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  tengilidir?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterCustomersInput = {
  athugasemd?: InputMaybe<Scalars['String']>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  skyring?: InputMaybe<Scalars['String']>;
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  tengilidir?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterItemCollectionInput = {
  efnislysing?: InputMaybe<Scalars['String']>;
  heiti?: InputMaybe<Scalars['String']>;
  itemCollectionNumber?: InputMaybe<Array<Scalars['String']>>;
  itemCollectionTypes?: InputMaybe<Array<Scalars['String']>>;
  originNumber?: InputMaybe<Array<Scalars['String']>>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  year?: InputMaybe<Scalars['String']>;
};

export type FilterItemInput = {
  afritunLokid?: InputMaybe<Scalars['String']>;
  athugasemd?: InputMaybe<Scalars['String']>;
  breidd?: InputMaybe<Array<Scalars['Float']>>;
  buidAdFylla?: InputMaybe<Scalars['String']>;
  coldLocations?: InputMaybe<Array<Scalars['String']>>;
  formCodes?: InputMaybe<Array<Scalars['String']>>;
  frumEintak?: InputMaybe<Scalars['String']>;
  gbStaerd?: InputMaybe<Scalars['String']>;
  heimildSafnmunir?: InputMaybe<Scalars['String']>;
  heiti?: InputMaybe<Scalars['String']>;
  itemCollectionNumber?: InputMaybe<Array<Scalars['String']>>;
  itemNumber?: InputMaybe<Array<Scalars['String']>>;
  itemOrderFrom?: InputMaybe<Scalars['String']>;
  itemOrderTo?: InputMaybe<Scalars['String']>;
  itemTypes?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['Float']>>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  ltoGerd?: InputMaybe<Scalars['String']>;
  lysing?: InputMaybe<Scalars['String']>;
  lysingSafnmunar?: InputMaybe<Scalars['String']>;
  lysingStafvaedingar?: InputMaybe<Scalars['String']>;
  minnispunktar?: InputMaybe<Scalars['String']>;
  nedanmalstextarId?: InputMaybe<Array<Scalars['Float']>>;
  originNumber?: InputMaybe<Array<Scalars['String']>>;
  ownersNumber?: InputMaybe<Scalars['String']>;
  rammarASekundu?: InputMaybe<Scalars['String']>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  skilaskyltEintak?: InputMaybe<Scalars['String']>;
  slod?: InputMaybe<Scalars['String']>;
  stadaSkraningar?: InputMaybe<Scalars['String']>;
  staerd?: InputMaybe<Scalars['String']>;
  stafvaeding?: InputMaybe<Scalars['String']>;
  timabilEfnisFra?: InputMaybe<Scalars['String']>;
  timabilEfnisTil?: InputMaybe<Scalars['String']>;
  titles?: InputMaybe<Array<Scalars['String']>>;
  upplysingarUmSafnmuninn?: InputMaybe<Scalars['String']>;
  upprunalegirEigendurGuid?: InputMaybe<Array<Scalars['String']>>;
  year?: InputMaybe<Scalars['String']>;
};

export type FilterOriginalTitleInput = {
  althjodlegurTitill?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['Float']>>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  locationInHouse?: InputMaybe<Array<Scalars['String']>>;
  originalTitle?: InputMaybe<Array<Scalars['String']>>;
  originalTitleType?: InputMaybe<Array<Scalars['Float']>>;
  overClassification?: InputMaybe<Array<Scalars['Float']>>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Array<Scalars['Float']>>;
  subClassification?: InputMaybe<Array<Scalars['Float']>>;
};

export type FilterOriginsInput = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  efnislysing?: InputMaybe<Scalars['String']>;
  heiti?: InputMaybe<Scalars['String']>;
  mottakendur?: InputMaybe<Array<Scalars['String']>>;
  originNumber?: InputMaybe<Array<Scalars['String']>>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  tengilidir?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterTitlesInput = {
  comments?: InputMaybe<Scalars['String']>;
  creditFullyRegistered?: InputMaybe<Scalars['Boolean']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<Scalars['Float']>>;
  premiereDate?: InputMaybe<Scalars['String']>;
  premiereLocation?: InputMaybe<Scalars['String']>;
  selectedGuids?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<Scalars['String']>>;
  year?: InputMaybe<Scalars['String']>;
};

export type Form = {
  __typename?: 'Form';
  code?: Maybe<Scalars['String']>;
  dropDownTypeItemResponse?: Maybe<Array<DropDownTypeItem>>;
  guid: Scalars['String'];
  metadata: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
};

export type InformationResponse = {
  __typename?: 'InformationResponse';
  createdBy: Scalars['String'];
  dateCreated: Scalars['String'];
  dateModified?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
};

export type Item = {
  __typename?: 'Item';
  breiddName?: Maybe<Scalars['String']>;
  coldLocationsNames?: Maybe<Array<Scalars['String']>>;
  formCode?: Maybe<Scalars['String']>;
  formGuid?: Maybe<Scalars['String']>;
  formName?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  informationResponse?: Maybe<InformationResponse>;
  isItemTypeLocation?: Maybe<Scalars['Boolean']>;
  itemCollectionGuid: Scalars['String'];
  itemCollectionNumber?: Maybe<Scalars['String']>;
  itemDateCreated?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  itemNumber: Scalars['String'];
  itemTypeGuid: Scalars['String'];
  itemTypeName?: Maybe<Scalars['String']>;
  json: Scalars['JSONObject'];
  languagesNames?: Maybe<Array<Scalars['String']>>;
  locationsNames?: Maybe<Array<Scalars['String']>>;
  originGuid: Scalars['String'];
  originNumber?: Maybe<Scalars['String']>;
  originYear?: Maybe<Scalars['String']>;
  subtitlesNames?: Maybe<Array<Scalars['String']>>;
  tagsGuid?: Maybe<Array<DropDownDto>>;
  title?: Maybe<Scalars['String']>;
  upprunalegirEigendurNames?: Maybe<Array<Scalars['String']>>;
};

export type ItemCollection = {
  __typename?: 'ItemCollection';
  guid: Scalars['String'];
  itemCollectionDateCreated: Scalars['String'];
  itemCollectionJsonResponse: ItemCollectionJsonResponse;
  itemCollectionName?: Maybe<Scalars['String']>;
  itemCollectionNumber: Scalars['String'];
  itemCollectionTypeCode?: Maybe<Scalars['String']>;
  itemCollectionTypeGuid: Scalars['String'];
  itemCount?: Maybe<Scalars['Float']>;
  originGuid: Scalars['String'];
  originName?: Maybe<Scalars['String']>;
  originNumber: Scalars['String'];
  originYear?: Maybe<Scalars['String']>;
  tagsGuid?: Maybe<Array<DropDownDto>>;
};

export type ItemCollectionInput = {
  afhendingarskilyrdi?: InputMaybe<Scalars['String']>;
  afhendingarskilyrdiId?: InputMaybe<Scalars['Float']>;
  heiti: Scalars['String'];
  itemCollectionType?: InputMaybe<Scalars['JSONObject']>;
  itemCollectionTypeGuid?: InputMaybe<Scalars['String']>;
  itemCount?: InputMaybe<Scalars['Float']>;
  lysing?: InputMaybe<Scalars['String']>;
  originGuid?: InputMaybe<Scalars['String']>;
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
};

export type ItemCollectionJsonResponse = {
  __typename?: 'ItemCollectionJsonResponse';
  afhendingarskilyrdi?: Maybe<Scalars['String']>;
  afhendingarskilyrdiId?: Maybe<Scalars['Float']>;
  heiti: Scalars['String'];
  itemCollectionTypeGuid?: Maybe<Scalars['String']>;
  lysing?: Maybe<Scalars['String']>;
  tegund?: Maybe<Scalars['String']>;
};

export type ItemCollectionListAndGuids = {
  __typename?: 'ItemCollectionListAndGuids';
  list: ItemCollectionsList;
  totalGuids: Array<Scalars['String']>;
};

export type ItemCollectionType = {
  __typename?: 'ItemCollectionType';
  code: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type ItemCollectionTypeDetail = {
  __typename?: 'ItemCollectionTypeDetail';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  createdByName?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  informationResponse: InformationResponse;
  modifiedByName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  originTypeGuid: Scalars['String'];
};

export type ItemCollectionTypeDetailList = {
  __typename?: 'ItemCollectionTypeDetailList';
  items?: Maybe<Array<ItemCollectionTypeDetail>>;
  pageInfo: PageInfo;
};

export type ItemCollectionTypeDetailListAndGuids = {
  __typename?: 'ItemCollectionTypeDetailListAndGuids';
  list: ItemCollectionTypeDetailList;
  totalGuids: Array<Scalars['String']>;
};

export type ItemCollectionTypeInput = {
  active: Scalars['Boolean'];
  code: Scalars['String'];
  name: Scalars['String'];
};

export type ItemCollectionTypeStatistic = {
  __typename?: 'ItemCollectionTypeStatistic';
  collectionTypeCode: Scalars['String'];
  collectionTypeName: Scalars['String'];
  itemCount: Scalars['Int'];
};

export type ItemCollectionsList = {
  __typename?: 'ItemCollectionsList';
  items?: Maybe<Array<ItemCollection>>;
  pageInfo: PageInfo;
};

export type ItemInfo = {
  __typename?: 'ItemInfo';
  coldLocationsName?: Maybe<Array<Scalars['String']>>;
  guid: Scalars['String'];
  hasContentAnalysis: Scalars['Boolean'];
  heiti?: Maybe<Scalars['String']>;
  isItemCopyOfConnectedItem: Scalars['Boolean'];
  itemJson: Scalars['JSONObject'];
  itemName?: Maybe<Scalars['String']>;
  itemNumber: Scalars['String'];
  itemOrder?: Maybe<Scalars['Float']>;
  itemTypeGuid: Scalars['String'];
  itemTypeName?: Maybe<Scalars['String']>;
  locationsName?: Maybe<Array<Scalars['String']>>;
  stadaSkraningar: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  tungumalName?: Maybe<Array<Scalars['String']>>;
};

export type ItemInput = {
  itemCollectionGuid: Scalars['String'];
  itemTypeGuid: Scalars['String'];
  json: Scalars['JSONObject'];
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  timabilEfnisFra?: InputMaybe<Scalars['String']>;
  timabilEfnisTil?: InputMaybe<Scalars['String']>;
};

export type ItemListAndGuids = {
  __typename?: 'ItemListAndGuids';
  list: ItemsList;
  totalGuids: Array<Scalars['String']>;
};

export type ItemLocationHistory = {
  __typename?: 'ItemLocationHistory';
  dateFrom: Scalars['String'];
  dateTo?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  informationResponse: InformationResponse;
  itemGuid: Scalars['String'];
  itemLocationGuid: Scalars['String'];
  locationGuid: Scalars['String'];
  locationName?: Maybe<Scalars['String']>;
};

export type ItemLocationsInput = {
  itemGuid: Scalars['String'];
  itemLocationGuids?: InputMaybe<Array<Scalars['String']>>;
};

export type ItemStatisticsByYear = {
  __typename?: 'ItemStatisticsByYear';
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  statistics: Array<ItemCollectionTypeStatistic>;
  year: Scalars['Int'];
};

export type ItemType = {
  __typename?: 'ItemType';
  code?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  name: Scalars['String'];
  visible?: Maybe<Scalars['Boolean']>;
};

export type ItemTypeDetail = {
  __typename?: 'ItemTypeDetail';
  active: Scalars['Boolean'];
  createdByName?: Maybe<Scalars['String']>;
  formGuid: Scalars['String'];
  guid: Scalars['String'];
  informationResponse: InformationResponse;
  itemCollectionTypeGuid: Scalars['String'];
  locationGuid: Scalars['String'];
  modifiedByName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type ItemTypeDetailList = {
  __typename?: 'ItemTypeDetailList';
  items?: Maybe<Array<ItemTypeDetail>>;
  pageInfo: PageInfo;
};

export type ItemTypeDetailListAndGuids = {
  __typename?: 'ItemTypeDetailListAndGuids';
  list: ItemTypeDetailList;
  totalGuids: Array<Scalars['String']>;
};

export type ItemTypeInput = {
  active: Scalars['Boolean'];
  name: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type ItemsList = {
  __typename?: 'ItemsList';
  items?: Maybe<Array<Item>>;
  pageInfo: PageInfo;
};

export type KmiCreditResponse = {
  __typename?: 'KMICreditResponse';
  customerName: Scalars['String'];
  dropdownItemName: Scalars['String'];
};

export type KmiInfoResponse = {
  __typename?: 'KMIInfoResponse';
  date?: Maybe<Scalars['String']>;
  genres?: Maybe<Array<Scalars['String']>>;
  languages?: Maybe<Array<Scalars['String']>>;
  productionYear?: Maybe<Scalars['String']>;
  synopsis?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleGuid: Scalars['String'];
};

export type KmiMovieData = {
  __typename?: 'KMIMovieData';
  genres?: Maybe<Array<Scalars['String']>>;
  languages?: Maybe<Array<Scalars['String']>>;
  productionYear?: Maybe<Scalars['String']>;
  synopsis?: Maybe<Scalars['String']>;
};

export type KmiSearchResult = {
  __typename?: 'KMISearchResult';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  guid: Scalars['String'];
  name: Scalars['String'];
};

export type LocationInput = {
  name: Scalars['String'];
};

export type LocationItem = {
  __typename?: 'LocationItem';
  itemGuid: Scalars['String'];
  itemName: Scalars['String'];
  itemNumber: Scalars['String'];
  itemType: Scalars['String'];
};

export type LocationsGuidInput = {
  locationsGuid: Array<Scalars['String']>;
};

export type MergeCustomerInput = {
  customerGuid: Scalars['String'];
  mergeCustomersGuids: Array<Scalars['String']>;
};

export type MergeOriginalTitleInput = {
  mergeOriginalTitleGuids: Array<Scalars['String']>;
  originalTitleGuid: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateOrDeactivateRightsAgreement: Scalars['Boolean'];
  addItemLocationToItems: Array<Item>;
  createConditionCheck: ConditionCheck;
  createConnectedItem: ConnectedItem;
  createContentAnalysis: ContentAnalysis;
  createCopyItems: Array<Item>;
  createCredit: Array<Credit>;
  createCreditsForTitle: Scalars['Boolean'];
  createCustomer: Customer;
  createItem: Item;
  createItemCollection: ItemCollection;
  createItemCollectionType: ItemCollectionTypeDetail;
  createItemType: ItemTypeDetail;
  createLocation: Location;
  createManyItems: Array<Item>;
  createOrigin: Origin;
  createOriginType: OriginType;
  createOriginalTitle: OriginalTitle;
  createOriginalTitleTitle: OriginalTitleTitle;
  createTag: Tag;
  createTitle: Title;
  deleteConditionCheck?: Maybe<Scalars['String']>;
  deleteConnectedItem?: Maybe<Scalars['String']>;
  deleteContentAnalysis?: Maybe<Scalars['String']>;
  deleteCredit?: Maybe<Scalars['String']>;
  deleteCustomer?: Maybe<Scalars['String']>;
  deleteItem?: Maybe<Scalars['String']>;
  deleteItemCollection?: Maybe<Scalars['String']>;
  deleteItemCollectionType?: Maybe<Scalars['String']>;
  deleteItemLocationFromItem?: Maybe<Scalars['String']>;
  deleteItemType?: Maybe<Scalars['String']>;
  deleteManyItems?: Maybe<Scalars['String']>;
  deleteOrigin?: Maybe<Scalars['String']>;
  deleteOriginType?: Maybe<Scalars['String']>;
  deleteOriginalTitle?: Maybe<Scalars['String']>;
  deleteTag?: Maybe<Scalars['String']>;
  deleteTitle?: Maybe<Scalars['String']>;
  fillContentAnalysisIndex: Scalars['Boolean'];
  fillCreditIndex: Scalars['Boolean'];
  fillCustomerIndex: Scalars['Boolean'];
  fillItemCollectionIndex: Scalars['Boolean'];
  fillItemIndex: Scalars['Boolean'];
  fillOriginIndex: Scalars['Boolean'];
  fillOriginalTitleIndex: Scalars['Boolean'];
  fillTitleIndex: Scalars['Boolean'];
  importItemsToItemCollection?: Maybe<Scalars['Boolean']>;
  mergeCustomers: Scalars['Boolean'];
  mergeOriginalTitles: Scalars['Boolean'];
  patchTitle: Title;
  reindexImportResult?: Maybe<Scalars['Boolean']>;
  updateConditionCheck: ConditionCheck;
  updateContentAnalysis: ContentAnalysis;
  updateCredit: Credit;
  updateCustomer: Customer;
  updateItem: Item;
  updateItemCollection: ItemCollection;
  updateItemCollectionType: ItemCollectionTypeDetail;
  updateItemType: ItemTypeDetail;
  updateItemsLocation: Array<Item>;
  updateItemsRegistration: Array<Item>;
  updateOrigin: Origin;
  updateOriginalTitle: OriginalTitle;
  updateTag: Tag;
  updateTitle: Title;
};


export type MutationActivateOrDeactivateRightsAgreementArgs = {
  active: Scalars['Boolean'];
  rightsAgreementGuid: Scalars['String'];
};


export type MutationAddItemLocationToItemsArgs = {
  itemLocations: ItemLocationsInput;
};


export type MutationCreateConditionCheckArgs = {
  conditionCheck: ConditionCheckInput;
};


export type MutationCreateConnectedItemArgs = {
  connectedItems: ConnectedItemsInput;
};


export type MutationCreateContentAnalysisArgs = {
  contentAnalysis: ContentAnalysisInput;
};


export type MutationCreateCopyItemsArgs = {
  copyItems: CopyItemsInput;
};


export type MutationCreateCreditArgs = {
  credit: CreditInput;
};


export type MutationCreateCreditsForTitleArgs = {
  creditRequests: Array<CreditForTitleInput>;
};


export type MutationCreateCustomerArgs = {
  customer: CustomerInput;
};


export type MutationCreateItemArgs = {
  item: ItemInput;
};


export type MutationCreateItemCollectionArgs = {
  itemCollection: ItemCollectionInput;
};


export type MutationCreateItemCollectionTypeArgs = {
  itemCollectionType: ItemCollectionTypeInput;
  originTypeGuid: Scalars['String'];
};


export type MutationCreateItemTypeArgs = {
  formGuid: Scalars['String'];
  itemCollectionTypeGuid: Scalars['String'];
  itemType: ItemTypeInput;
};


export type MutationCreateLocationArgs = {
  itemTypeGuid: Scalars['String'];
  location: LocationInput;
};


export type MutationCreateManyItemsArgs = {
  comment?: InputMaybe<Scalars['String']>;
  itemCollectionGuid: Scalars['String'];
  itemCount: Scalars['Int'];
  itemTypeGuid?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationsGuidInput>;
  titleGuid?: InputMaybe<Scalars['String']>;
};


export type MutationCreateOriginArgs = {
  origin: OriginInput;
};


export type MutationCreateOriginTypeArgs = {
  originType: OriginTypeInput;
};


export type MutationCreateOriginalTitleArgs = {
  originalTitle: OriginalTitleInput;
};


export type MutationCreateOriginalTitleTitleArgs = {
  originalTitleTitle: OriginalTitleTitleInput;
};


export type MutationCreateTagArgs = {
  tag: TagInput;
};


export type MutationCreateTitleArgs = {
  title: TitleInput;
};


export type MutationDeleteConditionCheckArgs = {
  conditionCheckGuid: Scalars['String'];
};


export type MutationDeleteConnectedItemArgs = {
  connectedItemGuid: Scalars['String'];
  itemGuid: Scalars['String'];
};


export type MutationDeleteContentAnalysisArgs = {
  contentAnalysisGuid: Scalars['String'];
};


export type MutationDeleteCreditArgs = {
  creditGuid: Scalars['String'];
};


export type MutationDeleteCustomerArgs = {
  customerGuid: Scalars['String'];
};


export type MutationDeleteItemArgs = {
  itemGuid: Scalars['String'];
};


export type MutationDeleteItemCollectionArgs = {
  itemCollectionGuid: Scalars['String'];
};


export type MutationDeleteItemCollectionTypeArgs = {
  itemCollectionTypeGuid: Scalars['String'];
};


export type MutationDeleteItemLocationFromItemArgs = {
  itemGuid: Scalars['String'];
  itemLocationGuid: Scalars['String'];
};


export type MutationDeleteItemTypeArgs = {
  itemTypeGuid: Scalars['String'];
};


export type MutationDeleteManyItemsArgs = {
  itemGuids: Array<Scalars['String']>;
};


export type MutationDeleteOriginArgs = {
  originGuid: Scalars['String'];
};


export type MutationDeleteOriginTypeArgs = {
  originTypeGuid: Scalars['String'];
};


export type MutationDeleteOriginalTitleArgs = {
  originalTitleGuid: Scalars['String'];
};


export type MutationDeleteTagArgs = {
  tagGuid: Scalars['String'];
};


export type MutationDeleteTitleArgs = {
  titleGuid: Scalars['String'];
};


export type MutationImportItemsToItemCollectionArgs = {
  excelImportGuid: Scalars['String'];
  formTypeEnum: Scalars['String'];
  itemCollectionGuid: Scalars['String'];
};


export type MutationMergeCustomersArgs = {
  mergeCustomerData: MergeCustomerInput;
};


export type MutationMergeOriginalTitlesArgs = {
  mergeOriginalTitleData: MergeOriginalTitleInput;
};


export type MutationPatchTitleArgs = {
  title: PatchTitleInput;
  titleGuid: Scalars['String'];
};


export type MutationReindexImportResultArgs = {
  importResultJson: Scalars['String'];
};


export type MutationUpdateConditionCheckArgs = {
  conditionCheck: ConditionCheckInput;
  conditionCheckGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateContentAnalysisArgs = {
  contentAnalysis: ContentAnalysisInput;
  contentAnalysisGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCreditArgs = {
  credit: CreditInput;
  creditGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCustomerArgs = {
  customer: CustomerInput;
  customerGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateItemArgs = {
  item: ItemInput;
  itemGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateItemCollectionArgs = {
  itemCollection: ItemCollectionInput;
  itemCollectionGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateItemCollectionTypeArgs = {
  itemCollectionType: ItemCollectionTypeInput;
  itemCollectionTypeGuid: Scalars['String'];
};


export type MutationUpdateItemTypeArgs = {
  itemType: ItemTypeInput;
  itemTypeGuid: Scalars['String'];
};


export type MutationUpdateItemsLocationArgs = {
  itemGuids: Array<Scalars['String']>;
  updateColdLocationInput: UpdateColdLocationInput;
  updateItemsLocationInput: UpdateItemsLocationInput;
};


export type MutationUpdateItemsRegistrationArgs = {
  itemCollectionGuid: Scalars['String'];
  state: Scalars['Boolean'];
};


export type MutationUpdateOriginArgs = {
  origin: OriginInput;
  originGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOriginalTitleArgs = {
  originalTitle: OriginalTitleInput;
  originalTitleGuid?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateTagArgs = {
  tag: TagInput;
  tagGuid: Scalars['String'];
};


export type MutationUpdateTitleArgs = {
  title: TitleInput;
  titleGuid?: InputMaybe<Scalars['String']>;
};

export type Origin = {
  __typename?: 'Origin';
  guid: Scalars['String'];
  originDate: Scalars['String'];
  originJsonRequest: OriginJsonRequest;
  originJsonResponse: OriginJsonResponse;
  originName?: Maybe<Scalars['String']>;
  originNumber: Scalars['String'];
  originTypeGuid: Scalars['String'];
  tagsGuid?: Maybe<Array<DropDownDto>>;
};

export type OriginInput = {
  dagsetning: Scalars['String'];
  heiti: Scalars['String'];
  lysing?: InputMaybe<Scalars['String']>;
  mottakandiGuid?: InputMaybe<Array<Scalars['String']>>;
  originTypeGuid: Scalars['String'];
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  tengilidurGuid?: InputMaybe<Array<Scalars['String']>>;
};

export type OriginJsonRequest = {
  __typename?: 'OriginJsonRequest';
  dagsetning: Scalars['String'];
  heiti: Scalars['String'];
  lysing?: Maybe<Scalars['String']>;
};

export type OriginJsonResponse = {
  __typename?: 'OriginJsonResponse';
  dagsetning: Scalars['String'];
  heiti: Scalars['String'];
  lysing?: Maybe<Scalars['String']>;
  mottakendur?: Maybe<Array<Person>>;
  tengilidir?: Maybe<Array<Person>>;
};

export type OriginListAndGuids = {
  __typename?: 'OriginListAndGuids';
  list: OriginsList;
  totalGuids: Array<Scalars['String']>;
};

export type OriginType = {
  __typename?: 'OriginType';
  active: Scalars['String'];
  guid: Scalars['String'];
  informationResponse: InformationResponse;
  name: Scalars['String'];
};

export type OriginTypeInput = {
  active: Scalars['Boolean'];
  name: Scalars['String'];
};

export type OriginalTitle = {
  __typename?: 'OriginalTitle';
  guid: Scalars['String'];
  informationResponse: InformationResponse;
  originalTitleDateCreated: Scalars['String'];
  originalTitleJsonRequest: OriginalTitleJsonRequest;
  originalTitleJsonResponse: OriginalTitleJsonResponse;
  originalTitleName: Scalars['String'];
};

export type OriginalTitleInput = {
  althjodlegurTitill?: InputMaybe<Scalars['String']>;
  frumtitill: Scalars['String'];
  heimild?: InputMaybe<Scalars['String']>;
  heimildId?: InputMaybe<Scalars['Float']>;
  lysing?: InputMaybe<Scalars['String']>;
  originalTitleName: Scalars['String'];
  stadsetningFrumefnisUtanhuss?: InputMaybe<Scalars['String']>;
  tegundTitils?: InputMaybe<Scalars['String']>;
  tegundTitilsHeiti?: InputMaybe<Scalars['String']>;
  undirflokkar: Array<Scalars['JSONObject']>;
  upprunalond: Array<Scalars['JSONObject']>;
  yfirflokkar: Array<Scalars['JSONObject']>;
};

export type OriginalTitleJsonRequest = {
  __typename?: 'OriginalTitleJsonRequest';
  althjodlegurTitill?: Maybe<Scalars['String']>;
  frumtitill: Scalars['String'];
  heimild?: Maybe<Scalars['String']>;
  heimildId?: Maybe<Scalars['Float']>;
  lysing?: Maybe<Scalars['String']>;
  stadsetningFrumefnisUtanhuss?: Maybe<Scalars['String']>;
  tegundTitils?: Maybe<Scalars['Float']>;
  tegundTitilsHeiti?: Maybe<Scalars['String']>;
  undirflokkar?: Maybe<Array<Scalars['JSONObject']>>;
  upprunalond?: Maybe<Array<Scalars['JSONObject']>>;
  yfirflokkar?: Maybe<Array<Scalars['JSONObject']>>;
};

export type OriginalTitleJsonResponse = {
  __typename?: 'OriginalTitleJsonResponse';
  althjodlegurTitill?: Maybe<Scalars['String']>;
  frumtitill: Scalars['String'];
  heimild?: Maybe<Scalars['String']>;
  heimildId?: Maybe<Scalars['Float']>;
  lysing?: Maybe<Scalars['String']>;
  stadsetningFrumefnisUtanhuss?: Maybe<Scalars['String']>;
  tegundTitils?: Maybe<Scalars['Float']>;
  tegundTitilsHeiti?: Maybe<Scalars['String']>;
  undirflokkar?: Maybe<Array<Scalars['JSONObject']>>;
  upprunalond?: Maybe<Array<Scalars['JSONObject']>>;
  yfirflokkar?: Maybe<Array<Scalars['JSONObject']>>;
};

export type OriginalTitleListAndGuids = {
  __typename?: 'OriginalTitleListAndGuids';
  list: OriginalTitlesList;
  totalGuids: Array<Scalars['String']>;
};

export type OriginalTitleTitle = {
  __typename?: 'OriginalTitleTitle';
  originalTitle?: Maybe<OriginalTitle>;
  title: Title;
};

export type OriginalTitleTitleInput = {
  originalTitleGuid?: InputMaybe<Scalars['String']>;
  originalTitleName?: InputMaybe<Scalars['String']>;
  titleName: Scalars['String'];
};

export type OriginalTitlesList = {
  __typename?: 'OriginalTitlesList';
  items?: Maybe<Array<OriginalTitle>>;
  pageInfo: PageInfo;
};

export type OriginsList = {
  __typename?: 'OriginsList';
  items?: Maybe<Array<Origin>>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  totalResults: Scalars['Float'];
};

export type PaginationInput = {
  pageIndex?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type PatchTitleInput = {
  athugasemdir?: InputMaybe<Scalars['String']>;
  frumsyning?: InputMaybe<Scalars['String']>;
  kreditFullskradur?: InputMaybe<Scalars['Boolean']>;
  lengdEfnis?: InputMaybe<Scalars['String']>;
  originalTitleGuid?: InputMaybe<Scalars['String']>;
  stadsetningFrumsyningar?: InputMaybe<Scalars['String']>;
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  titill?: InputMaybe<Scalars['String']>;
  titleName?: InputMaybe<Scalars['String']>;
  tungumal?: InputMaybe<Array<Scalars['JSONObject']>>;
  utgafuAr?: InputMaybe<Scalars['String']>;
};

export type Person = {
  __typename?: 'Person';
  guid?: Maybe<Scalars['String']>;
  nafn?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  allItemTypeOptions: Array<SelectItem>;
  allUserOptions?: Maybe<Array<SelectItem>>;
  breiddOptions?: Maybe<Array<SelectItemInt>>;
  checkIfNameExists: Scalars['Float'];
  coldLocationOptions?: Maybe<Array<SelectItem>>;
  coldLocationOptionsByForm: Array<SelectItem>;
  conditionCheck?: Maybe<ConditionCheck>;
  conditionCheckDamageOptions: Array<SelectItemInt>;
  conditionCheckInspectorOptions: Array<SelectItem>;
  conditionCheckStateOptions: Array<SelectItemInt>;
  contentAnalyses?: Maybe<Array<ContentAnalysis>>;
  contentAnalysis?: Maybe<ContentAnalysis>;
  contentAnalysisPaginated?: Maybe<ContentAnalysisListAndGuids>;
  contentAnalysisTagsOptions?: Maybe<Array<SelectItem>>;
  countryOfOriginOptions?: Maybe<Array<SelectItemInt>>;
  credit?: Maybe<Credit>;
  creditOptions?: Maybe<Array<SelectItem>>;
  credits?: Maybe<Array<Credit>>;
  creditsPaginated?: Maybe<CreditListAndGuids>;
  customer?: Maybe<Customer>;
  customerContacts?: Maybe<Array<SelectItem>>;
  customerCreditItems?: Maybe<Array<CreditItem>>;
  customerCredits: Array<Credit>;
  customerOptions?: Maybe<Array<SelectItem>>;
  customerTags?: Maybe<Array<SelectItem>>;
  customerTagsOptions?: Maybe<Array<SelectItem>>;
  customers?: Maybe<Array<Customer>>;
  customersOptions: Array<SelectItem>;
  customersPaginated?: Maybe<CustomerListAndGuids>;
  discLocationOptions?: Maybe<Array<SelectItem>>;
  formForItemType: Form;
  formsForMuseum: Array<Form>;
  getCollectionAndOriginNumber: BreadcrumbInfo;
  getCollectionTypes?: Maybe<Array<ItemCollectionType>>;
  getCollectionTypesList?: Maybe<Array<SelectItem>>;
  getConnectedItems: Array<ConnectedItem>;
  getDeliveryConditions: Array<SelectItemInt>;
  getItemLocationHistory: Array<ItemLocationHistory>;
  getItemLocations: Array<LocationItem>;
  item?: Maybe<Item>;
  itemCollection?: Maybe<ItemCollection>;
  itemCollectionFormTypeCode: Scalars['String'];
  itemCollectionNumberOptions?: Maybe<Array<SelectItem>>;
  itemCollectionTypeDetail?: Maybe<ItemCollectionTypeDetail>;
  itemCollectionTypeDetails?: Maybe<ItemCollectionTypeDetailListAndGuids>;
  itemCollectionTypeDetailsPaginated?: Maybe<ItemCollectionTypeDetailListAndGuids>;
  itemCollections?: Maybe<Array<ItemCollection>>;
  itemCollectionsForOriginOptions: Array<SelectItem>;
  itemCollectionsInOrigin: Array<ItemCollection>;
  itemCollectionsOptions?: Maybe<Array<SelectItem>>;
  itemCollectionsPaginated?: Maybe<ItemCollectionListAndGuids>;
  itemConditionCheck: Array<ConditionCheck>;
  itemContentAnalyses: Array<ContentAnalysis>;
  itemCountFromCollection: Scalars['Float'];
  itemNumberOptions?: Maybe<Array<SelectItem>>;
  itemStatisticsByCollectionType: ItemStatisticsByYear;
  itemType?: Maybe<ItemType>;
  itemTypeDetail?: Maybe<ItemTypeDetail>;
  itemTypeDetails?: Maybe<ItemTypeDetailListAndGuids>;
  itemTypeDetailsPaginated?: Maybe<ItemTypeDetailListAndGuids>;
  itemTypeOptions?: Maybe<Array<SelectItem>>;
  itemTypes?: Maybe<Array<ItemType>>;
  itemTypesForItemCollectionType?: Maybe<Array<SelectItem>>;
  items?: Maybe<Array<Item>>;
  itemsInCollection: Array<ItemInfo>;
  itemsInOriginalTitle: Array<TitleItemInfo>;
  itemsInTitle: Array<ItemInfo>;
  itemsPaginated?: Maybe<ItemListAndGuids>;
  itemsWithItemType: Scalars['Int'];
  kmiCredits?: Maybe<Array<KmiCreditResponse>>;
  kmiInfoForTitle?: Maybe<KmiInfoResponse>;
  languageOptions?: Maybe<Array<SelectItemInt>>;
  location?: Maybe<Location>;
  locationOptions?: Maybe<Array<SelectItem>>;
  locationOptionsByForm: Array<SelectItem>;
  locationsForMuseum: Array<Location>;
  origin?: Maybe<Origin>;
  originForItemCollectionOption: Array<SelectItem>;
  originNumber: Scalars['String'];
  originNumberOptions?: Maybe<Array<SelectItem>>;
  originOptions?: Maybe<Array<SelectItem>>;
  originType?: Maybe<OriginType>;
  originTypeOptions?: Maybe<Array<SelectItem>>;
  originTypes?: Maybe<Array<OriginType>>;
  originalTitle?: Maybe<OriginalTitle>;
  originalTitleOptions?: Maybe<Array<SelectItem>>;
  originalTitleTitle: Scalars['String'];
  originalTitles?: Maybe<Array<OriginalTitle>>;
  originalTitlesOptions?: Maybe<Array<SelectItem>>;
  originalTitlesPaginated?: Maybe<OriginalTitleListAndGuids>;
  origins?: Maybe<Array<Origin>>;
  originsPaginated?: Maybe<OriginListAndGuids>;
  overClassificationOptions?: Maybe<Array<SelectItemInt>>;
  rightsAgreements?: Maybe<Array<RightsAgreementDocument>>;
  searchKMIMovies?: Maybe<Array<KmiSearchResult>>;
  searchTMDbMovies?: Maybe<Array<TmDbSearchResult>>;
  selectedGuidsAsSelectItems?: Maybe<Array<SelectItem>>;
  selectedItemsOptions: Array<SelectItem>;
  sortedItemsGuids: Array<Scalars['String']>;
  sourceOptions?: Maybe<Array<SelectItemInt>>;
  stickerTypes?: Maybe<Array<SelectItem>>;
  subClassificationOptions?: Maybe<Array<SelectItemInt>>;
  subtypeOptions?: Maybe<Array<SelectItemInt>>;
  tag?: Maybe<Tag>;
  tags?: Maybe<TagsListAndGuids>;
  tagsPaginated?: Maybe<TagsListAndGuids>;
  title?: Maybe<Title>;
  titleCredits: Array<Credit>;
  titleDirector?: Maybe<Scalars['String']>;
  titleOptions?: Maybe<Array<SelectItem>>;
  titles?: Maybe<Array<Title>>;
  titlesInOriginalTitle: Array<Title>;
  titlesPaginated?: Maybe<TitleListAndGuids>;
  tmdbCredits?: Maybe<Array<TmDbCreditResponse>>;
  tmdbInfoForTitle?: Maybe<TmDbInfoResponse>;
  userOptions?: Maybe<Array<SelectItem>>;
  validateTitleDeletion?: Maybe<Scalars['String']>;
};


export type QueryCheckIfNameExistsArgs = {
  name: Scalars['String'];
};


export type QueryColdLocationOptionsArgs = {
  itemTypeGuid: Scalars['String'];
};


export type QueryColdLocationOptionsByFormArgs = {
  formCode?: InputMaybe<Scalars['String']>;
};


export type QueryConditionCheckArgs = {
  conditionCheckGuid?: InputMaybe<Scalars['String']>;
};


export type QueryConditionCheckDamageOptionsArgs = {
  dropDownItemId?: InputMaybe<Scalars['Float']>;
};


export type QueryConditionCheckStateOptionsArgs = {
  dropDownItemId?: InputMaybe<Scalars['Float']>;
};


export type QueryContentAnalysesArgs = {
  search?: InputMaybe<SearchContentAnalysisInput>;
};


export type QueryContentAnalysisArgs = {
  contentAnalysisGuid?: InputMaybe<Scalars['String']>;
};


export type QueryContentAnalysisPaginatedArgs = {
  filter?: InputMaybe<FilterContentAnalysisInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchContentAnalysisInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryCreditArgs = {
  creditGuid?: InputMaybe<Scalars['String']>;
};


export type QueryCreditsArgs = {
  search?: InputMaybe<SearchCreditsInput>;
};


export type QueryCreditsPaginatedArgs = {
  filter?: InputMaybe<FilterCreditsInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchCreditsInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerArgs = {
  customerGuid?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerContactsArgs = {
  customerGuid?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerCreditItemsArgs = {
  customerGuid?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerCreditsArgs = {
  customerGuid?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerOptionsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerTagsArgs = {
  customerGuid?: InputMaybe<Scalars['String']>;
};


export type QueryCustomersArgs = {
  search?: InputMaybe<SearchCustomerInput>;
};


export type QueryCustomersOptionsArgs = {
  customerGuids: Array<Scalars['String']>;
};


export type QueryCustomersPaginatedArgs = {
  filter?: InputMaybe<FilterCustomersInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchCustomerInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryFormForItemTypeArgs = {
  itemTypeGuid: Scalars['String'];
};


export type QueryGetCollectionAndOriginNumberArgs = {
  itemCollectionGuid: Scalars['String'];
};


export type QueryGetConnectedItemsArgs = {
  itemGuid: Scalars['String'];
};


export type QueryGetDeliveryConditionsArgs = {
  dropDownItemId?: InputMaybe<Scalars['Float']>;
};


export type QueryGetItemLocationHistoryArgs = {
  itemGuid: Scalars['String'];
};


export type QueryGetItemLocationsArgs = {
  itemGuid: Scalars['String'];
};


export type QueryItemArgs = {
  itemGuid?: InputMaybe<Scalars['String']>;
};


export type QueryItemCollectionArgs = {
  itemCollectionGuid?: InputMaybe<Scalars['String']>;
};


export type QueryItemCollectionFormTypeCodeArgs = {
  itemCollectionTypeGuid: Scalars['String'];
};


export type QueryItemCollectionNumberOptionsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryItemCollectionTypeDetailArgs = {
  itemCollectionTypeDetailGuid?: InputMaybe<Scalars['String']>;
};


export type QueryItemCollectionTypeDetailsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchAdminComponentInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryItemCollectionsArgs = {
  search?: InputMaybe<SearchItemCollectionInput>;
};


export type QueryItemCollectionsForOriginOptionsArgs = {
  originGuid: Scalars['String'];
};


export type QueryItemCollectionsInOriginArgs = {
  originGuid: Scalars['String'];
};


export type QueryItemCollectionsPaginatedArgs = {
  filter?: InputMaybe<FilterItemCollectionInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchItemCollectionInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryItemConditionCheckArgs = {
  itemGuid: Scalars['String'];
};


export type QueryItemContentAnalysesArgs = {
  itemGuid: Scalars['String'];
};


export type QueryItemCountFromCollectionArgs = {
  itemCollectionGuid: Scalars['String'];
};


export type QueryItemNumberOptionsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryItemStatisticsByCollectionTypeArgs = {
  collectionTypeGuids: Array<Scalars['String']>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  skraninguLokid?: InputMaybe<Scalars['String']>;
};


export type QueryItemTypeArgs = {
  itemTypeGuid?: InputMaybe<Scalars['String']>;
};


export type QueryItemTypeDetailArgs = {
  itemTypeDetailGuid?: InputMaybe<Scalars['String']>;
};


export type QueryItemTypeDetailsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchAdminComponentInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryItemTypeOptionsArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryItemTypesForItemCollectionTypeArgs = {
  itemCollectionGuid?: InputMaybe<Scalars['String']>;
};


export type QueryItemsArgs = {
  search?: InputMaybe<SearchItemInput>;
};


export type QueryItemsInCollectionArgs = {
  itemCollectionGuid: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryItemsInOriginalTitleArgs = {
  originalTitleGuid: Scalars['String'];
};


export type QueryItemsInTitleArgs = {
  titleGuid: Scalars['String'];
};


export type QueryItemsPaginatedArgs = {
  filter?: InputMaybe<FilterItemInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchItemInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryItemsWithItemTypeArgs = {
  itemTypeGuid: Scalars['String'];
};


export type QueryKmiCreditsArgs = {
  movieId: Scalars['String'];
};


export type QueryKmiInfoForTitleArgs = {
  kmiId: Scalars['String'];
  titleGuid: Scalars['String'];
};


export type QueryLocationArgs = {
  locationGuid?: InputMaybe<Scalars['String']>;
};


export type QueryLocationOptionsArgs = {
  itemTypeGuid: Scalars['String'];
};


export type QueryLocationOptionsByFormArgs = {
  formCode?: InputMaybe<Scalars['String']>;
};


export type QueryOriginArgs = {
  originGuid?: InputMaybe<Scalars['String']>;
};


export type QueryOriginForItemCollectionOptionArgs = {
  itemCollectionGuid: Scalars['String'];
};


export type QueryOriginNumberArgs = {
  originGuid: Scalars['String'];
};


export type QueryOriginNumberOptionsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryOriginTypeArgs = {
  originTypeGuid?: InputMaybe<Scalars['String']>;
};


export type QueryOriginalTitleArgs = {
  originalTitleGuid?: InputMaybe<Scalars['String']>;
};


export type QueryOriginalTitleOptionsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryOriginalTitleTitleArgs = {
  originalTitleGuid: Scalars['String'];
};


export type QueryOriginalTitlesArgs = {
  search?: InputMaybe<SearchOriginalTitlesInput>;
};


export type QueryOriginalTitlesOptionsArgs = {
  originalTitleGuids: Array<Scalars['String']>;
};


export type QueryOriginalTitlesPaginatedArgs = {
  filter?: InputMaybe<FilterOriginalTitleInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchOriginalTitlesInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryOriginsArgs = {
  search?: InputMaybe<SearchOriginsInput>;
};


export type QueryOriginsPaginatedArgs = {
  filter?: InputMaybe<FilterOriginsInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchOriginsInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryRightsAgreementsArgs = {
  customerGuid?: InputMaybe<Scalars['String']>;
  originalTitleGuid?: InputMaybe<Scalars['String']>;
};


export type QuerySearchKmiMoviesArgs = {
  name: Scalars['String'];
};


export type QuerySearchTmDbMoviesArgs = {
  name: Scalars['String'];
};


export type QuerySelectedGuidsAsSelectItemsArgs = {
  selectedGuids: Array<Scalars['String']>;
  source: Scalars['String'];
};


export type QuerySelectedItemsOptionsArgs = {
  itemGuids: Array<Scalars['String']>;
};


export type QuerySortedItemsGuidsArgs = {
  selectedGuids: Array<Scalars['String']>;
  sort: Scalars['String'];
  sortBy: Scalars['String'];
};


export type QueryTagArgs = {
  tagGuid?: InputMaybe<Scalars['String']>;
};


export type QueryTagsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchAdminComponentInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryTitleArgs = {
  titleGuid?: InputMaybe<Scalars['String']>;
};


export type QueryTitleCreditsArgs = {
  titleGuid?: InputMaybe<Scalars['String']>;
};


export type QueryTitleDirectorArgs = {
  titleGuid: Scalars['String'];
};


export type QueryTitleOptionsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTitlesArgs = {
  search?: InputMaybe<SearchTitlesInput>;
};


export type QueryTitlesInOriginalTitleArgs = {
  originalTitleGuid: Scalars['String'];
};


export type QueryTitlesPaginatedArgs = {
  filter?: InputMaybe<FilterTitlesInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchTitlesInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryTmdbCreditsArgs = {
  movieId: Scalars['Int'];
};


export type QueryTmdbInfoForTitleArgs = {
  titleGuid: Scalars['String'];
  tmdbId: Scalars['Int'];
};


export type QueryValidateTitleDeletionArgs = {
  titleGuid: Scalars['String'];
};

export type RightsAgreementDocument = {
  __typename?: 'RightsAgreementDocument';
  blobFileGuid: Scalars['String'];
  customer?: Maybe<Scalars['String']>;
  customerGuid?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  originalTitle?: Maybe<Scalars['String']>;
  originalTitleGuid?: Maybe<Scalars['String']>;
  rightsAgreementGuid: Scalars['String'];
};

export type SearchAdminComponentInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchContentAnalysisInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchCreditsInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchCustomerInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchItemCollectionInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchItemInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchOriginalTitlesInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchOriginsInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SearchTitlesInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type SelectItem = {
  __typename?: 'SelectItem';
  extraInfo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  num?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SelectItemInt = {
  __typename?: 'SelectItemInt';
  displayOrder?: Maybe<Scalars['Float']>;
  groupCode?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  title: Scalars['String'];
};

export type TmDbCreditResponse = {
  __typename?: 'TMDbCreditResponse';
  customerName: Scalars['String'];
  roleName: Scalars['String'];
};

export type TmDbInfoResponse = {
  __typename?: 'TMDbInfoResponse';
  id?: Maybe<Scalars['Int']>;
  overview?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  releaseDate?: Maybe<Scalars['String']>;
  runtime?: Maybe<Scalars['Int']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleGuid: Scalars['String'];
};

export type TmDbSearchResult = {
  __typename?: 'TMDbSearchResult';
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Tag = {
  __typename?: 'Tag';
  createdByName?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  informationResponse: InformationResponse;
  keyword: Scalars['String'];
  modifiedByName?: Maybe<Scalars['String']>;
  tagType: TagType;
};

export type TagInput = {
  isContentType: Scalars['Boolean'];
  isCustomerType: Scalars['Boolean'];
  isItemType?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
};

export type TagType = {
  __typename?: 'TagType';
  isContentType: Scalars['Boolean'];
  isCustomerType: Scalars['Boolean'];
  isItemType: Scalars['Boolean'];
};

export type TagsList = {
  __typename?: 'TagsList';
  items?: Maybe<Array<Tag>>;
  pageInfo: PageInfo;
};

export type TagsListAndGuids = {
  __typename?: 'TagsListAndGuids';
  list: TagsList;
  totalGuids: Array<Scalars['String']>;
};

export type Title = {
  __typename?: 'Title';
  guid: Scalars['String'];
  informationResponse: InformationResponse;
  originalTitleGuid: Scalars['String'];
  tagsGuid?: Maybe<Array<DropDownDto>>;
  titleDateCreated: Scalars['String'];
  titleJsonResponse: TitleJsonResponse;
  titleName: Scalars['String'];
  titleRequest: TitleJsonRequest;
};

export type TitleInput = {
  athugasemdir?: InputMaybe<Scalars['String']>;
  frumsyning?: InputMaybe<Scalars['String']>;
  kreditFullskradur?: InputMaybe<Scalars['Boolean']>;
  lengdEfnis?: InputMaybe<Scalars['String']>;
  originalTitleGuid?: InputMaybe<Scalars['String']>;
  stadsetningFrumsyningar?: InputMaybe<Scalars['String']>;
  tagsGuid?: InputMaybe<Array<Scalars['String']>>;
  titill: Scalars['String'];
  titleName: Scalars['String'];
  tungumal?: InputMaybe<Array<Scalars['JSONObject']>>;
  utgafuAr?: InputMaybe<Scalars['String']>;
};

export type TitleItemInfo = {
  __typename?: 'TitleItemInfo';
  hasContentAnalysis: Scalars['Boolean'];
  itemGuid: Scalars['String'];
  itemNumber: Scalars['String'];
  itemTypeName?: Maybe<Scalars['String']>;
  titleGuid: Scalars['String'];
  titleName: Scalars['String'];
};

export type TitleJsonRequest = {
  __typename?: 'TitleJsonRequest';
  athugasemdir?: Maybe<Scalars['String']>;
  frumsyning?: Maybe<Scalars['String']>;
  kreditFullskradur?: Maybe<Scalars['Boolean']>;
  lengdEfnis?: Maybe<Scalars['String']>;
  stadsetningFrumsyningar?: Maybe<Scalars['String']>;
  timabilEfnisFra?: Maybe<Scalars['String']>;
  timabilEfnisTil?: Maybe<Scalars['String']>;
  titill: Scalars['String'];
  tungumal?: Maybe<Array<Scalars['JSONObject']>>;
  utgafuAr?: Maybe<Scalars['String']>;
};

export type TitleJsonResponse = {
  __typename?: 'TitleJsonResponse';
  athugasemdir?: Maybe<Scalars['String']>;
  frumsyning?: Maybe<Scalars['String']>;
  kreditFullskradur?: Maybe<Scalars['Boolean']>;
  lengdEfnis?: Maybe<Scalars['String']>;
  stadsetningFrumsyningar?: Maybe<Scalars['String']>;
  timabilEfnisFra?: Maybe<Scalars['String']>;
  timabilEfnisTil?: Maybe<Scalars['String']>;
  titill: Scalars['String'];
  tungumal?: Maybe<Array<Scalars['JSONObject']>>;
  utgafuAr?: Maybe<Scalars['String']>;
};

export type TitleListAndGuids = {
  __typename?: 'TitleListAndGuids';
  list: TitlesList;
  totalGuids: Array<Scalars['String']>;
};

export type TitlesList = {
  __typename?: 'TitlesList';
  items?: Maybe<Array<Title>>;
  pageInfo: PageInfo;
};

export type UpdateColdLocationInput = {
  canRemoveLastColdLocation: Scalars['Boolean'];
  coldLocationsGuidToAdd: Array<Scalars['String']>;
  coldLocationsGuidToRemove: Array<Scalars['String']>;
};

export type UpdateItemsLocationInput = {
  canRemoveLastLocation: Scalars['Boolean'];
  locationsGuidToAdd: Array<Scalars['String']>;
  locationsGuidToRemove: Array<Scalars['String']>;
};

export type ConditionCheckFragmentsFragment = { __typename?: 'ConditionCheck', guid: string, itemGuid?: string | null, conditionCheckJsonResponse: { __typename?: 'ConditionCheckJsonRequest', dagsetning?: string | null, athugasemdir?: string | null, meginskemmdir?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, heildarastand?: { __typename?: 'SelectItemInt', id: number, title: string } | null, skodunarmadur?: { __typename?: 'Person', guid?: string | null, nafn?: string | null } | null } };

export type ConditionChecksQueryVariables = Exact<{ [key: string]: never; }>;


export type ConditionChecksQuery = { __typename?: 'Query', conditionCheck?: { __typename?: 'ConditionCheck', guid: string, itemGuid?: string | null, conditionCheckJsonResponse: { __typename?: 'ConditionCheckJsonRequest', dagsetning?: string | null, athugasemdir?: string | null, meginskemmdir?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, heildarastand?: { __typename?: 'SelectItemInt', id: number, title: string } | null, skodunarmadur?: { __typename?: 'Person', guid?: string | null, nafn?: string | null } | null } } | null };

export type ConditionCheckQueryVariables = Exact<{
  conditionCheckGuid?: InputMaybe<Scalars['String']>;
}>;


export type ConditionCheckQuery = { __typename?: 'Query', conditionCheck?: { __typename?: 'ConditionCheck', guid: string, itemGuid?: string | null, conditionCheckJsonResponse: { __typename?: 'ConditionCheckJsonRequest', dagsetning?: string | null, athugasemdir?: string | null, meginskemmdir?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, heildarastand?: { __typename?: 'SelectItemInt', id: number, title: string } | null, skodunarmadur?: { __typename?: 'Person', guid?: string | null, nafn?: string | null } | null } } | null };

export type CreateConditionCheckMutationVariables = Exact<{
  conditionCheck: ConditionCheckInput;
}>;


export type CreateConditionCheckMutation = { __typename?: 'Mutation', createConditionCheck: { __typename?: 'ConditionCheck', guid: string, itemGuid?: string | null, conditionCheckJsonResponse: { __typename?: 'ConditionCheckJsonRequest', dagsetning?: string | null, athugasemdir?: string | null, meginskemmdir?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, heildarastand?: { __typename?: 'SelectItemInt', id: number, title: string } | null, skodunarmadur?: { __typename?: 'Person', guid?: string | null, nafn?: string | null } | null } } };

export type UpdateConditionCheckMutationVariables = Exact<{
  conditionCheck: ConditionCheckInput;
  conditionCheckGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateConditionCheckMutation = { __typename?: 'Mutation', updateConditionCheck: { __typename?: 'ConditionCheck', guid: string, itemGuid?: string | null, conditionCheckJsonResponse: { __typename?: 'ConditionCheckJsonRequest', dagsetning?: string | null, athugasemdir?: string | null, meginskemmdir?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, heildarastand?: { __typename?: 'SelectItemInt', id: number, title: string } | null, skodunarmadur?: { __typename?: 'Person', guid?: string | null, nafn?: string | null } | null } } };

export type DeleteConditionCheckMutationVariables = Exact<{
  conditionCheckGuid: Scalars['String'];
}>;


export type DeleteConditionCheckMutation = { __typename?: 'Mutation', deleteConditionCheck?: string | null };

export type ItemConditionChecksQueryVariables = Exact<{
  itemGuid: Scalars['String'];
}>;


export type ItemConditionChecksQuery = { __typename?: 'Query', itemConditionCheck: Array<{ __typename?: 'ConditionCheck', guid: string, itemGuid?: string | null, conditionCheckJsonResponse: { __typename?: 'ConditionCheckJsonRequest', dagsetning?: string | null, athugasemdir?: string | null, meginskemmdir?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, heildarastand?: { __typename?: 'SelectItemInt', id: number, title: string } | null, skodunarmadur?: { __typename?: 'Person', guid?: string | null, nafn?: string | null } | null } }> };

export type ConditionCheckOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConditionCheckOptionsQuery = { __typename?: 'Query', conditionCheckDamageOptions: Array<{ __typename?: 'SelectItemInt', id: number, title: string }>, conditionCheckStateOptions: Array<{ __typename?: 'SelectItemInt', id: number, title: string }>, conditionCheckInspectorOptions: Array<{ __typename?: 'SelectItem', id: string, title: string }> };

export type ContentAnalysisFragmentsFragment = { __typename?: 'ContentAnalysis', guid: string, itemGuid?: string | null, itemNumber?: string | null, titleGuid?: string | null, titleName?: string | null, contentAnalysisJsonResponse: { __typename?: 'ContentAnalysisJsonResponse', efnislysing?: string | null, tcFra?: string | null, tcTil?: string | null, samtalsTimi?: string | null, tagsGuid?: Array<any> | null, year?: string | null, yearTo?: string | null } };

export type ContentAnalysesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentAnalysesQuery = { __typename?: 'Query', contentAnalyses?: Array<{ __typename?: 'ContentAnalysis', guid: string, itemGuid?: string | null, itemNumber?: string | null, titleGuid?: string | null, titleName?: string | null, contentAnalysisJsonResponse: { __typename?: 'ContentAnalysisJsonResponse', efnislysing?: string | null, tcFra?: string | null, tcTil?: string | null, samtalsTimi?: string | null, tagsGuid?: Array<any> | null, year?: string | null, yearTo?: string | null } }> | null };

export type ContentAnalysisQueryVariables = Exact<{
  contentAnalysisGuid?: InputMaybe<Scalars['String']>;
}>;


export type ContentAnalysisQuery = { __typename?: 'Query', contentAnalysis?: { __typename?: 'ContentAnalysis', guid: string, itemGuid?: string | null, itemNumber?: string | null, titleGuid?: string | null, titleName?: string | null, contentAnalysisJsonResponse: { __typename?: 'ContentAnalysisJsonResponse', efnislysing?: string | null, tcFra?: string | null, tcTil?: string | null, samtalsTimi?: string | null, tagsGuid?: Array<any> | null, year?: string | null, yearTo?: string | null } } | null };

export type CreateContentAnalysisMutationVariables = Exact<{
  contentAnalysis: ContentAnalysisInput;
}>;


export type CreateContentAnalysisMutation = { __typename?: 'Mutation', createContentAnalysis: { __typename?: 'ContentAnalysis', guid: string, itemGuid?: string | null, itemNumber?: string | null, titleGuid?: string | null, titleName?: string | null, contentAnalysisJsonResponse: { __typename?: 'ContentAnalysisJsonResponse', efnislysing?: string | null, tcFra?: string | null, tcTil?: string | null, samtalsTimi?: string | null, tagsGuid?: Array<any> | null, year?: string | null, yearTo?: string | null } } };

export type UpdateContentAnalysisMutationVariables = Exact<{
  contentAnalysis: ContentAnalysisInput;
  contentAnalysisGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateContentAnalysisMutation = { __typename?: 'Mutation', updateContentAnalysis: { __typename?: 'ContentAnalysis', guid: string, itemGuid?: string | null, itemNumber?: string | null, titleGuid?: string | null, titleName?: string | null, contentAnalysisJsonResponse: { __typename?: 'ContentAnalysisJsonResponse', efnislysing?: string | null, tcFra?: string | null, tcTil?: string | null, samtalsTimi?: string | null, tagsGuid?: Array<any> | null, year?: string | null, yearTo?: string | null } } };

export type DeleteContentAnalysisMutationVariables = Exact<{
  contentAnalysisGuid: Scalars['String'];
}>;


export type DeleteContentAnalysisMutation = { __typename?: 'Mutation', deleteContentAnalysis?: string | null };

export type ItemContentAnalysesQueryVariables = Exact<{
  itemGuid: Scalars['String'];
}>;


export type ItemContentAnalysesQuery = { __typename?: 'Query', itemContentAnalyses: Array<{ __typename?: 'ContentAnalysis', guid: string, itemGuid?: string | null, itemNumber?: string | null, titleGuid?: string | null, titleName?: string | null, contentAnalysisJsonResponse: { __typename?: 'ContentAnalysisJsonResponse', efnislysing?: string | null, tcFra?: string | null, tcTil?: string | null, samtalsTimi?: string | null, tagsGuid?: Array<any> | null, year?: string | null, yearTo?: string | null } }> };

export type ContentAnalysisPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchContentAnalysisInput>;
  filter?: InputMaybe<FilterContentAnalysisInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type ContentAnalysisPaginatedQuery = { __typename?: 'Query', contentAnalysisPaginated?: { __typename?: 'ContentAnalysisListAndGuids', totalGuids: Array<string>, list: { __typename?: 'ContentAnalysisList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'ContentAnalysis', guid: string, itemGuid?: string | null, itemNumber?: string | null, titleGuid?: string | null, titleName?: string | null, contentAnalysisJsonResponse: { __typename?: 'ContentAnalysisJsonResponse', efnislysing?: string | null, tcFra?: string | null, tcTil?: string | null, samtalsTimi?: string | null, tagsGuid?: Array<any> | null, year?: string | null, yearTo?: string | null } }> | null } } | null };

export type ContentAnalysisTagsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentAnalysisTagsOptionsQuery = { __typename?: 'Query', contentAnalysisTagsOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type CreditFragmentsFragment = { __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null };

export type CreditsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditsQuery = { __typename?: 'Query', credits?: Array<{ __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type CreditQueryVariables = Exact<{
  creditGuid?: InputMaybe<Scalars['String']>;
  titleGuid?: InputMaybe<Scalars['String']>;
}>;


export type CreditQuery = { __typename?: 'Query', credit?: { __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } | null, customerOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, creditOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, title?: { __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } | null };

export type CreditsPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchCreditsInput>;
  filter?: InputMaybe<FilterCreditsInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type CreditsPaginatedQuery = { __typename?: 'Query', creditsPaginated?: { __typename?: 'CreditListAndGuids', totalGuids: Array<string>, list: { __typename?: 'CreditsList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null } } | null };

export type CreditOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditOptionsQuery = { __typename?: 'Query', creditOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, titleOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type CreateCreditMutationVariables = Exact<{
  credit: CreditInput;
}>;


export type CreateCreditMutation = { __typename?: 'Mutation', createCredit: Array<{ __typename?: 'Credit', guid: string }> };

export type UpdateCreditMutationVariables = Exact<{
  credit: CreditInput;
  creditGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCreditMutation = { __typename?: 'Mutation', updateCredit: { __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type DeleteCreditMutationVariables = Exact<{
  creditGuid: Scalars['String'];
}>;


export type DeleteCreditMutation = { __typename?: 'Mutation', deleteCredit?: string | null };

export type CreateCreditsForTitleMutationVariables = Exact<{
  creditRequests: Array<CreditForTitleInput> | CreditForTitleInput;
}>;


export type CreateCreditsForTitleMutation = { __typename?: 'Mutation', createCreditsForTitle: boolean };

export type KmiCreditsQueryVariables = Exact<{
  movieId: Scalars['String'];
}>;


export type KmiCreditsQuery = { __typename?: 'Query', kmiCredits?: Array<{ __typename?: 'KMICreditResponse', customerName: string, dropdownItemName: string }> | null };

export type CustomerFragmentsFragment = { __typename?: 'Customer', guid: string, name: string, ssn?: string | null, address?: string | null, postalCode?: string | null, email?: string | null, phoneNumber?: string | null, comment?: string | null, deceased?: boolean | null, active: boolean, identity?: string | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null };

export type CustomersQueryVariables = Exact<{
  search?: InputMaybe<SearchCustomerInput>;
}>;


export type CustomersQuery = { __typename?: 'Query', customers?: Array<{ __typename?: 'Customer', guid: string, name: string, ssn?: string | null, address?: string | null, postalCode?: string | null, email?: string | null, phoneNumber?: string | null, comment?: string | null, deceased?: boolean | null, active: boolean, identity?: string | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type CustomerQueryVariables = Exact<{
  customerGuid?: InputMaybe<Scalars['String']>;
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', guid: string, name: string, ssn?: string | null, address?: string | null, postalCode?: string | null, email?: string | null, phoneNumber?: string | null, comment?: string | null, deceased?: boolean | null, active: boolean, identity?: string | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } | null, customerCredits: Array<{ __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }>, customerContacts?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, customerTags?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, customerCreditItems?: Array<{ __typename?: 'CreditItem', creditGuid?: string | null, creditName?: string | null, customerName?: string | null, customerGuid?: string | null, titleName?: string | null, titleGuid?: string | null, itemNumber?: string | null, itemGuid?: string | null }> | null };

export type CustomersPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchCustomerInput>;
  filter?: InputMaybe<FilterCustomersInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type CustomersPaginatedQuery = { __typename?: 'Query', customersPaginated?: { __typename?: 'CustomerListAndGuids', totalGuids: Array<string>, list: { __typename?: 'CustomersList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'Customer', guid: string, name: string, ssn?: string | null, address?: string | null, postalCode?: string | null, email?: string | null, phoneNumber?: string | null, comment?: string | null, deceased?: boolean | null, active: boolean, identity?: string | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null } } | null };

export type CreateCustomerMutationVariables = Exact<{
  customer: CustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'Customer', guid: string, name: string, ssn?: string | null, address?: string | null, postalCode?: string | null, email?: string | null, phoneNumber?: string | null, comment?: string | null, deceased?: boolean | null, active: boolean, identity?: string | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type UpdateCustomerMutationVariables = Exact<{
  customer: CustomerInput;
  customerGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', guid: string, name: string, ssn?: string | null, address?: string | null, postalCode?: string | null, email?: string | null, phoneNumber?: string | null, comment?: string | null, deceased?: boolean | null, active: boolean, identity?: string | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type MergeCustomersMutationVariables = Exact<{
  mergeCustomerData: MergeCustomerInput;
}>;


export type MergeCustomersMutation = { __typename?: 'Mutation', mergeCustomers: boolean };

export type CustomerAutocompleteOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type CustomerAutocompleteOptionsQuery = { __typename?: 'Query', customerOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type CustomersOptionsQueryVariables = Exact<{
  customerGuids: Array<Scalars['String']> | Scalars['String'];
}>;


export type CustomersOptionsQuery = { __typename?: 'Query', customersOptions: Array<{ __typename?: 'SelectItem', id: string, title: string }> };

export type CustomerOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerOptionsQuery = { __typename?: 'Query', customerOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type UserOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOptionsQuery = { __typename?: 'Query', userOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type AllUserOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserOptionsQuery = { __typename?: 'Query', allUserOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type CustomerAndTagOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerAndTagOptionsQuery = { __typename?: 'Query', customerOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, customerTagsOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type CheckIfNameExistsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type CheckIfNameExistsQuery = { __typename?: 'Query', checkIfNameExists: number };

export type DeleteCustomerMutationVariables = Exact<{
  customerGuid: Scalars['String'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer?: string | null };

export type DashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardQuery = { __typename?: 'Query', origins?: Array<{ __typename?: 'Origin', guid: string, originTypeGuid: string, originNumber: string, originName?: string | null, originDate: string, originJsonResponse: { __typename?: 'OriginJsonResponse', heiti: string, lysing?: string | null, dagsetning: string, tengilidir?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null, mottakendur?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null, itemCollections?: Array<{ __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type FormFragmentsFragment = { __typename?: 'Form', guid: string, name: string, metadata: Array<any>, dropDownTypeItemResponse?: Array<{ __typename?: 'DropDownTypeItem', id: number, code: string, name: string, description: string, dropDownItemResponse: Array<{ __typename?: 'DropDownItem', id: number, value: string }> }> | null };

export type FormForItemTypeQueryVariables = Exact<{
  itemTypeGuid: Scalars['String'];
}>;


export type FormForItemTypeQuery = { __typename?: 'Query', formForItemType: { __typename?: 'Form', guid: string, name: string, metadata: Array<any>, dropDownTypeItemResponse?: Array<{ __typename?: 'DropDownTypeItem', id: number, code: string, name: string, description: string, dropDownItemResponse: Array<{ __typename?: 'DropDownItem', id: number, value: string }> }> | null } };

export type FormsForMuseumQueryVariables = Exact<{ [key: string]: never; }>;


export type FormsForMuseumQuery = { __typename?: 'Query', formsForMuseum: Array<{ __typename?: 'Form', guid: string, name: string, code?: string | null }> };

export type ItemFragmentsFragment = { __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null };

export type ItemsQueryVariables = Exact<{
  search?: InputMaybe<SearchItemInput>;
}>;


export type ItemsQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type ItemQueryVariables = Exact<{
  itemGuid?: InputMaybe<Scalars['String']>;
}>;


export type ItemQuery = { __typename?: 'Query', item?: { __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } | null };

export type ItemsPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchItemInput>;
  filter?: InputMaybe<FilterItemInput>;
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type ItemsPaginatedQuery = { __typename?: 'Query', itemsPaginated?: { __typename?: 'ItemListAndGuids', totalGuids: Array<string>, list: { __typename?: 'ItemsList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null } } | null };

export type SortedItemsGuidsQueryVariables = Exact<{
  selectedGuids: Array<Scalars['String']> | Scalars['String'];
  sort: Scalars['String'];
  sortBy: Scalars['String'];
}>;


export type SortedItemsGuidsQuery = { __typename?: 'Query', sortedItemsGuids: Array<string> };

export type DeleteItemMutationVariables = Exact<{
  itemGuid: Scalars['String'];
}>;


export type DeleteItemMutation = { __typename?: 'Mutation', deleteItem?: string | null };

export type DeleteManyItemsMutationVariables = Exact<{
  itemGuids: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteManyItemsMutation = { __typename?: 'Mutation', deleteManyItems?: string | null };

export type DiscLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscLocationsQuery = { __typename?: 'Query', discLocationOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type ItemDropDownOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemDropDownOptionsQuery = { __typename?: 'Query', subtypeOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, originOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, itemCollectionsOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type ConnectedItemsQueryVariables = Exact<{
  itemGuid: Scalars['String'];
}>;


export type ConnectedItemsQuery = { __typename?: 'Query', getConnectedItems: Array<{ __typename?: 'ConnectedItem', itemGuid: string, itemInfoResponse: Array<{ __typename?: 'ItemInfo', guid: string, itemTypeGuid: string, itemNumber: string, isItemCopyOfConnectedItem: boolean, hasContentAnalysis: boolean }> }> };

export type CreateConnectedItemsMutationVariables = Exact<{
  connectedItems: ConnectedItemsInput;
}>;


export type CreateConnectedItemsMutation = { __typename?: 'Mutation', createConnectedItem: { __typename?: 'ConnectedItem', itemGuid: string, connectedItems?: Array<string> | null } };

export type DeleteConnectedItemMutationVariables = Exact<{
  itemGuid: Scalars['String'];
  connectedItemGuid: Scalars['String'];
}>;


export type DeleteConnectedItemMutation = { __typename?: 'Mutation', deleteConnectedItem?: string | null };

export type CreateCopyItemsMutationVariables = Exact<{
  copyItems: CopyItemsInput;
}>;


export type CreateCopyItemsMutation = { __typename?: 'Mutation', createCopyItems: Array<{ __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> };

export type ItemsInCollectionQueryVariables = Exact<{
  itemCollectionGuid: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ItemsInCollectionQuery = { __typename?: 'Query', itemsInCollection: Array<{ __typename?: 'ItemInfo', guid: string, title?: string | null, heiti?: string | null, itemTypeGuid: string, itemTypeName?: string | null, itemNumber: string, isItemCopyOfConnectedItem: boolean, coldLocationsName?: Array<string> | null, locationsName?: Array<string> | null, stadaSkraningar: boolean, tungumalName?: Array<string> | null, itemJson: any }> };

export type ItemCountFromCollectionQueryVariables = Exact<{
  itemCollectionGuid: Scalars['String'];
}>;


export type ItemCountFromCollectionQuery = { __typename?: 'Query', itemCountFromCollection: number };

export type ItemsInTitleQueryVariables = Exact<{
  titleGuid: Scalars['String'];
}>;


export type ItemsInTitleQuery = { __typename?: 'Query', itemsInTitle: Array<{ __typename?: 'ItemInfo', guid: string, title?: string | null, heiti?: string | null, itemTypeGuid: string, itemTypeName?: string | null, itemNumber: string, isItemCopyOfConnectedItem: boolean, hasContentAnalysis: boolean }> };

export type ItemsInOriginalTitleQueryVariables = Exact<{
  originalTitleGuid: Scalars['String'];
}>;


export type ItemsInOriginalTitleQuery = { __typename?: 'Query', itemsInOriginalTitle: Array<{ __typename?: 'TitleItemInfo', itemGuid: string, itemNumber: string, itemTypeName?: string | null, titleGuid: string, titleName: string, hasContentAnalysis: boolean }> };

export type OriginForItemCollectionOptionQueryVariables = Exact<{
  itemCollectionGuid: Scalars['String'];
}>;


export type OriginForItemCollectionOptionQuery = { __typename?: 'Query', originForItemCollectionOption: Array<{ __typename?: 'SelectItem', id: string, title: string }> };

export type AutoCompleteOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AutoCompleteOptionsQuery = { __typename?: 'Query', originNumberOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, itemCollectionNumberOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, itemNumberOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type BreadcrumbInfoQueryVariables = Exact<{
  itemCollectionGuid: Scalars['String'];
}>;


export type BreadcrumbInfoQuery = { __typename?: 'Query', getCollectionAndOriginNumber: { __typename?: 'BreadcrumbInfo', originGuid: string, originNumber: string, originName?: string | null, itemCollectionNumber: string, itemCollectionName: string } };

export type CreateItemMutationVariables = Exact<{
  item: ItemInput;
}>;


export type CreateItemMutation = { __typename?: 'Mutation', createItem: { __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type UpdateItemMutationVariables = Exact<{
  item: ItemInput;
  itemGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateItemMutation = { __typename?: 'Mutation', updateItem: { __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type ItemTypesForItemCollectionTypeQueryVariables = Exact<{
  itemCollectionGuid?: InputMaybe<Scalars['String']>;
}>;


export type ItemTypesForItemCollectionTypeQuery = { __typename?: 'Query', itemTypesForItemCollectionType?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type CreateManyItemsMutationVariables = Exact<{
  itemCount: Scalars['Int'];
  itemCollectionGuid: Scalars['String'];
  itemTypeGuid?: InputMaybe<Scalars['String']>;
  titleGuid?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationsGuidInput>;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type CreateManyItemsMutation = { __typename?: 'Mutation', createManyItems: Array<{ __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> };

export type UpdateItemsRegistrationMutationVariables = Exact<{
  itemCollectionGuid: Scalars['String'];
  state: Scalars['Boolean'];
}>;


export type UpdateItemsRegistrationMutation = { __typename?: 'Mutation', updateItemsRegistration: Array<{ __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> };

export type StickerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type StickerTypesQuery = { __typename?: 'Query', stickerTypes?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type ItemsWithItemTypeQueryVariables = Exact<{
  itemTypeGuid: Scalars['String'];
}>;


export type ItemsWithItemTypeQuery = { __typename?: 'Query', itemsWithItemType: number };

export type ItemLocationsQueryVariables = Exact<{
  itemGuid: Scalars['String'];
}>;


export type ItemLocationsQuery = { __typename?: 'Query', getItemLocations: Array<{ __typename?: 'LocationItem', itemGuid: string, itemName: string, itemNumber: string, itemType: string }> };

export type ItemLocationHistoryQueryVariables = Exact<{
  itemGuid: Scalars['String'];
}>;


export type ItemLocationHistoryQuery = { __typename?: 'Query', getItemLocationHistory: Array<{ __typename?: 'ItemLocationHistory', guid: string, itemGuid: string, locationGuid: string, itemLocationGuid: string, dateFrom: string, dateTo?: string | null, locationName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> };

export type AddItemLocationToItemsMutationVariables = Exact<{
  itemLocations: ItemLocationsInput;
}>;


export type AddItemLocationToItemsMutation = { __typename?: 'Mutation', addItemLocationToItems: Array<{ __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> };

export type UpdateItemsLocationMutationVariables = Exact<{
  itemGuids: Array<Scalars['String']> | Scalars['String'];
  updateItemsLocationInput: UpdateItemsLocationInput;
  updateColdLocationInput: UpdateColdLocationInput;
}>;


export type UpdateItemsLocationMutation = { __typename?: 'Mutation', updateItemsLocation: Array<{ __typename?: 'Item', guid: string, itemCollectionGuid: string, itemNumber: string, itemTypeGuid: string, itemTypeName?: string | null, originNumber?: string | null, itemCollectionNumber?: string | null, originGuid: string, originYear?: string | null, formCode?: string | null, formName?: string | null, title?: string | null, itemName?: string | null, itemDateCreated?: string | null, json: any, isItemTypeLocation?: boolean | null, languagesNames?: Array<string> | null, subtitlesNames?: Array<string> | null, coldLocationsNames?: Array<string> | null, locationsNames?: Array<string> | null, upprunalegirEigendurNames?: Array<string> | null, breiddName?: string | null, informationResponse?: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> };

export type DeleteItemLocationFromItemMutationVariables = Exact<{
  itemGuid: Scalars['String'];
  itemLocationGuid: Scalars['String'];
}>;


export type DeleteItemLocationFromItemMutation = { __typename?: 'Mutation', deleteItemLocationFromItem?: string | null };

export type SelectedItemsOptionsQueryVariables = Exact<{
  itemGuids: Array<Scalars['String']> | Scalars['String'];
}>;


export type SelectedItemsOptionsQuery = { __typename?: 'Query', selectedItemsOptions: Array<{ __typename?: 'SelectItem', id: string, title: string }> };

export type SelectedGuidsAsSelectItemsQueryVariables = Exact<{
  selectedGuids: Array<Scalars['String']> | Scalars['String'];
  source: Scalars['String'];
}>;


export type SelectedGuidsAsSelectItemsQuery = { __typename?: 'Query', selectedGuidsAsSelectItems?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type ItemStatisticsByCollectionTypeQueryVariables = Exact<{
  collectionTypeGuids: Array<Scalars['String']> | Scalars['String'];
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  skraninguLokid?: InputMaybe<Scalars['String']>;
}>;


export type ItemStatisticsByCollectionTypeQuery = { __typename?: 'Query', itemStatisticsByCollectionType: { __typename?: 'ItemStatisticsByYear', year: number, dateFrom: string, dateTo: string, statistics: Array<{ __typename?: 'ItemCollectionTypeStatistic', collectionTypeCode: string, collectionTypeName: string, itemCount: number }> } };

export type ItemCollectionFragmentsFragment = { __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null };

export type ItemCollectionsQueryVariables = Exact<{
  search?: InputMaybe<SearchItemCollectionInput>;
}>;


export type ItemCollectionsQuery = { __typename?: 'Query', itemCollections?: Array<{ __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type ItemCollectionQueryVariables = Exact<{
  itemCollectionGuid?: InputMaybe<Scalars['String']>;
  dropDownItemId?: InputMaybe<Scalars['Float']>;
}>;


export type ItemCollectionQuery = { __typename?: 'Query', itemCollection?: { __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } | null, getCollectionTypesList?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, getDeliveryConditions: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> };

export type DeliveryConditionsQueryVariables = Exact<{
  dropDownItemId?: InputMaybe<Scalars['Float']>;
}>;


export type DeliveryConditionsQuery = { __typename?: 'Query', getDeliveryConditions: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> };

export type ItemCollectionsForOriginOptionsQueryVariables = Exact<{
  originGuid: Scalars['String'];
}>;


export type ItemCollectionsForOriginOptionsQuery = { __typename?: 'Query', itemCollectionsForOriginOptions: Array<{ __typename?: 'SelectItem', id: string, title: string, num?: string | null }> };

export type ItemCollectionsPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchItemCollectionInput>;
  filter?: InputMaybe<FilterItemCollectionInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type ItemCollectionsPaginatedQuery = { __typename?: 'Query', itemCollectionsPaginated?: { __typename?: 'ItemCollectionListAndGuids', totalGuids: Array<string>, list: { __typename?: 'ItemCollectionsList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null } } | null };

export type ItemCollectionNumberOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type ItemCollectionNumberOptionsQuery = { __typename?: 'Query', itemCollectionNumberOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type ItemCollectionOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemCollectionOptionsQuery = { __typename?: 'Query', getCollectionTypesList?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, getDeliveryConditions: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> };

export type ItemCollectionsInOriginQueryVariables = Exact<{
  originGuid: Scalars['String'];
}>;


export type ItemCollectionsInOriginQuery = { __typename?: 'Query', itemCollectionsInOrigin: Array<{ __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> };

export type CreateItemCollectionMutationVariables = Exact<{
  itemCollection: ItemCollectionInput;
}>;


export type CreateItemCollectionMutation = { __typename?: 'Mutation', createItemCollection: { __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type UpdateItemCollectionMutationVariables = Exact<{
  itemCollection: ItemCollectionInput;
  itemCollectionGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateItemCollectionMutation = { __typename?: 'Mutation', updateItemCollection: { __typename?: 'ItemCollection', guid: string, originGuid: string, originNumber: string, originName?: string | null, originYear?: string | null, itemCollectionNumber: string, itemCollectionTypeGuid: string, itemCount?: number | null, itemCollectionName?: string | null, itemCollectionTypeCode?: string | null, itemCollectionDateCreated: string, itemCollectionJsonResponse: { __typename?: 'ItemCollectionJsonResponse', tegund?: string | null, heiti: string, afhendingarskilyrdiId?: number | null, afhendingarskilyrdi?: string | null, lysing?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type DeleteItemCollectionMutationVariables = Exact<{
  itemCollectionGuid: Scalars['String'];
}>;


export type DeleteItemCollectionMutation = { __typename?: 'Mutation', deleteItemCollection?: string | null };

export type ItemCollectionTypesListQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemCollectionTypesListQuery = { __typename?: 'Query', getCollectionTypesList?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type ImportItemsToItemCollectionMutationVariables = Exact<{
  itemCollectionGuid: Scalars['String'];
  formTypeEnum: Scalars['String'];
  excelImportGuid: Scalars['String'];
}>;


export type ImportItemsToItemCollectionMutation = { __typename?: 'Mutation', importItemsToItemCollection?: boolean | null };

export type ReindexImportResultMutationVariables = Exact<{
  importResultJson: Scalars['String'];
}>;


export type ReindexImportResultMutation = { __typename?: 'Mutation', reindexImportResult?: boolean | null };

export type ItemCollectionFormTypeCodeQueryVariables = Exact<{
  itemCollectionTypeGuid: Scalars['String'];
}>;


export type ItemCollectionFormTypeCodeQuery = { __typename?: 'Query', itemCollectionFormTypeCode: string };

export type ItemCollectionTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemCollectionTypeQuery = { __typename?: 'Query', getCollectionTypes?: Array<{ __typename?: 'ItemCollectionType', id: number, code: string, name: string }> | null, getCollectionTypesList?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type ItemCollectionTypeDetailFragmentsFragment = { __typename?: 'ItemCollectionTypeDetail', guid: string, name: string, active: boolean, code: string, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } };

export type ItemCollectionTypeDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemCollectionTypeDetailsQuery = { __typename?: 'Query', itemCollectionTypeDetails?: { __typename?: 'ItemCollectionTypeDetailListAndGuids', totalGuids: Array<string>, list: { __typename?: 'ItemCollectionTypeDetailList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'ItemCollectionTypeDetail', guid: string, name: string, active: boolean, code: string, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null } } | null };

export type ItemCollectionTypeDetailsPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchAdminComponentInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type ItemCollectionTypeDetailsPaginatedQuery = { __typename?: 'Query', itemCollectionTypeDetailsPaginated?: { __typename?: 'ItemCollectionTypeDetailListAndGuids', totalGuids: Array<string>, list: { __typename?: 'ItemCollectionTypeDetailList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'ItemCollectionTypeDetail', guid: string, name: string, active: boolean, code: string, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null } } | null };

export type ItemCollectionTypeDetailQueryVariables = Exact<{
  itemCollectionTypeDetailGuid?: InputMaybe<Scalars['String']>;
}>;


export type ItemCollectionTypeDetailQuery = { __typename?: 'Query', itemCollectionTypeDetail?: { __typename?: 'ItemCollectionTypeDetail', guid: string, name: string, active: boolean, code: string, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } | null };

export type UpdateItemCollectionTypeMutationVariables = Exact<{
  itemCollectionType: ItemCollectionTypeInput;
  itemCollectionTypeGuid: Scalars['String'];
}>;


export type UpdateItemCollectionTypeMutation = { __typename?: 'Mutation', updateItemCollectionType: { __typename?: 'ItemCollectionTypeDetail', guid: string, name: string, active: boolean, code: string, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type CreateItemCollectionTypeMutationVariables = Exact<{
  itemCollectionType: ItemCollectionTypeInput;
  originTypeGuid: Scalars['String'];
}>;


export type CreateItemCollectionTypeMutation = { __typename?: 'Mutation', createItemCollectionType: { __typename?: 'ItemCollectionTypeDetail', guid: string, name: string, active: boolean, code: string, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type DeleteItemCollectionTypeMutationVariables = Exact<{
  itemCollectionTypeGuid: Scalars['String'];
}>;


export type DeleteItemCollectionTypeMutation = { __typename?: 'Mutation', deleteItemCollectionType?: string | null };

export type ItemTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemTypesQuery = { __typename?: 'Query', itemTypes?: Array<{ __typename?: 'ItemType', guid: string, code?: string | null, name: string }> | null };

export type ItemTypeQueryVariables = Exact<{
  itemTypeGuid?: InputMaybe<Scalars['String']>;
}>;


export type ItemTypeQuery = { __typename?: 'Query', itemType?: { __typename?: 'ItemType', guid: string, name: string, visible?: boolean | null } | null };

export type AllItemTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllItemTypeOptionsQuery = { __typename?: 'Query', allItemTypeOptions: Array<{ __typename?: 'SelectItem', id: string, title: string }> };

export type ItemFilterOptionsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type ItemFilterOptionsQuery = { __typename?: 'Query', itemTypeOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, languageOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, breiddOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null };

export type ItemTypeDetailFragmentsFragment = { __typename?: 'ItemTypeDetail', guid: string, formGuid: string, name: string, active: boolean, visible: boolean, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } };

export type ItemTypeDetailQueryVariables = Exact<{
  itemTypeDetailGuid?: InputMaybe<Scalars['String']>;
}>;


export type ItemTypeDetailQuery = { __typename?: 'Query', itemTypeDetail?: { __typename?: 'ItemTypeDetail', guid: string, formGuid: string, name: string, active: boolean, visible: boolean, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } | null };

export type ItemTypeDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemTypeDetailsQuery = { __typename?: 'Query', itemTypeDetails?: { __typename?: 'ItemTypeDetailListAndGuids', totalGuids: Array<string>, list: { __typename?: 'ItemTypeDetailList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'ItemTypeDetail', guid: string, formGuid: string, name: string, active: boolean, visible: boolean, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null } } | null };

export type ItemTypeDetailsPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchAdminComponentInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type ItemTypeDetailsPaginatedQuery = { __typename?: 'Query', itemTypeDetailsPaginated?: { __typename?: 'ItemTypeDetailListAndGuids', totalGuids: Array<string>, list: { __typename?: 'ItemTypeDetailList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'ItemTypeDetail', guid: string, formGuid: string, name: string, active: boolean, visible: boolean, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null } } | null };

export type UpdateItemTypeMutationVariables = Exact<{
  itemType: ItemTypeInput;
  itemTypeGuid: Scalars['String'];
}>;


export type UpdateItemTypeMutation = { __typename?: 'Mutation', updateItemType: { __typename?: 'ItemTypeDetail', guid: string, formGuid: string, name: string, active: boolean, visible: boolean, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type CreateItemTypeMutationVariables = Exact<{
  itemType: ItemTypeInput;
  formGuid: Scalars['String'];
  itemCollectionTypeGuid: Scalars['String'];
}>;


export type CreateItemTypeMutation = { __typename?: 'Mutation', createItemType: { __typename?: 'ItemTypeDetail', guid: string, formGuid: string, name: string, active: boolean, visible: boolean, createdByName?: string | null, modifiedByName?: string | null, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type DeleteItemTypeMutationVariables = Exact<{
  itemTypeGuid: Scalars['String'];
}>;


export type DeleteItemTypeMutation = { __typename?: 'Mutation', deleteItemType?: string | null };

export type LocationFragmentsFragment = { __typename?: 'Location', guid: string, name: string };

export type LocationsQueryVariables = Exact<{
  locationGuid?: InputMaybe<Scalars['String']>;
}>;


export type LocationsQuery = { __typename?: 'Query', location?: { __typename?: 'Location', guid: string, name: string } | null };

export type CreateLocationMutationVariables = Exact<{
  location: LocationInput;
  itemTypeGuid: Scalars['String'];
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'Location', guid: string, name: string } };

export type LocationOptionsQueryVariables = Exact<{
  itemTypeGuid: Scalars['String'];
}>;


export type LocationOptionsQuery = { __typename?: 'Query', locationOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type LocationsForMuseumQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsForMuseumQuery = { __typename?: 'Query', locationsForMuseum: Array<{ __typename?: 'Location', guid: string, name: string }> };

export type LocationOptionsByFormQueryVariables = Exact<{
  formCode?: InputMaybe<Scalars['String']>;
}>;


export type LocationOptionsByFormQuery = { __typename?: 'Query', locationOptionsByForm: Array<{ __typename?: 'SelectItem', id: string, title: string }>, coldLocationOptionsByForm: Array<{ __typename?: 'SelectItem', id: string, title: string }> };

export type ColdLocationOptionsQueryVariables = Exact<{
  itemTypeGuid: Scalars['String'];
}>;


export type ColdLocationOptionsQuery = { __typename?: 'Query', coldLocationOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type OriginFragmentsFragment = { __typename?: 'Origin', guid: string, originTypeGuid: string, originNumber: string, originName?: string | null, originDate: string, originJsonResponse: { __typename?: 'OriginJsonResponse', heiti: string, lysing?: string | null, dagsetning: string, tengilidir?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null, mottakendur?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null };

export type OriginsQueryVariables = Exact<{
  search?: InputMaybe<SearchOriginsInput>;
}>;


export type OriginsQuery = { __typename?: 'Query', origins?: Array<{ __typename?: 'Origin', guid: string, originTypeGuid: string, originNumber: string, originName?: string | null, originDate: string, originJsonResponse: { __typename?: 'OriginJsonResponse', heiti: string, lysing?: string | null, dagsetning: string, tengilidir?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null, mottakendur?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type OriginQueryVariables = Exact<{
  originGuid?: InputMaybe<Scalars['String']>;
}>;


export type OriginQuery = { __typename?: 'Query', origin?: { __typename?: 'Origin', guid: string, originTypeGuid: string, originNumber: string, originName?: string | null, originDate: string, originJsonResponse: { __typename?: 'OriginJsonResponse', heiti: string, lysing?: string | null, dagsetning: string, tengilidir?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null, mottakendur?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } | null, customerOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, userOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, originTypeOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type OriginsPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchOriginsInput>;
  filter?: InputMaybe<FilterOriginsInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type OriginsPaginatedQuery = { __typename?: 'Query', originsPaginated?: { __typename?: 'OriginListAndGuids', totalGuids: Array<string>, list: { __typename?: 'OriginsList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'Origin', guid: string, originTypeGuid: string, originNumber: string, originName?: string | null, originDate: string, originJsonResponse: { __typename?: 'OriginJsonResponse', heiti: string, lysing?: string | null, dagsetning: string, tengilidir?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null, mottakendur?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null } } | null };

export type OriginCreateOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginCreateOptionsQuery = { __typename?: 'Query', customerOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, userOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null, originTypeOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type OriginOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginOptionsQuery = { __typename?: 'Query', originOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type OriginNumberAutoCompleteOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type OriginNumberAutoCompleteOptionsQuery = { __typename?: 'Query', originNumberOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type CreateOriginMutationVariables = Exact<{
  origin: OriginInput;
}>;


export type CreateOriginMutation = { __typename?: 'Mutation', createOrigin: { __typename?: 'Origin', guid: string, originTypeGuid: string, originNumber: string, originName?: string | null, originDate: string, originJsonResponse: { __typename?: 'OriginJsonResponse', heiti: string, lysing?: string | null, dagsetning: string, tengilidir?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null, mottakendur?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type UpdateOriginMutationVariables = Exact<{
  origin: OriginInput;
  originGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOriginMutation = { __typename?: 'Mutation', updateOrigin: { __typename?: 'Origin', guid: string, originTypeGuid: string, originNumber: string, originName?: string | null, originDate: string, originJsonResponse: { __typename?: 'OriginJsonResponse', heiti: string, lysing?: string | null, dagsetning: string, tengilidir?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null, mottakendur?: Array<{ __typename?: 'Person', guid?: string | null, nafn?: string | null }> | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type DeleteOriginMutationVariables = Exact<{
  originGuid: Scalars['String'];
}>;


export type DeleteOriginMutation = { __typename?: 'Mutation', deleteOrigin?: string | null };

export type OriginNumberQueryVariables = Exact<{
  originGuid: Scalars['String'];
}>;


export type OriginNumberQuery = { __typename?: 'Query', originNumber: string };

export type OriginTypeFragmentsFragment = { __typename?: 'OriginType', guid: string, name: string, active: string, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } };

export type OriginTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginTypesQuery = { __typename?: 'Query', originTypes?: Array<{ __typename?: 'OriginType', guid: string, name: string, active: string, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null };

export type OriginTypeQueryVariables = Exact<{
  originTypeGuid?: InputMaybe<Scalars['String']>;
}>;


export type OriginTypeQuery = { __typename?: 'Query', originType?: { __typename?: 'OriginType', guid: string, name: string, active: string, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } | null };

export type CreateOriginTypeMutationVariables = Exact<{
  originType: OriginTypeInput;
}>;


export type CreateOriginTypeMutation = { __typename?: 'Mutation', createOriginType: { __typename?: 'OriginType', guid: string, name: string, active: string, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type DeleteOriginTypeMutationVariables = Exact<{
  originTypeGuid: Scalars['String'];
}>;


export type DeleteOriginTypeMutation = { __typename?: 'Mutation', deleteOriginType?: string | null };

export type OriginalTitleFragmentsFragment = { __typename?: 'OriginalTitle', guid: string, originalTitleName: string, originalTitleDateCreated: string, originalTitleJsonResponse: { __typename?: 'OriginalTitleJsonResponse', frumtitill: string, althjodlegurTitill?: string | null, lysing?: string | null, tegundTitils?: number | null, tegundTitilsHeiti?: string | null, heimildId?: number | null, heimild?: string | null, stadsetningFrumefnisUtanhuss?: string | null, upprunalond?: Array<any> | null, yfirflokkar?: Array<any> | null, undirflokkar?: Array<any> | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } };

export type OriginalTitlesQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginalTitlesQuery = { __typename?: 'Query', originalTitles?: Array<{ __typename?: 'OriginalTitle', guid: string, originalTitleName: string, originalTitleDateCreated: string, originalTitleJsonResponse: { __typename?: 'OriginalTitleJsonResponse', frumtitill: string, althjodlegurTitill?: string | null, lysing?: string | null, tegundTitils?: number | null, tegundTitilsHeiti?: string | null, heimildId?: number | null, heimild?: string | null, stadsetningFrumefnisUtanhuss?: string | null, upprunalond?: Array<any> | null, yfirflokkar?: Array<any> | null, undirflokkar?: Array<any> | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null, titles?: Array<{ __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null, credits?: Array<{ __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type OriginalTitleQueryVariables = Exact<{
  originalTitleGuid?: InputMaybe<Scalars['String']>;
}>;


export type OriginalTitleQuery = { __typename?: 'Query', originalTitle?: { __typename?: 'OriginalTitle', guid: string, originalTitleName: string, originalTitleDateCreated: string, originalTitleJsonResponse: { __typename?: 'OriginalTitleJsonResponse', frumtitill: string, althjodlegurTitill?: string | null, lysing?: string | null, tegundTitils?: number | null, tegundTitilsHeiti?: string | null, heimildId?: number | null, heimild?: string | null, stadsetningFrumefnisUtanhuss?: string | null, upprunalond?: Array<any> | null, yfirflokkar?: Array<any> | null, undirflokkar?: Array<any> | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } | null, sourceOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, countryOfOriginOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, overClassificationOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string, groupCode?: string | null, displayOrder?: number | null }> | null, subClassificationOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string, groupCode?: string | null, displayOrder?: number | null }> | null };

export type OriginalTitlesPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchOriginalTitlesInput>;
  filter?: InputMaybe<FilterOriginalTitleInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type OriginalTitlesPaginatedQuery = { __typename?: 'Query', originalTitlesPaginated?: { __typename?: 'OriginalTitleListAndGuids', totalGuids: Array<string>, list: { __typename?: 'OriginalTitlesList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'OriginalTitle', guid: string, originalTitleName: string, originalTitleDateCreated: string, originalTitleJsonResponse: { __typename?: 'OriginalTitleJsonResponse', frumtitill: string, althjodlegurTitill?: string | null, lysing?: string | null, tegundTitils?: number | null, tegundTitilsHeiti?: string | null, heimildId?: number | null, heimild?: string | null, stadsetningFrumefnisUtanhuss?: string | null, upprunalond?: Array<any> | null, yfirflokkar?: Array<any> | null, undirflokkar?: Array<any> | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null } } | null };

export type CreateOriginalTitleMutationVariables = Exact<{
  originalTitle: OriginalTitleInput;
}>;


export type CreateOriginalTitleMutation = { __typename?: 'Mutation', createOriginalTitle: { __typename?: 'OriginalTitle', guid: string, originalTitleName: string, originalTitleDateCreated: string, originalTitleJsonResponse: { __typename?: 'OriginalTitleJsonResponse', frumtitill: string, althjodlegurTitill?: string | null, lysing?: string | null, tegundTitils?: number | null, tegundTitilsHeiti?: string | null, heimildId?: number | null, heimild?: string | null, stadsetningFrumefnisUtanhuss?: string | null, upprunalond?: Array<any> | null, yfirflokkar?: Array<any> | null, undirflokkar?: Array<any> | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type UpdateOriginalTitleMutationVariables = Exact<{
  originalTitle: OriginalTitleInput;
  originalTitleGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOriginalTitleMutation = { __typename?: 'Mutation', updateOriginalTitle: { __typename?: 'OriginalTitle', guid: string, originalTitleName: string, originalTitleDateCreated: string, originalTitleJsonResponse: { __typename?: 'OriginalTitleJsonResponse', frumtitill: string, althjodlegurTitill?: string | null, lysing?: string | null, tegundTitils?: number | null, tegundTitilsHeiti?: string | null, heimildId?: number | null, heimild?: string | null, stadsetningFrumefnisUtanhuss?: string | null, upprunalond?: Array<any> | null, yfirflokkar?: Array<any> | null, undirflokkar?: Array<any> | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type DeleteOriginalTitleMutationVariables = Exact<{
  originalTitleGuid: Scalars['String'];
}>;


export type DeleteOriginalTitleMutation = { __typename?: 'Mutation', deleteOriginalTitle?: string | null };

export type OriginTitlesCreateOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginTitlesCreateOptionsQuery = { __typename?: 'Query', sourceOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, countryOfOriginOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null, overClassificationOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string, groupCode?: string | null, displayOrder?: number | null }> | null, subClassificationOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string, groupCode?: string | null, displayOrder?: number | null }> | null };

export type AutocompleteOriginalTitleOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteOriginalTitleOptionsQuery = { __typename?: 'Query', originalTitleOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type TitleCreditOptionsQueryVariables = Exact<{
  titleGuid?: InputMaybe<Scalars['String']>;
}>;


export type TitleCreditOptionsQuery = { __typename?: 'Query', titleCredits: Array<{ __typename?: 'Credit', guid: string, titleGuid: string, customerGuid?: string | null, titleName?: string | null, customerName?: string | null, creditName?: string | null, creditDateCreated?: string | null, creditJsonResponse?: { __typename?: 'CreditJsonResponse', dropdownItemId?: number | null, dropdownItemName?: string | null, comments?: string | null } | null, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> };

export type OriginalTitleNameQueryVariables = Exact<{
  originalTitleGuid: Scalars['String'];
}>;


export type OriginalTitleNameQuery = { __typename?: 'Query', originalTitleTitle: string };

export type CreateOriginalTitleTitleMutationVariables = Exact<{
  originalTitleTitle: OriginalTitleTitleInput;
}>;


export type CreateOriginalTitleTitleMutation = { __typename?: 'Mutation', createOriginalTitleTitle: { __typename?: 'OriginalTitleTitle', originalTitle?: { __typename?: 'OriginalTitle', guid: string, originalTitleName: string, originalTitleDateCreated: string, originalTitleJsonResponse: { __typename?: 'OriginalTitleJsonResponse', frumtitill: string, althjodlegurTitill?: string | null, lysing?: string | null, tegundTitils?: number | null, tegundTitilsHeiti?: string | null, heimildId?: number | null, heimild?: string | null, stadsetningFrumefnisUtanhuss?: string | null, upprunalond?: Array<any> | null, yfirflokkar?: Array<any> | null, undirflokkar?: Array<any> | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } | null, title: { __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } } };

export type MergeOriginalTitlesMutationVariables = Exact<{
  mergeOriginalTitleData: MergeOriginalTitleInput;
}>;


export type MergeOriginalTitlesMutation = { __typename?: 'Mutation', mergeOriginalTitles: boolean };

export type OriginalTitlesOptionsQueryVariables = Exact<{
  originalTitleGuids: Array<Scalars['String']> | Scalars['String'];
}>;


export type OriginalTitlesOptionsQuery = { __typename?: 'Query', originalTitlesOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type RightsAgreementsQueryVariables = Exact<{
  customerGuid?: InputMaybe<Scalars['String']>;
  originalTitleGuid?: InputMaybe<Scalars['String']>;
}>;


export type RightsAgreementsQuery = { __typename?: 'Query', rightsAgreements?: Array<{ __typename?: 'RightsAgreementDocument', blobFileGuid: string, name: string, dateCreated: string, originalTitle?: string | null, originalTitleGuid?: string | null, customer?: string | null, customerGuid?: string | null, isDeleted: boolean, rightsAgreementGuid: string }> | null };

export type ActivateOrDeactivateRightsAgreementMutationVariables = Exact<{
  rightsAgreementGuid: Scalars['String'];
  active: Scalars['Boolean'];
}>;


export type ActivateOrDeactivateRightsAgreementMutation = { __typename?: 'Mutation', activateOrDeactivateRightsAgreement: boolean };

export type TagFragmentsFragment = { __typename?: 'Tag', guid: string, keyword: string, createdByName?: string | null, modifiedByName?: string | null, tagType: { __typename?: 'TagType', isCustomerType: boolean, isContentType: boolean, isItemType: boolean }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', tags?: { __typename?: 'TagsListAndGuids', totalGuids: Array<string>, list: { __typename?: 'TagsList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'Tag', guid: string, keyword: string, createdByName?: string | null, modifiedByName?: string | null, tagType: { __typename?: 'TagType', isCustomerType: boolean, isContentType: boolean, isItemType: boolean }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null } } | null };

export type TagQueryVariables = Exact<{
  tagGuid?: InputMaybe<Scalars['String']>;
}>;


export type TagQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', guid: string, keyword: string, createdByName?: string | null, modifiedByName?: string | null, tagType: { __typename?: 'TagType', isCustomerType: boolean, isContentType: boolean, isItemType: boolean }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } | null };

export type TagsPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchAdminComponentInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type TagsPaginatedQuery = { __typename?: 'Query', tagsPaginated?: { __typename?: 'TagsListAndGuids', totalGuids: Array<string>, list: { __typename?: 'TagsList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'Tag', guid: string, keyword: string, createdByName?: string | null, modifiedByName?: string | null, tagType: { __typename?: 'TagType', isCustomerType: boolean, isContentType: boolean, isItemType: boolean }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } }> | null } } | null };

export type CreateTagMutationVariables = Exact<{
  tag: TagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', guid: string, keyword: string, createdByName?: string | null, modifiedByName?: string | null, tagType: { __typename?: 'TagType', isCustomerType: boolean, isContentType: boolean, isItemType: boolean }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type UpdateTagMutationVariables = Exact<{
  tag: TagInput;
  tagGuid: Scalars['String'];
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'Tag', guid: string, keyword: string, createdByName?: string | null, modifiedByName?: string | null, tagType: { __typename?: 'TagType', isCustomerType: boolean, isContentType: boolean, isItemType: boolean }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null } } };

export type DeleteTagMutationVariables = Exact<{
  tagGuid: Scalars['String'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: string | null };

export type CustomerTagsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerTagsOptionsQuery = { __typename?: 'Query', customerTagsOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type TitleFragmentsFragment = { __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null };

export type TitlesQueryVariables = Exact<{ [key: string]: never; }>;


export type TitlesQuery = { __typename?: 'Query', titles?: Array<{ __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null };

export type TitleQueryVariables = Exact<{
  titleGuid?: InputMaybe<Scalars['String']>;
}>;


export type TitleQuery = { __typename?: 'Query', title?: { __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } | null, languageOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null };

export type TitlesPaginatedQueryVariables = Exact<{
  search?: InputMaybe<SearchTitlesInput>;
  filter?: InputMaybe<FilterTitlesInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type TitlesPaginatedQuery = { __typename?: 'Query', titlesPaginated?: { __typename?: 'TitleListAndGuids', totalGuids: Array<string>, list: { __typename?: 'TitlesList', pageInfo: { __typename?: 'PageInfo', totalResults: number }, items?: Array<{ __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null }> | null } } | null };

export type TitlesInOriginalTitleQueryVariables = Exact<{
  originalTitleGuid: Scalars['String'];
}>;


export type TitlesInOriginalTitleQuery = { __typename?: 'Query', titlesInOriginalTitle: Array<{ __typename?: 'Title', guid: string, originalTitleGuid: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null } }> };

export type CreateTitleMutationVariables = Exact<{
  title: TitleInput;
}>;


export type CreateTitleMutation = { __typename?: 'Mutation', createTitle: { __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type UpdateTitleMutationVariables = Exact<{
  title: TitleInput;
  titleGuid?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTitleMutation = { __typename?: 'Mutation', updateTitle: { __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type PatchTitleMutationVariables = Exact<{
  title: PatchTitleInput;
  titleGuid: Scalars['String'];
}>;


export type PatchTitleMutation = { __typename?: 'Mutation', patchTitle: { __typename?: 'Title', guid: string, originalTitleGuid: string, titleName: string, titleDateCreated: string, titleJsonResponse: { __typename?: 'TitleJsonResponse', titill: string, frumsyning?: string | null, stadsetningFrumsyningar?: string | null, timabilEfnisFra?: string | null, timabilEfnisTil?: string | null, tungumal?: Array<any> | null, athugasemdir?: string | null, kreditFullskradur?: boolean | null, lengdEfnis?: string | null, utgafuAr?: string | null }, informationResponse: { __typename?: 'InformationResponse', dateCreated: string, createdBy: string, dateModified?: string | null, modifiedBy?: string | null }, tagsGuid?: Array<{ __typename?: 'DropDownDto', guid: string, title: string }> | null } };

export type DeleteTitleMutationVariables = Exact<{
  titleGuid: Scalars['String'];
}>;


export type DeleteTitleMutation = { __typename?: 'Mutation', deleteTitle?: string | null };

export type ValidateTitleDeletionQueryVariables = Exact<{
  titleGuid: Scalars['String'];
}>;


export type ValidateTitleDeletionQuery = { __typename?: 'Query', validateTitleDeletion?: string | null };

export type TitlesCreateOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TitlesCreateOptionsQuery = { __typename?: 'Query', languageOptions?: Array<{ __typename?: 'SelectItemInt', id: number, title: string }> | null };

export type AutocompleteTitleOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AutocompleteTitleOptionsQuery = { __typename?: 'Query', titleOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string }> | null };

export type TitleDirectorQueryVariables = Exact<{
  titleGuid: Scalars['String'];
}>;


export type TitleDirectorQuery = { __typename?: 'Query', titleDirector?: string | null };

export type TitleOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TitleOptionsQuery = { __typename?: 'Query', titleOptions?: Array<{ __typename?: 'SelectItem', id: string, title: string, extraInfo?: string | null }> | null };

export type TmDbInfoForTitleQueryVariables = Exact<{
  titleGuid: Scalars['String'];
  tmdbId: Scalars['Int'];
}>;


export type TmDbInfoForTitleQuery = { __typename?: 'Query', tmdbInfoForTitle?: { __typename?: 'TMDbInfoResponse', titleGuid: string, title?: string | null, releaseDate?: string | null, overview?: string | null, runtime?: number | null, spokenLanguages?: string | null, id?: number | null, page?: number | null } | null };

export type SearchTmDbMoviesQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SearchTmDbMoviesQuery = { __typename?: 'Query', searchTMDbMovies?: Array<{ __typename?: 'TMDbSearchResult', id: number, title: string }> | null };

export type KmiInfoForTitleQueryVariables = Exact<{
  titleGuid: Scalars['String'];
  kmiId: Scalars['String'];
}>;


export type KmiInfoForTitleQuery = { __typename?: 'Query', kmiInfoForTitle?: { __typename?: 'KMIInfoResponse', titleGuid: string, title?: string | null, date?: string | null, synopsis?: string | null, productionYear?: string | null, languages?: Array<string> | null, genres?: Array<string> | null } | null };

export type SearchKmiMoviesQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SearchKmiMoviesQuery = { __typename?: 'Query', searchKMIMovies?: Array<{ __typename?: 'KMISearchResult', id: string, title: string }> | null };

export const ConditionCheckFragmentsFragmentDoc = gql`
    fragment ConditionCheckFragments on ConditionCheck {
  guid
  itemGuid
  conditionCheckJsonResponse {
    dagsetning
    athugasemdir
    meginskemmdir {
      id
      title
    }
    heildarastand {
      id
      title
    }
    skodunarmadur {
      guid
      nafn
    }
  }
}
    `;
export const ContentAnalysisFragmentsFragmentDoc = gql`
    fragment ContentAnalysisFragments on ContentAnalysis {
  guid
  itemGuid
  itemNumber
  titleGuid
  titleName
  contentAnalysisJsonResponse {
    efnislysing
    tcFra
    tcTil
    samtalsTimi
    tagsGuid
    year
    yearTo
  }
}
    `;
export const CreditFragmentsFragmentDoc = gql`
    fragment CreditFragments on Credit {
  guid
  titleGuid
  customerGuid
  creditJsonResponse {
    dropdownItemId
    dropdownItemName
    comments
  }
  titleName
  customerName
  creditName
  creditDateCreated
  tagsGuid {
    guid
    title
  }
}
    `;
export const CustomerFragmentsFragmentDoc = gql`
    fragment CustomerFragments on Customer {
  guid
  name
  ssn
  address
  postalCode
  email
  phoneNumber
  comment
  deceased
  active
  identity
  comment
  tagsGuid {
    guid
    title
  }
}
    `;
export const FormFragmentsFragmentDoc = gql`
    fragment FormFragments on Form {
  guid
  name
  metadata
  dropDownTypeItemResponse {
    id
    code
    name
    description
    dropDownItemResponse {
      id
      value
    }
  }
}
    `;
export const ItemFragmentsFragmentDoc = gql`
    fragment ItemFragments on Item {
  guid
  itemCollectionGuid
  itemNumber
  itemTypeGuid
  itemTypeName
  originNumber
  itemCollectionNumber
  originGuid
  originYear
  formCode
  formName
  title
  itemName
  itemDateCreated
  json
  isItemTypeLocation
  languagesNames
  subtitlesNames
  coldLocationsNames
  locationsNames
  upprunalegirEigendurNames
  breiddName
  informationResponse {
    dateCreated
    createdBy
    dateModified
    modifiedBy
  }
  tagsGuid {
    guid
    title
  }
}
    `;
export const ItemCollectionFragmentsFragmentDoc = gql`
    fragment ItemCollectionFragments on ItemCollection {
  guid
  originGuid
  originNumber
  originName
  originYear
  itemCollectionNumber
  itemCollectionTypeGuid
  itemCount
  itemCollectionName
  itemCollectionTypeCode
  itemCollectionDateCreated
  itemCollectionJsonResponse {
    tegund
    heiti
    afhendingarskilyrdiId
    afhendingarskilyrdi
    lysing
  }
  tagsGuid {
    guid
    title
  }
}
    `;
export const ItemCollectionTypeDetailFragmentsFragmentDoc = gql`
    fragment ItemCollectionTypeDetailFragments on ItemCollectionTypeDetail {
  guid
  name
  active
  code
  createdByName
  modifiedByName
  informationResponse {
    dateCreated
    createdBy
    dateModified
    modifiedBy
  }
}
    `;
export const ItemTypeDetailFragmentsFragmentDoc = gql`
    fragment ItemTypeDetailFragments on ItemTypeDetail {
  guid
  formGuid
  name
  active
  visible
  createdByName
  modifiedByName
  informationResponse {
    dateCreated
    createdBy
    dateModified
    modifiedBy
  }
}
    `;
export const LocationFragmentsFragmentDoc = gql`
    fragment LocationFragments on Location {
  guid
  name
}
    `;
export const OriginFragmentsFragmentDoc = gql`
    fragment OriginFragments on Origin {
  guid
  originTypeGuid
  originNumber
  originName
  originDate
  originJsonResponse {
    heiti
    lysing
    dagsetning
    tengilidir {
      guid
      nafn
    }
    mottakendur {
      guid
      nafn
    }
  }
  tagsGuid {
    guid
    title
  }
}
    `;
export const OriginTypeFragmentsFragmentDoc = gql`
    fragment OriginTypeFragments on OriginType {
  guid
  name
  active
  informationResponse {
    dateCreated
    createdBy
    dateModified
    modifiedBy
  }
}
    `;
export const OriginalTitleFragmentsFragmentDoc = gql`
    fragment OriginalTitleFragments on OriginalTitle {
  guid
  originalTitleName
  originalTitleDateCreated
  originalTitleJsonResponse {
    frumtitill
    althjodlegurTitill
    lysing
    tegundTitils
    tegundTitilsHeiti
    heimildId
    heimild
    stadsetningFrumefnisUtanhuss
    upprunalond
    yfirflokkar
    undirflokkar
  }
  informationResponse {
    dateCreated
    createdBy
    dateModified
    modifiedBy
  }
}
    `;
export const TagFragmentsFragmentDoc = gql`
    fragment TagFragments on Tag {
  guid
  keyword
  tagType {
    isCustomerType
    isContentType
    isItemType
  }
  createdByName
  modifiedByName
  informationResponse {
    dateCreated
    createdBy
    dateModified
    modifiedBy
  }
}
    `;
export const TitleFragmentsFragmentDoc = gql`
    fragment TitleFragments on Title {
  guid
  originalTitleGuid
  titleName
  titleDateCreated
  titleJsonResponse {
    titill
    frumsyning
    stadsetningFrumsyningar
    timabilEfnisFra
    timabilEfnisTil
    tungumal
    athugasemdir
    kreditFullskradur
    lengdEfnis
    utgafuAr
  }
  informationResponse {
    dateCreated
    createdBy
    dateModified
    modifiedBy
  }
  tagsGuid {
    guid
    title
  }
}
    `;
export const ConditionChecksDocument = gql`
    query ConditionChecks {
  conditionCheck {
    guid
    ...ConditionCheckFragments
  }
}
    ${ConditionCheckFragmentsFragmentDoc}`;

/**
 * __useConditionChecksQuery__
 *
 * To run a query within a React component, call `useConditionChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionChecksQuery({
 *   variables: {
 *   },
 * });
 */
export function useConditionChecksQuery(baseOptions?: Apollo.QueryHookOptions<ConditionChecksQuery, ConditionChecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConditionChecksQuery, ConditionChecksQueryVariables>(ConditionChecksDocument, options);
      }
export function useConditionChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConditionChecksQuery, ConditionChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConditionChecksQuery, ConditionChecksQueryVariables>(ConditionChecksDocument, options);
        }
export type ConditionChecksQueryHookResult = ReturnType<typeof useConditionChecksQuery>;
export type ConditionChecksLazyQueryHookResult = ReturnType<typeof useConditionChecksLazyQuery>;
export type ConditionChecksQueryResult = Apollo.QueryResult<ConditionChecksQuery, ConditionChecksQueryVariables>;
export const ConditionCheckDocument = gql`
    query ConditionCheck($conditionCheckGuid: String) {
  conditionCheck(conditionCheckGuid: $conditionCheckGuid) {
    ...ConditionCheckFragments
  }
}
    ${ConditionCheckFragmentsFragmentDoc}`;

/**
 * __useConditionCheckQuery__
 *
 * To run a query within a React component, call `useConditionCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionCheckQuery({
 *   variables: {
 *      conditionCheckGuid: // value for 'conditionCheckGuid'
 *   },
 * });
 */
export function useConditionCheckQuery(baseOptions?: Apollo.QueryHookOptions<ConditionCheckQuery, ConditionCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConditionCheckQuery, ConditionCheckQueryVariables>(ConditionCheckDocument, options);
      }
export function useConditionCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConditionCheckQuery, ConditionCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConditionCheckQuery, ConditionCheckQueryVariables>(ConditionCheckDocument, options);
        }
export type ConditionCheckQueryHookResult = ReturnType<typeof useConditionCheckQuery>;
export type ConditionCheckLazyQueryHookResult = ReturnType<typeof useConditionCheckLazyQuery>;
export type ConditionCheckQueryResult = Apollo.QueryResult<ConditionCheckQuery, ConditionCheckQueryVariables>;
export const CreateConditionCheckDocument = gql`
    mutation CreateConditionCheck($conditionCheck: ConditionCheckInput!) {
  createConditionCheck(conditionCheck: $conditionCheck) {
    ...ConditionCheckFragments
  }
}
    ${ConditionCheckFragmentsFragmentDoc}`;
export type CreateConditionCheckMutationFn = Apollo.MutationFunction<CreateConditionCheckMutation, CreateConditionCheckMutationVariables>;

/**
 * __useCreateConditionCheckMutation__
 *
 * To run a mutation, you first call `useCreateConditionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConditionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConditionCheckMutation, { data, loading, error }] = useCreateConditionCheckMutation({
 *   variables: {
 *      conditionCheck: // value for 'conditionCheck'
 *   },
 * });
 */
export function useCreateConditionCheckMutation(baseOptions?: Apollo.MutationHookOptions<CreateConditionCheckMutation, CreateConditionCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConditionCheckMutation, CreateConditionCheckMutationVariables>(CreateConditionCheckDocument, options);
      }
export type CreateConditionCheckMutationHookResult = ReturnType<typeof useCreateConditionCheckMutation>;
export type CreateConditionCheckMutationResult = Apollo.MutationResult<CreateConditionCheckMutation>;
export type CreateConditionCheckMutationOptions = Apollo.BaseMutationOptions<CreateConditionCheckMutation, CreateConditionCheckMutationVariables>;
export const UpdateConditionCheckDocument = gql`
    mutation UpdateConditionCheck($conditionCheck: ConditionCheckInput!, $conditionCheckGuid: String) {
  updateConditionCheck(
    conditionCheck: $conditionCheck
    conditionCheckGuid: $conditionCheckGuid
  ) {
    ...ConditionCheckFragments
  }
}
    ${ConditionCheckFragmentsFragmentDoc}`;
export type UpdateConditionCheckMutationFn = Apollo.MutationFunction<UpdateConditionCheckMutation, UpdateConditionCheckMutationVariables>;

/**
 * __useUpdateConditionCheckMutation__
 *
 * To run a mutation, you first call `useUpdateConditionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConditionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConditionCheckMutation, { data, loading, error }] = useUpdateConditionCheckMutation({
 *   variables: {
 *      conditionCheck: // value for 'conditionCheck'
 *      conditionCheckGuid: // value for 'conditionCheckGuid'
 *   },
 * });
 */
export function useUpdateConditionCheckMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConditionCheckMutation, UpdateConditionCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConditionCheckMutation, UpdateConditionCheckMutationVariables>(UpdateConditionCheckDocument, options);
      }
export type UpdateConditionCheckMutationHookResult = ReturnType<typeof useUpdateConditionCheckMutation>;
export type UpdateConditionCheckMutationResult = Apollo.MutationResult<UpdateConditionCheckMutation>;
export type UpdateConditionCheckMutationOptions = Apollo.BaseMutationOptions<UpdateConditionCheckMutation, UpdateConditionCheckMutationVariables>;
export const DeleteConditionCheckDocument = gql`
    mutation DeleteConditionCheck($conditionCheckGuid: String!) {
  deleteConditionCheck(conditionCheckGuid: $conditionCheckGuid)
}
    `;
export type DeleteConditionCheckMutationFn = Apollo.MutationFunction<DeleteConditionCheckMutation, DeleteConditionCheckMutationVariables>;

/**
 * __useDeleteConditionCheckMutation__
 *
 * To run a mutation, you first call `useDeleteConditionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConditionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConditionCheckMutation, { data, loading, error }] = useDeleteConditionCheckMutation({
 *   variables: {
 *      conditionCheckGuid: // value for 'conditionCheckGuid'
 *   },
 * });
 */
export function useDeleteConditionCheckMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConditionCheckMutation, DeleteConditionCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConditionCheckMutation, DeleteConditionCheckMutationVariables>(DeleteConditionCheckDocument, options);
      }
export type DeleteConditionCheckMutationHookResult = ReturnType<typeof useDeleteConditionCheckMutation>;
export type DeleteConditionCheckMutationResult = Apollo.MutationResult<DeleteConditionCheckMutation>;
export type DeleteConditionCheckMutationOptions = Apollo.BaseMutationOptions<DeleteConditionCheckMutation, DeleteConditionCheckMutationVariables>;
export const ItemConditionChecksDocument = gql`
    query ItemConditionChecks($itemGuid: String!) {
  itemConditionCheck(itemGuid: $itemGuid) {
    ...ConditionCheckFragments
  }
}
    ${ConditionCheckFragmentsFragmentDoc}`;

/**
 * __useItemConditionChecksQuery__
 *
 * To run a query within a React component, call `useItemConditionChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemConditionChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemConditionChecksQuery({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useItemConditionChecksQuery(baseOptions: Apollo.QueryHookOptions<ItemConditionChecksQuery, ItemConditionChecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemConditionChecksQuery, ItemConditionChecksQueryVariables>(ItemConditionChecksDocument, options);
      }
export function useItemConditionChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemConditionChecksQuery, ItemConditionChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemConditionChecksQuery, ItemConditionChecksQueryVariables>(ItemConditionChecksDocument, options);
        }
export type ItemConditionChecksQueryHookResult = ReturnType<typeof useItemConditionChecksQuery>;
export type ItemConditionChecksLazyQueryHookResult = ReturnType<typeof useItemConditionChecksLazyQuery>;
export type ItemConditionChecksQueryResult = Apollo.QueryResult<ItemConditionChecksQuery, ItemConditionChecksQueryVariables>;
export const ConditionCheckOptionsDocument = gql`
    query ConditionCheckOptions {
  conditionCheckDamageOptions {
    id
    title
  }
  conditionCheckStateOptions {
    id
    title
  }
  conditionCheckInspectorOptions {
    id
    title
  }
}
    `;

/**
 * __useConditionCheckOptionsQuery__
 *
 * To run a query within a React component, call `useConditionCheckOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionCheckOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionCheckOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConditionCheckOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ConditionCheckOptionsQuery, ConditionCheckOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConditionCheckOptionsQuery, ConditionCheckOptionsQueryVariables>(ConditionCheckOptionsDocument, options);
      }
export function useConditionCheckOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConditionCheckOptionsQuery, ConditionCheckOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConditionCheckOptionsQuery, ConditionCheckOptionsQueryVariables>(ConditionCheckOptionsDocument, options);
        }
export type ConditionCheckOptionsQueryHookResult = ReturnType<typeof useConditionCheckOptionsQuery>;
export type ConditionCheckOptionsLazyQueryHookResult = ReturnType<typeof useConditionCheckOptionsLazyQuery>;
export type ConditionCheckOptionsQueryResult = Apollo.QueryResult<ConditionCheckOptionsQuery, ConditionCheckOptionsQueryVariables>;
export const ContentAnalysesDocument = gql`
    query ContentAnalyses {
  contentAnalyses {
    guid
    ...ContentAnalysisFragments
  }
}
    ${ContentAnalysisFragmentsFragmentDoc}`;

/**
 * __useContentAnalysesQuery__
 *
 * To run a query within a React component, call `useContentAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentAnalysesQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentAnalysesQuery(baseOptions?: Apollo.QueryHookOptions<ContentAnalysesQuery, ContentAnalysesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentAnalysesQuery, ContentAnalysesQueryVariables>(ContentAnalysesDocument, options);
      }
export function useContentAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentAnalysesQuery, ContentAnalysesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentAnalysesQuery, ContentAnalysesQueryVariables>(ContentAnalysesDocument, options);
        }
export type ContentAnalysesQueryHookResult = ReturnType<typeof useContentAnalysesQuery>;
export type ContentAnalysesLazyQueryHookResult = ReturnType<typeof useContentAnalysesLazyQuery>;
export type ContentAnalysesQueryResult = Apollo.QueryResult<ContentAnalysesQuery, ContentAnalysesQueryVariables>;
export const ContentAnalysisDocument = gql`
    query ContentAnalysis($contentAnalysisGuid: String) {
  contentAnalysis(contentAnalysisGuid: $contentAnalysisGuid) {
    ...ContentAnalysisFragments
  }
}
    ${ContentAnalysisFragmentsFragmentDoc}`;

/**
 * __useContentAnalysisQuery__
 *
 * To run a query within a React component, call `useContentAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentAnalysisQuery({
 *   variables: {
 *      contentAnalysisGuid: // value for 'contentAnalysisGuid'
 *   },
 * });
 */
export function useContentAnalysisQuery(baseOptions?: Apollo.QueryHookOptions<ContentAnalysisQuery, ContentAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentAnalysisQuery, ContentAnalysisQueryVariables>(ContentAnalysisDocument, options);
      }
export function useContentAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentAnalysisQuery, ContentAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentAnalysisQuery, ContentAnalysisQueryVariables>(ContentAnalysisDocument, options);
        }
export type ContentAnalysisQueryHookResult = ReturnType<typeof useContentAnalysisQuery>;
export type ContentAnalysisLazyQueryHookResult = ReturnType<typeof useContentAnalysisLazyQuery>;
export type ContentAnalysisQueryResult = Apollo.QueryResult<ContentAnalysisQuery, ContentAnalysisQueryVariables>;
export const CreateContentAnalysisDocument = gql`
    mutation CreateContentAnalysis($contentAnalysis: ContentAnalysisInput!) {
  createContentAnalysis(contentAnalysis: $contentAnalysis) {
    ...ContentAnalysisFragments
  }
}
    ${ContentAnalysisFragmentsFragmentDoc}`;
export type CreateContentAnalysisMutationFn = Apollo.MutationFunction<CreateContentAnalysisMutation, CreateContentAnalysisMutationVariables>;

/**
 * __useCreateContentAnalysisMutation__
 *
 * To run a mutation, you first call `useCreateContentAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentAnalysisMutation, { data, loading, error }] = useCreateContentAnalysisMutation({
 *   variables: {
 *      contentAnalysis: // value for 'contentAnalysis'
 *   },
 * });
 */
export function useCreateContentAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentAnalysisMutation, CreateContentAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentAnalysisMutation, CreateContentAnalysisMutationVariables>(CreateContentAnalysisDocument, options);
      }
export type CreateContentAnalysisMutationHookResult = ReturnType<typeof useCreateContentAnalysisMutation>;
export type CreateContentAnalysisMutationResult = Apollo.MutationResult<CreateContentAnalysisMutation>;
export type CreateContentAnalysisMutationOptions = Apollo.BaseMutationOptions<CreateContentAnalysisMutation, CreateContentAnalysisMutationVariables>;
export const UpdateContentAnalysisDocument = gql`
    mutation UpdateContentAnalysis($contentAnalysis: ContentAnalysisInput!, $contentAnalysisGuid: String) {
  updateContentAnalysis(
    contentAnalysis: $contentAnalysis
    contentAnalysisGuid: $contentAnalysisGuid
  ) {
    ...ContentAnalysisFragments
  }
}
    ${ContentAnalysisFragmentsFragmentDoc}`;
export type UpdateContentAnalysisMutationFn = Apollo.MutationFunction<UpdateContentAnalysisMutation, UpdateContentAnalysisMutationVariables>;

/**
 * __useUpdateContentAnalysisMutation__
 *
 * To run a mutation, you first call `useUpdateContentAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentAnalysisMutation, { data, loading, error }] = useUpdateContentAnalysisMutation({
 *   variables: {
 *      contentAnalysis: // value for 'contentAnalysis'
 *      contentAnalysisGuid: // value for 'contentAnalysisGuid'
 *   },
 * });
 */
export function useUpdateContentAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentAnalysisMutation, UpdateContentAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentAnalysisMutation, UpdateContentAnalysisMutationVariables>(UpdateContentAnalysisDocument, options);
      }
export type UpdateContentAnalysisMutationHookResult = ReturnType<typeof useUpdateContentAnalysisMutation>;
export type UpdateContentAnalysisMutationResult = Apollo.MutationResult<UpdateContentAnalysisMutation>;
export type UpdateContentAnalysisMutationOptions = Apollo.BaseMutationOptions<UpdateContentAnalysisMutation, UpdateContentAnalysisMutationVariables>;
export const DeleteContentAnalysisDocument = gql`
    mutation DeleteContentAnalysis($contentAnalysisGuid: String!) {
  deleteContentAnalysis(contentAnalysisGuid: $contentAnalysisGuid)
}
    `;
export type DeleteContentAnalysisMutationFn = Apollo.MutationFunction<DeleteContentAnalysisMutation, DeleteContentAnalysisMutationVariables>;

/**
 * __useDeleteContentAnalysisMutation__
 *
 * To run a mutation, you first call `useDeleteContentAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentAnalysisMutation, { data, loading, error }] = useDeleteContentAnalysisMutation({
 *   variables: {
 *      contentAnalysisGuid: // value for 'contentAnalysisGuid'
 *   },
 * });
 */
export function useDeleteContentAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentAnalysisMutation, DeleteContentAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentAnalysisMutation, DeleteContentAnalysisMutationVariables>(DeleteContentAnalysisDocument, options);
      }
export type DeleteContentAnalysisMutationHookResult = ReturnType<typeof useDeleteContentAnalysisMutation>;
export type DeleteContentAnalysisMutationResult = Apollo.MutationResult<DeleteContentAnalysisMutation>;
export type DeleteContentAnalysisMutationOptions = Apollo.BaseMutationOptions<DeleteContentAnalysisMutation, DeleteContentAnalysisMutationVariables>;
export const ItemContentAnalysesDocument = gql`
    query ItemContentAnalyses($itemGuid: String!) {
  itemContentAnalyses(itemGuid: $itemGuid) {
    ...ContentAnalysisFragments
  }
}
    ${ContentAnalysisFragmentsFragmentDoc}`;

/**
 * __useItemContentAnalysesQuery__
 *
 * To run a query within a React component, call `useItemContentAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemContentAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemContentAnalysesQuery({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useItemContentAnalysesQuery(baseOptions: Apollo.QueryHookOptions<ItemContentAnalysesQuery, ItemContentAnalysesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemContentAnalysesQuery, ItemContentAnalysesQueryVariables>(ItemContentAnalysesDocument, options);
      }
export function useItemContentAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemContentAnalysesQuery, ItemContentAnalysesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemContentAnalysesQuery, ItemContentAnalysesQueryVariables>(ItemContentAnalysesDocument, options);
        }
export type ItemContentAnalysesQueryHookResult = ReturnType<typeof useItemContentAnalysesQuery>;
export type ItemContentAnalysesLazyQueryHookResult = ReturnType<typeof useItemContentAnalysesLazyQuery>;
export type ItemContentAnalysesQueryResult = Apollo.QueryResult<ItemContentAnalysesQuery, ItemContentAnalysesQueryVariables>;
export const ContentAnalysisPaginatedDocument = gql`
    query ContentAnalysisPaginated($search: SearchContentAnalysisInput, $filter: FilterContentAnalysisInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  contentAnalysisPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...ContentAnalysisFragments
      }
    }
    totalGuids
  }
}
    ${ContentAnalysisFragmentsFragmentDoc}`;

/**
 * __useContentAnalysisPaginatedQuery__
 *
 * To run a query within a React component, call `useContentAnalysisPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentAnalysisPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentAnalysisPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useContentAnalysisPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<ContentAnalysisPaginatedQuery, ContentAnalysisPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentAnalysisPaginatedQuery, ContentAnalysisPaginatedQueryVariables>(ContentAnalysisPaginatedDocument, options);
      }
export function useContentAnalysisPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentAnalysisPaginatedQuery, ContentAnalysisPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentAnalysisPaginatedQuery, ContentAnalysisPaginatedQueryVariables>(ContentAnalysisPaginatedDocument, options);
        }
export type ContentAnalysisPaginatedQueryHookResult = ReturnType<typeof useContentAnalysisPaginatedQuery>;
export type ContentAnalysisPaginatedLazyQueryHookResult = ReturnType<typeof useContentAnalysisPaginatedLazyQuery>;
export type ContentAnalysisPaginatedQueryResult = Apollo.QueryResult<ContentAnalysisPaginatedQuery, ContentAnalysisPaginatedQueryVariables>;
export const ContentAnalysisTagsOptionsDocument = gql`
    query ContentAnalysisTagsOptions {
  contentAnalysisTagsOptions {
    id
    title
  }
}
    `;

/**
 * __useContentAnalysisTagsOptionsQuery__
 *
 * To run a query within a React component, call `useContentAnalysisTagsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentAnalysisTagsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentAnalysisTagsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentAnalysisTagsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ContentAnalysisTagsOptionsQuery, ContentAnalysisTagsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentAnalysisTagsOptionsQuery, ContentAnalysisTagsOptionsQueryVariables>(ContentAnalysisTagsOptionsDocument, options);
      }
export function useContentAnalysisTagsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentAnalysisTagsOptionsQuery, ContentAnalysisTagsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentAnalysisTagsOptionsQuery, ContentAnalysisTagsOptionsQueryVariables>(ContentAnalysisTagsOptionsDocument, options);
        }
export type ContentAnalysisTagsOptionsQueryHookResult = ReturnType<typeof useContentAnalysisTagsOptionsQuery>;
export type ContentAnalysisTagsOptionsLazyQueryHookResult = ReturnType<typeof useContentAnalysisTagsOptionsLazyQuery>;
export type ContentAnalysisTagsOptionsQueryResult = Apollo.QueryResult<ContentAnalysisTagsOptionsQuery, ContentAnalysisTagsOptionsQueryVariables>;
export const CreditsDocument = gql`
    query Credits {
  credits {
    ...CreditFragments
  }
}
    ${CreditFragmentsFragmentDoc}`;

/**
 * __useCreditsQuery__
 *
 * To run a query within a React component, call `useCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditsQuery(baseOptions?: Apollo.QueryHookOptions<CreditsQuery, CreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditsQuery, CreditsQueryVariables>(CreditsDocument, options);
      }
export function useCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditsQuery, CreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditsQuery, CreditsQueryVariables>(CreditsDocument, options);
        }
export type CreditsQueryHookResult = ReturnType<typeof useCreditsQuery>;
export type CreditsLazyQueryHookResult = ReturnType<typeof useCreditsLazyQuery>;
export type CreditsQueryResult = Apollo.QueryResult<CreditsQuery, CreditsQueryVariables>;
export const CreditDocument = gql`
    query Credit($creditGuid: String, $titleGuid: String) {
  credit(creditGuid: $creditGuid) {
    ...CreditFragments
  }
  customerOptions {
    id
    title
  }
  creditOptions {
    id
    title
  }
  title(titleGuid: $titleGuid) {
    ...TitleFragments
  }
}
    ${CreditFragmentsFragmentDoc}
${TitleFragmentsFragmentDoc}`;

/**
 * __useCreditQuery__
 *
 * To run a query within a React component, call `useCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditQuery({
 *   variables: {
 *      creditGuid: // value for 'creditGuid'
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useCreditQuery(baseOptions?: Apollo.QueryHookOptions<CreditQuery, CreditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditQuery, CreditQueryVariables>(CreditDocument, options);
      }
export function useCreditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditQuery, CreditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditQuery, CreditQueryVariables>(CreditDocument, options);
        }
export type CreditQueryHookResult = ReturnType<typeof useCreditQuery>;
export type CreditLazyQueryHookResult = ReturnType<typeof useCreditLazyQuery>;
export type CreditQueryResult = Apollo.QueryResult<CreditQuery, CreditQueryVariables>;
export const CreditsPaginatedDocument = gql`
    query CreditsPaginated($search: SearchCreditsInput, $filter: FilterCreditsInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  creditsPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...CreditFragments
      }
    }
    totalGuids
  }
}
    ${CreditFragmentsFragmentDoc}`;

/**
 * __useCreditsPaginatedQuery__
 *
 * To run a query within a React component, call `useCreditsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditsPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCreditsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<CreditsPaginatedQuery, CreditsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditsPaginatedQuery, CreditsPaginatedQueryVariables>(CreditsPaginatedDocument, options);
      }
export function useCreditsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditsPaginatedQuery, CreditsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditsPaginatedQuery, CreditsPaginatedQueryVariables>(CreditsPaginatedDocument, options);
        }
export type CreditsPaginatedQueryHookResult = ReturnType<typeof useCreditsPaginatedQuery>;
export type CreditsPaginatedLazyQueryHookResult = ReturnType<typeof useCreditsPaginatedLazyQuery>;
export type CreditsPaginatedQueryResult = Apollo.QueryResult<CreditsPaginatedQuery, CreditsPaginatedQueryVariables>;
export const CreditOptionsDocument = gql`
    query CreditOptions {
  creditOptions {
    id
    title
  }
  titleOptions {
    id
    title
  }
}
    `;

/**
 * __useCreditOptionsQuery__
 *
 * To run a query within a React component, call `useCreditOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CreditOptionsQuery, CreditOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditOptionsQuery, CreditOptionsQueryVariables>(CreditOptionsDocument, options);
      }
export function useCreditOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditOptionsQuery, CreditOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditOptionsQuery, CreditOptionsQueryVariables>(CreditOptionsDocument, options);
        }
export type CreditOptionsQueryHookResult = ReturnType<typeof useCreditOptionsQuery>;
export type CreditOptionsLazyQueryHookResult = ReturnType<typeof useCreditOptionsLazyQuery>;
export type CreditOptionsQueryResult = Apollo.QueryResult<CreditOptionsQuery, CreditOptionsQueryVariables>;
export const CreateCreditDocument = gql`
    mutation CreateCredit($credit: CreditInput!) {
  createCredit(credit: $credit) {
    guid
  }
}
    `;
export type CreateCreditMutationFn = Apollo.MutationFunction<CreateCreditMutation, CreateCreditMutationVariables>;

/**
 * __useCreateCreditMutation__
 *
 * To run a mutation, you first call `useCreateCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditMutation, { data, loading, error }] = useCreateCreditMutation({
 *   variables: {
 *      credit: // value for 'credit'
 *   },
 * });
 */
export function useCreateCreditMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditMutation, CreateCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditMutation, CreateCreditMutationVariables>(CreateCreditDocument, options);
      }
export type CreateCreditMutationHookResult = ReturnType<typeof useCreateCreditMutation>;
export type CreateCreditMutationResult = Apollo.MutationResult<CreateCreditMutation>;
export type CreateCreditMutationOptions = Apollo.BaseMutationOptions<CreateCreditMutation, CreateCreditMutationVariables>;
export const UpdateCreditDocument = gql`
    mutation UpdateCredit($credit: CreditInput!, $creditGuid: String) {
  updateCredit(credit: $credit, creditGuid: $creditGuid) {
    ...CreditFragments
  }
}
    ${CreditFragmentsFragmentDoc}`;
export type UpdateCreditMutationFn = Apollo.MutationFunction<UpdateCreditMutation, UpdateCreditMutationVariables>;

/**
 * __useUpdateCreditMutation__
 *
 * To run a mutation, you first call `useUpdateCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditMutation, { data, loading, error }] = useUpdateCreditMutation({
 *   variables: {
 *      credit: // value for 'credit'
 *      creditGuid: // value for 'creditGuid'
 *   },
 * });
 */
export function useUpdateCreditMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditMutation, UpdateCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditMutation, UpdateCreditMutationVariables>(UpdateCreditDocument, options);
      }
export type UpdateCreditMutationHookResult = ReturnType<typeof useUpdateCreditMutation>;
export type UpdateCreditMutationResult = Apollo.MutationResult<UpdateCreditMutation>;
export type UpdateCreditMutationOptions = Apollo.BaseMutationOptions<UpdateCreditMutation, UpdateCreditMutationVariables>;
export const DeleteCreditDocument = gql`
    mutation DeleteCredit($creditGuid: String!) {
  deleteCredit(creditGuid: $creditGuid)
}
    `;
export type DeleteCreditMutationFn = Apollo.MutationFunction<DeleteCreditMutation, DeleteCreditMutationVariables>;

/**
 * __useDeleteCreditMutation__
 *
 * To run a mutation, you first call `useDeleteCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditMutation, { data, loading, error }] = useDeleteCreditMutation({
 *   variables: {
 *      creditGuid: // value for 'creditGuid'
 *   },
 * });
 */
export function useDeleteCreditMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreditMutation, DeleteCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreditMutation, DeleteCreditMutationVariables>(DeleteCreditDocument, options);
      }
export type DeleteCreditMutationHookResult = ReturnType<typeof useDeleteCreditMutation>;
export type DeleteCreditMutationResult = Apollo.MutationResult<DeleteCreditMutation>;
export type DeleteCreditMutationOptions = Apollo.BaseMutationOptions<DeleteCreditMutation, DeleteCreditMutationVariables>;
export const CreateCreditsForTitleDocument = gql`
    mutation CreateCreditsForTitle($creditRequests: [CreditForTitleInput!]!) {
  createCreditsForTitle(creditRequests: $creditRequests)
}
    `;
export type CreateCreditsForTitleMutationFn = Apollo.MutationFunction<CreateCreditsForTitleMutation, CreateCreditsForTitleMutationVariables>;

/**
 * __useCreateCreditsForTitleMutation__
 *
 * To run a mutation, you first call `useCreateCreditsForTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditsForTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditsForTitleMutation, { data, loading, error }] = useCreateCreditsForTitleMutation({
 *   variables: {
 *      creditRequests: // value for 'creditRequests'
 *   },
 * });
 */
export function useCreateCreditsForTitleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditsForTitleMutation, CreateCreditsForTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditsForTitleMutation, CreateCreditsForTitleMutationVariables>(CreateCreditsForTitleDocument, options);
      }
export type CreateCreditsForTitleMutationHookResult = ReturnType<typeof useCreateCreditsForTitleMutation>;
export type CreateCreditsForTitleMutationResult = Apollo.MutationResult<CreateCreditsForTitleMutation>;
export type CreateCreditsForTitleMutationOptions = Apollo.BaseMutationOptions<CreateCreditsForTitleMutation, CreateCreditsForTitleMutationVariables>;
export const KmiCreditsDocument = gql`
    query KMICredits($movieId: String!) {
  kmiCredits(movieId: $movieId) {
    customerName
    dropdownItemName
  }
}
    `;

/**
 * __useKmiCreditsQuery__
 *
 * To run a query within a React component, call `useKmiCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKmiCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKmiCreditsQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useKmiCreditsQuery(baseOptions: Apollo.QueryHookOptions<KmiCreditsQuery, KmiCreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KmiCreditsQuery, KmiCreditsQueryVariables>(KmiCreditsDocument, options);
      }
export function useKmiCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KmiCreditsQuery, KmiCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KmiCreditsQuery, KmiCreditsQueryVariables>(KmiCreditsDocument, options);
        }
export type KmiCreditsQueryHookResult = ReturnType<typeof useKmiCreditsQuery>;
export type KmiCreditsLazyQueryHookResult = ReturnType<typeof useKmiCreditsLazyQuery>;
export type KmiCreditsQueryResult = Apollo.QueryResult<KmiCreditsQuery, KmiCreditsQueryVariables>;
export const CustomersDocument = gql`
    query Customers($search: SearchCustomerInput) {
  customers(search: $search) {
    ...CustomerFragments
  }
}
    ${CustomerFragmentsFragmentDoc}`;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCustomersQuery(baseOptions?: Apollo.QueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
      }
export function useCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>;
export type CustomersQueryResult = Apollo.QueryResult<CustomersQuery, CustomersQueryVariables>;
export const CustomerDocument = gql`
    query Customer($customerGuid: String) {
  customer(customerGuid: $customerGuid) {
    ...CustomerFragments
  }
  customerCredits(customerGuid: $customerGuid) {
    ...CreditFragments
  }
  customerContacts(customerGuid: $customerGuid) {
    id
    title
  }
  customerTags(customerGuid: $customerGuid) {
    id
    title
  }
  customerCreditItems(customerGuid: $customerGuid) {
    creditGuid
    creditName
    customerName
    customerGuid
    titleName
    titleGuid
    itemNumber
    itemGuid
  }
}
    ${CustomerFragmentsFragmentDoc}
${CreditFragmentsFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      customerGuid: // value for 'customerGuid'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const CustomersPaginatedDocument = gql`
    query CustomersPaginated($search: SearchCustomerInput, $filter: FilterCustomersInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  customersPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...CustomerFragments
      }
    }
    totalGuids
  }
}
    ${CustomerFragmentsFragmentDoc}`;

/**
 * __useCustomersPaginatedQuery__
 *
 * To run a query within a React component, call `useCustomersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCustomersPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<CustomersPaginatedQuery, CustomersPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersPaginatedQuery, CustomersPaginatedQueryVariables>(CustomersPaginatedDocument, options);
      }
export function useCustomersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersPaginatedQuery, CustomersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersPaginatedQuery, CustomersPaginatedQueryVariables>(CustomersPaginatedDocument, options);
        }
export type CustomersPaginatedQueryHookResult = ReturnType<typeof useCustomersPaginatedQuery>;
export type CustomersPaginatedLazyQueryHookResult = ReturnType<typeof useCustomersPaginatedLazyQuery>;
export type CustomersPaginatedQueryResult = Apollo.QueryResult<CustomersPaginatedQuery, CustomersPaginatedQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($customer: CustomerInput!) {
  createCustomer(customer: $customer) {
    ...CustomerFragments
  }
}
    ${CustomerFragmentsFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($customer: CustomerInput!, $customerGuid: String) {
  updateCustomer(customer: $customer, customerGuid: $customerGuid) {
    ...CustomerFragments
  }
}
    ${CustomerFragmentsFragmentDoc}`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *      customerGuid: // value for 'customerGuid'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const MergeCustomersDocument = gql`
    mutation MergeCustomers($mergeCustomerData: MergeCustomerInput!) {
  mergeCustomers(mergeCustomerData: $mergeCustomerData)
}
    `;
export type MergeCustomersMutationFn = Apollo.MutationFunction<MergeCustomersMutation, MergeCustomersMutationVariables>;

/**
 * __useMergeCustomersMutation__
 *
 * To run a mutation, you first call `useMergeCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCustomersMutation, { data, loading, error }] = useMergeCustomersMutation({
 *   variables: {
 *      mergeCustomerData: // value for 'mergeCustomerData'
 *   },
 * });
 */
export function useMergeCustomersMutation(baseOptions?: Apollo.MutationHookOptions<MergeCustomersMutation, MergeCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCustomersMutation, MergeCustomersMutationVariables>(MergeCustomersDocument, options);
      }
export type MergeCustomersMutationHookResult = ReturnType<typeof useMergeCustomersMutation>;
export type MergeCustomersMutationResult = Apollo.MutationResult<MergeCustomersMutation>;
export type MergeCustomersMutationOptions = Apollo.BaseMutationOptions<MergeCustomersMutation, MergeCustomersMutationVariables>;
export const CustomerAutocompleteOptionsDocument = gql`
    query CustomerAutocompleteOptions($query: String) {
  customerOptions(query: $query) {
    id
    title
  }
}
    `;

/**
 * __useCustomerAutocompleteOptionsQuery__
 *
 * To run a query within a React component, call `useCustomerAutocompleteOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAutocompleteOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAutocompleteOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCustomerAutocompleteOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerAutocompleteOptionsQuery, CustomerAutocompleteOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerAutocompleteOptionsQuery, CustomerAutocompleteOptionsQueryVariables>(CustomerAutocompleteOptionsDocument, options);
      }
export function useCustomerAutocompleteOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerAutocompleteOptionsQuery, CustomerAutocompleteOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerAutocompleteOptionsQuery, CustomerAutocompleteOptionsQueryVariables>(CustomerAutocompleteOptionsDocument, options);
        }
export type CustomerAutocompleteOptionsQueryHookResult = ReturnType<typeof useCustomerAutocompleteOptionsQuery>;
export type CustomerAutocompleteOptionsLazyQueryHookResult = ReturnType<typeof useCustomerAutocompleteOptionsLazyQuery>;
export type CustomerAutocompleteOptionsQueryResult = Apollo.QueryResult<CustomerAutocompleteOptionsQuery, CustomerAutocompleteOptionsQueryVariables>;
export const CustomersOptionsDocument = gql`
    query CustomersOptions($customerGuids: [String!]!) {
  customersOptions(customerGuids: $customerGuids) {
    id
    title
  }
}
    `;

/**
 * __useCustomersOptionsQuery__
 *
 * To run a query within a React component, call `useCustomersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersOptionsQuery({
 *   variables: {
 *      customerGuids: // value for 'customerGuids'
 *   },
 * });
 */
export function useCustomersOptionsQuery(baseOptions: Apollo.QueryHookOptions<CustomersOptionsQuery, CustomersOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersOptionsQuery, CustomersOptionsQueryVariables>(CustomersOptionsDocument, options);
      }
export function useCustomersOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersOptionsQuery, CustomersOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersOptionsQuery, CustomersOptionsQueryVariables>(CustomersOptionsDocument, options);
        }
export type CustomersOptionsQueryHookResult = ReturnType<typeof useCustomersOptionsQuery>;
export type CustomersOptionsLazyQueryHookResult = ReturnType<typeof useCustomersOptionsLazyQuery>;
export type CustomersOptionsQueryResult = Apollo.QueryResult<CustomersOptionsQuery, CustomersOptionsQueryVariables>;
export const CustomerOptionsDocument = gql`
    query CustomerOptions {
  customerOptions {
    id
    title
  }
}
    `;

/**
 * __useCustomerOptionsQuery__
 *
 * To run a query within a React component, call `useCustomerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerOptionsQuery, CustomerOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOptionsQuery, CustomerOptionsQueryVariables>(CustomerOptionsDocument, options);
      }
export function useCustomerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOptionsQuery, CustomerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOptionsQuery, CustomerOptionsQueryVariables>(CustomerOptionsDocument, options);
        }
export type CustomerOptionsQueryHookResult = ReturnType<typeof useCustomerOptionsQuery>;
export type CustomerOptionsLazyQueryHookResult = ReturnType<typeof useCustomerOptionsLazyQuery>;
export type CustomerOptionsQueryResult = Apollo.QueryResult<CustomerOptionsQuery, CustomerOptionsQueryVariables>;
export const UserOptionsDocument = gql`
    query UserOptions {
  userOptions {
    id
    title
  }
}
    `;

/**
 * __useUserOptionsQuery__
 *
 * To run a query within a React component, call `useUserOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserOptionsQuery(baseOptions?: Apollo.QueryHookOptions<UserOptionsQuery, UserOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserOptionsQuery, UserOptionsQueryVariables>(UserOptionsDocument, options);
      }
export function useUserOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserOptionsQuery, UserOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserOptionsQuery, UserOptionsQueryVariables>(UserOptionsDocument, options);
        }
export type UserOptionsQueryHookResult = ReturnType<typeof useUserOptionsQuery>;
export type UserOptionsLazyQueryHookResult = ReturnType<typeof useUserOptionsLazyQuery>;
export type UserOptionsQueryResult = Apollo.QueryResult<UserOptionsQuery, UserOptionsQueryVariables>;
export const AllUserOptionsDocument = gql`
    query AllUserOptions {
  allUserOptions {
    id
    title
  }
}
    `;

/**
 * __useAllUserOptionsQuery__
 *
 * To run a query within a React component, call `useAllUserOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AllUserOptionsQuery, AllUserOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserOptionsQuery, AllUserOptionsQueryVariables>(AllUserOptionsDocument, options);
      }
export function useAllUserOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserOptionsQuery, AllUserOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserOptionsQuery, AllUserOptionsQueryVariables>(AllUserOptionsDocument, options);
        }
export type AllUserOptionsQueryHookResult = ReturnType<typeof useAllUserOptionsQuery>;
export type AllUserOptionsLazyQueryHookResult = ReturnType<typeof useAllUserOptionsLazyQuery>;
export type AllUserOptionsQueryResult = Apollo.QueryResult<AllUserOptionsQuery, AllUserOptionsQueryVariables>;
export const CustomerAndTagOptionsDocument = gql`
    query CustomerAndTagOptions {
  customerOptions {
    id
    title
  }
  customerTagsOptions {
    id
    title
  }
}
    `;

/**
 * __useCustomerAndTagOptionsQuery__
 *
 * To run a query within a React component, call `useCustomerAndTagOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAndTagOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAndTagOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerAndTagOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerAndTagOptionsQuery, CustomerAndTagOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerAndTagOptionsQuery, CustomerAndTagOptionsQueryVariables>(CustomerAndTagOptionsDocument, options);
      }
export function useCustomerAndTagOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerAndTagOptionsQuery, CustomerAndTagOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerAndTagOptionsQuery, CustomerAndTagOptionsQueryVariables>(CustomerAndTagOptionsDocument, options);
        }
export type CustomerAndTagOptionsQueryHookResult = ReturnType<typeof useCustomerAndTagOptionsQuery>;
export type CustomerAndTagOptionsLazyQueryHookResult = ReturnType<typeof useCustomerAndTagOptionsLazyQuery>;
export type CustomerAndTagOptionsQueryResult = Apollo.QueryResult<CustomerAndTagOptionsQuery, CustomerAndTagOptionsQueryVariables>;
export const CheckIfNameExistsDocument = gql`
    query CheckIfNameExists($name: String!) {
  checkIfNameExists(name: $name)
}
    `;

/**
 * __useCheckIfNameExistsQuery__
 *
 * To run a query within a React component, call `useCheckIfNameExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfNameExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfNameExistsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckIfNameExistsQuery(baseOptions: Apollo.QueryHookOptions<CheckIfNameExistsQuery, CheckIfNameExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfNameExistsQuery, CheckIfNameExistsQueryVariables>(CheckIfNameExistsDocument, options);
      }
export function useCheckIfNameExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfNameExistsQuery, CheckIfNameExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfNameExistsQuery, CheckIfNameExistsQueryVariables>(CheckIfNameExistsDocument, options);
        }
export type CheckIfNameExistsQueryHookResult = ReturnType<typeof useCheckIfNameExistsQuery>;
export type CheckIfNameExistsLazyQueryHookResult = ReturnType<typeof useCheckIfNameExistsLazyQuery>;
export type CheckIfNameExistsQueryResult = Apollo.QueryResult<CheckIfNameExistsQuery, CheckIfNameExistsQueryVariables>;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($customerGuid: String!) {
  deleteCustomer(customerGuid: $customerGuid)
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      customerGuid: // value for 'customerGuid'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const DashboardDocument = gql`
    query Dashboard {
  origins {
    ...OriginFragments
  }
  itemCollections {
    ...ItemCollectionFragments
  }
}
    ${OriginFragmentsFragmentDoc}
${ItemCollectionFragmentsFragmentDoc}`;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardQuery(baseOptions?: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const FormForItemTypeDocument = gql`
    query FormForItemType($itemTypeGuid: String!) {
  formForItemType(itemTypeGuid: $itemTypeGuid) {
    ...FormFragments
  }
}
    ${FormFragmentsFragmentDoc}`;

/**
 * __useFormForItemTypeQuery__
 *
 * To run a query within a React component, call `useFormForItemTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormForItemTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormForItemTypeQuery({
 *   variables: {
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useFormForItemTypeQuery(baseOptions: Apollo.QueryHookOptions<FormForItemTypeQuery, FormForItemTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormForItemTypeQuery, FormForItemTypeQueryVariables>(FormForItemTypeDocument, options);
      }
export function useFormForItemTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormForItemTypeQuery, FormForItemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormForItemTypeQuery, FormForItemTypeQueryVariables>(FormForItemTypeDocument, options);
        }
export type FormForItemTypeQueryHookResult = ReturnType<typeof useFormForItemTypeQuery>;
export type FormForItemTypeLazyQueryHookResult = ReturnType<typeof useFormForItemTypeLazyQuery>;
export type FormForItemTypeQueryResult = Apollo.QueryResult<FormForItemTypeQuery, FormForItemTypeQueryVariables>;
export const FormsForMuseumDocument = gql`
    query FormsForMuseum {
  formsForMuseum {
    guid
    name
    code
  }
}
    `;

/**
 * __useFormsForMuseumQuery__
 *
 * To run a query within a React component, call `useFormsForMuseumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormsForMuseumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormsForMuseumQuery({
 *   variables: {
 *   },
 * });
 */
export function useFormsForMuseumQuery(baseOptions?: Apollo.QueryHookOptions<FormsForMuseumQuery, FormsForMuseumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormsForMuseumQuery, FormsForMuseumQueryVariables>(FormsForMuseumDocument, options);
      }
export function useFormsForMuseumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormsForMuseumQuery, FormsForMuseumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormsForMuseumQuery, FormsForMuseumQueryVariables>(FormsForMuseumDocument, options);
        }
export type FormsForMuseumQueryHookResult = ReturnType<typeof useFormsForMuseumQuery>;
export type FormsForMuseumLazyQueryHookResult = ReturnType<typeof useFormsForMuseumLazyQuery>;
export type FormsForMuseumQueryResult = Apollo.QueryResult<FormsForMuseumQuery, FormsForMuseumQueryVariables>;
export const ItemsDocument = gql`
    query Items($search: SearchItemInput) {
  items(search: $search) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;

/**
 * __useItemsQuery__
 *
 * To run a query within a React component, call `useItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useItemsQuery(baseOptions?: Apollo.QueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
      }
export function useItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
export type ItemsQueryHookResult = ReturnType<typeof useItemsQuery>;
export type ItemsLazyQueryHookResult = ReturnType<typeof useItemsLazyQuery>;
export type ItemsQueryResult = Apollo.QueryResult<ItemsQuery, ItemsQueryVariables>;
export const ItemDocument = gql`
    query Item($itemGuid: String) {
  item(itemGuid: $itemGuid) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;

/**
 * __useItemQuery__
 *
 * To run a query within a React component, call `useItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemQuery({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useItemQuery(baseOptions?: Apollo.QueryHookOptions<ItemQuery, ItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemQuery, ItemQueryVariables>(ItemDocument, options);
      }
export function useItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemQuery, ItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemQuery, ItemQueryVariables>(ItemDocument, options);
        }
export type ItemQueryHookResult = ReturnType<typeof useItemQuery>;
export type ItemLazyQueryHookResult = ReturnType<typeof useItemLazyQuery>;
export type ItemQueryResult = Apollo.QueryResult<ItemQuery, ItemQueryVariables>;
export const ItemsPaginatedDocument = gql`
    query ItemsPaginated($search: SearchItemInput, $filter: FilterItemInput, $pagination: PaginationInput, $type: String, $sort: String, $sortBy: String) {
  itemsPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    type: $type
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...ItemFragments
      }
    }
    totalGuids
  }
}
    ${ItemFragmentsFragmentDoc}`;

/**
 * __useItemsPaginatedQuery__
 *
 * To run a query within a React component, call `useItemsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useItemsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<ItemsPaginatedQuery, ItemsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsPaginatedQuery, ItemsPaginatedQueryVariables>(ItemsPaginatedDocument, options);
      }
export function useItemsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsPaginatedQuery, ItemsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsPaginatedQuery, ItemsPaginatedQueryVariables>(ItemsPaginatedDocument, options);
        }
export type ItemsPaginatedQueryHookResult = ReturnType<typeof useItemsPaginatedQuery>;
export type ItemsPaginatedLazyQueryHookResult = ReturnType<typeof useItemsPaginatedLazyQuery>;
export type ItemsPaginatedQueryResult = Apollo.QueryResult<ItemsPaginatedQuery, ItemsPaginatedQueryVariables>;
export const SortedItemsGuidsDocument = gql`
    query SortedItemsGuids($selectedGuids: [String!]!, $sort: String!, $sortBy: String!) {
  sortedItemsGuids(selectedGuids: $selectedGuids, sort: $sort, sortBy: $sortBy)
}
    `;

/**
 * __useSortedItemsGuidsQuery__
 *
 * To run a query within a React component, call `useSortedItemsGuidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSortedItemsGuidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSortedItemsGuidsQuery({
 *   variables: {
 *      selectedGuids: // value for 'selectedGuids'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useSortedItemsGuidsQuery(baseOptions: Apollo.QueryHookOptions<SortedItemsGuidsQuery, SortedItemsGuidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SortedItemsGuidsQuery, SortedItemsGuidsQueryVariables>(SortedItemsGuidsDocument, options);
      }
export function useSortedItemsGuidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SortedItemsGuidsQuery, SortedItemsGuidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SortedItemsGuidsQuery, SortedItemsGuidsQueryVariables>(SortedItemsGuidsDocument, options);
        }
export type SortedItemsGuidsQueryHookResult = ReturnType<typeof useSortedItemsGuidsQuery>;
export type SortedItemsGuidsLazyQueryHookResult = ReturnType<typeof useSortedItemsGuidsLazyQuery>;
export type SortedItemsGuidsQueryResult = Apollo.QueryResult<SortedItemsGuidsQuery, SortedItemsGuidsQueryVariables>;
export const DeleteItemDocument = gql`
    mutation DeleteItem($itemGuid: String!) {
  deleteItem(itemGuid: $itemGuid)
}
    `;
export type DeleteItemMutationFn = Apollo.MutationFunction<DeleteItemMutation, DeleteItemMutationVariables>;

/**
 * __useDeleteItemMutation__
 *
 * To run a mutation, you first call `useDeleteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemMutation, { data, loading, error }] = useDeleteItemMutation({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useDeleteItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemMutation, DeleteItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemMutation, DeleteItemMutationVariables>(DeleteItemDocument, options);
      }
export type DeleteItemMutationHookResult = ReturnType<typeof useDeleteItemMutation>;
export type DeleteItemMutationResult = Apollo.MutationResult<DeleteItemMutation>;
export type DeleteItemMutationOptions = Apollo.BaseMutationOptions<DeleteItemMutation, DeleteItemMutationVariables>;
export const DeleteManyItemsDocument = gql`
    mutation DeleteManyItems($itemGuids: [String!]!) {
  deleteManyItems(itemGuids: $itemGuids)
}
    `;
export type DeleteManyItemsMutationFn = Apollo.MutationFunction<DeleteManyItemsMutation, DeleteManyItemsMutationVariables>;

/**
 * __useDeleteManyItemsMutation__
 *
 * To run a mutation, you first call `useDeleteManyItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyItemsMutation, { data, loading, error }] = useDeleteManyItemsMutation({
 *   variables: {
 *      itemGuids: // value for 'itemGuids'
 *   },
 * });
 */
export function useDeleteManyItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManyItemsMutation, DeleteManyItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManyItemsMutation, DeleteManyItemsMutationVariables>(DeleteManyItemsDocument, options);
      }
export type DeleteManyItemsMutationHookResult = ReturnType<typeof useDeleteManyItemsMutation>;
export type DeleteManyItemsMutationResult = Apollo.MutationResult<DeleteManyItemsMutation>;
export type DeleteManyItemsMutationOptions = Apollo.BaseMutationOptions<DeleteManyItemsMutation, DeleteManyItemsMutationVariables>;
export const DiscLocationsDocument = gql`
    query DiscLocations {
  discLocationOptions {
    id
    title
  }
}
    `;

/**
 * __useDiscLocationsQuery__
 *
 * To run a query within a React component, call `useDiscLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscLocationsQuery(baseOptions?: Apollo.QueryHookOptions<DiscLocationsQuery, DiscLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscLocationsQuery, DiscLocationsQueryVariables>(DiscLocationsDocument, options);
      }
export function useDiscLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscLocationsQuery, DiscLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscLocationsQuery, DiscLocationsQueryVariables>(DiscLocationsDocument, options);
        }
export type DiscLocationsQueryHookResult = ReturnType<typeof useDiscLocationsQuery>;
export type DiscLocationsLazyQueryHookResult = ReturnType<typeof useDiscLocationsLazyQuery>;
export type DiscLocationsQueryResult = Apollo.QueryResult<DiscLocationsQuery, DiscLocationsQueryVariables>;
export const ItemDropDownOptionsDocument = gql`
    query ItemDropDownOptions {
  subtypeOptions {
    id
    title
  }
  originOptions {
    id
    title
  }
  itemCollectionsOptions {
    id
    title
  }
}
    `;

/**
 * __useItemDropDownOptionsQuery__
 *
 * To run a query within a React component, call `useItemDropDownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemDropDownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemDropDownOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemDropDownOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ItemDropDownOptionsQuery, ItemDropDownOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemDropDownOptionsQuery, ItemDropDownOptionsQueryVariables>(ItemDropDownOptionsDocument, options);
      }
export function useItemDropDownOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemDropDownOptionsQuery, ItemDropDownOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemDropDownOptionsQuery, ItemDropDownOptionsQueryVariables>(ItemDropDownOptionsDocument, options);
        }
export type ItemDropDownOptionsQueryHookResult = ReturnType<typeof useItemDropDownOptionsQuery>;
export type ItemDropDownOptionsLazyQueryHookResult = ReturnType<typeof useItemDropDownOptionsLazyQuery>;
export type ItemDropDownOptionsQueryResult = Apollo.QueryResult<ItemDropDownOptionsQuery, ItemDropDownOptionsQueryVariables>;
export const ConnectedItemsDocument = gql`
    query ConnectedItems($itemGuid: String!) {
  getConnectedItems(itemGuid: $itemGuid) {
    itemGuid
    itemInfoResponse {
      guid
      itemTypeGuid
      itemNumber
      isItemCopyOfConnectedItem
      hasContentAnalysis
    }
  }
}
    `;

/**
 * __useConnectedItemsQuery__
 *
 * To run a query within a React component, call `useConnectedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedItemsQuery({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useConnectedItemsQuery(baseOptions: Apollo.QueryHookOptions<ConnectedItemsQuery, ConnectedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedItemsQuery, ConnectedItemsQueryVariables>(ConnectedItemsDocument, options);
      }
export function useConnectedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedItemsQuery, ConnectedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedItemsQuery, ConnectedItemsQueryVariables>(ConnectedItemsDocument, options);
        }
export type ConnectedItemsQueryHookResult = ReturnType<typeof useConnectedItemsQuery>;
export type ConnectedItemsLazyQueryHookResult = ReturnType<typeof useConnectedItemsLazyQuery>;
export type ConnectedItemsQueryResult = Apollo.QueryResult<ConnectedItemsQuery, ConnectedItemsQueryVariables>;
export const CreateConnectedItemsDocument = gql`
    mutation CreateConnectedItems($connectedItems: ConnectedItemsInput!) {
  createConnectedItem(connectedItems: $connectedItems) {
    itemGuid
    connectedItems
  }
}
    `;
export type CreateConnectedItemsMutationFn = Apollo.MutationFunction<CreateConnectedItemsMutation, CreateConnectedItemsMutationVariables>;

/**
 * __useCreateConnectedItemsMutation__
 *
 * To run a mutation, you first call `useCreateConnectedItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectedItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectedItemsMutation, { data, loading, error }] = useCreateConnectedItemsMutation({
 *   variables: {
 *      connectedItems: // value for 'connectedItems'
 *   },
 * });
 */
export function useCreateConnectedItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectedItemsMutation, CreateConnectedItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectedItemsMutation, CreateConnectedItemsMutationVariables>(CreateConnectedItemsDocument, options);
      }
export type CreateConnectedItemsMutationHookResult = ReturnType<typeof useCreateConnectedItemsMutation>;
export type CreateConnectedItemsMutationResult = Apollo.MutationResult<CreateConnectedItemsMutation>;
export type CreateConnectedItemsMutationOptions = Apollo.BaseMutationOptions<CreateConnectedItemsMutation, CreateConnectedItemsMutationVariables>;
export const DeleteConnectedItemDocument = gql`
    mutation DeleteConnectedItem($itemGuid: String!, $connectedItemGuid: String!) {
  deleteConnectedItem(itemGuid: $itemGuid, connectedItemGuid: $connectedItemGuid)
}
    `;
export type DeleteConnectedItemMutationFn = Apollo.MutationFunction<DeleteConnectedItemMutation, DeleteConnectedItemMutationVariables>;

/**
 * __useDeleteConnectedItemMutation__
 *
 * To run a mutation, you first call `useDeleteConnectedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectedItemMutation, { data, loading, error }] = useDeleteConnectedItemMutation({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *      connectedItemGuid: // value for 'connectedItemGuid'
 *   },
 * });
 */
export function useDeleteConnectedItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectedItemMutation, DeleteConnectedItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectedItemMutation, DeleteConnectedItemMutationVariables>(DeleteConnectedItemDocument, options);
      }
export type DeleteConnectedItemMutationHookResult = ReturnType<typeof useDeleteConnectedItemMutation>;
export type DeleteConnectedItemMutationResult = Apollo.MutationResult<DeleteConnectedItemMutation>;
export type DeleteConnectedItemMutationOptions = Apollo.BaseMutationOptions<DeleteConnectedItemMutation, DeleteConnectedItemMutationVariables>;
export const CreateCopyItemsDocument = gql`
    mutation CreateCopyItems($copyItems: CopyItemsInput!) {
  createCopyItems(copyItems: $copyItems) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;
export type CreateCopyItemsMutationFn = Apollo.MutationFunction<CreateCopyItemsMutation, CreateCopyItemsMutationVariables>;

/**
 * __useCreateCopyItemsMutation__
 *
 * To run a mutation, you first call `useCreateCopyItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCopyItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCopyItemsMutation, { data, loading, error }] = useCreateCopyItemsMutation({
 *   variables: {
 *      copyItems: // value for 'copyItems'
 *   },
 * });
 */
export function useCreateCopyItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCopyItemsMutation, CreateCopyItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCopyItemsMutation, CreateCopyItemsMutationVariables>(CreateCopyItemsDocument, options);
      }
export type CreateCopyItemsMutationHookResult = ReturnType<typeof useCreateCopyItemsMutation>;
export type CreateCopyItemsMutationResult = Apollo.MutationResult<CreateCopyItemsMutation>;
export type CreateCopyItemsMutationOptions = Apollo.BaseMutationOptions<CreateCopyItemsMutation, CreateCopyItemsMutationVariables>;
export const ItemsInCollectionDocument = gql`
    query ItemsInCollection($itemCollectionGuid: String!, $offset: Int, $limit: Int) {
  itemsInCollection(
    itemCollectionGuid: $itemCollectionGuid
    offset: $offset
    limit: $limit
  ) {
    guid
    title
    heiti
    itemTypeGuid
    itemTypeName
    itemNumber
    isItemCopyOfConnectedItem
    coldLocationsName
    locationsName
    stadaSkraningar
    tungumalName
    itemJson
  }
}
    `;

/**
 * __useItemsInCollectionQuery__
 *
 * To run a query within a React component, call `useItemsInCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsInCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsInCollectionQuery({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useItemsInCollectionQuery(baseOptions: Apollo.QueryHookOptions<ItemsInCollectionQuery, ItemsInCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsInCollectionQuery, ItemsInCollectionQueryVariables>(ItemsInCollectionDocument, options);
      }
export function useItemsInCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsInCollectionQuery, ItemsInCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsInCollectionQuery, ItemsInCollectionQueryVariables>(ItemsInCollectionDocument, options);
        }
export type ItemsInCollectionQueryHookResult = ReturnType<typeof useItemsInCollectionQuery>;
export type ItemsInCollectionLazyQueryHookResult = ReturnType<typeof useItemsInCollectionLazyQuery>;
export type ItemsInCollectionQueryResult = Apollo.QueryResult<ItemsInCollectionQuery, ItemsInCollectionQueryVariables>;
export const ItemCountFromCollectionDocument = gql`
    query ItemCountFromCollection($itemCollectionGuid: String!) {
  itemCountFromCollection(itemCollectionGuid: $itemCollectionGuid)
}
    `;

/**
 * __useItemCountFromCollectionQuery__
 *
 * To run a query within a React component, call `useItemCountFromCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCountFromCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCountFromCollectionQuery({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *   },
 * });
 */
export function useItemCountFromCollectionQuery(baseOptions: Apollo.QueryHookOptions<ItemCountFromCollectionQuery, ItemCountFromCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCountFromCollectionQuery, ItemCountFromCollectionQueryVariables>(ItemCountFromCollectionDocument, options);
      }
export function useItemCountFromCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCountFromCollectionQuery, ItemCountFromCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCountFromCollectionQuery, ItemCountFromCollectionQueryVariables>(ItemCountFromCollectionDocument, options);
        }
export type ItemCountFromCollectionQueryHookResult = ReturnType<typeof useItemCountFromCollectionQuery>;
export type ItemCountFromCollectionLazyQueryHookResult = ReturnType<typeof useItemCountFromCollectionLazyQuery>;
export type ItemCountFromCollectionQueryResult = Apollo.QueryResult<ItemCountFromCollectionQuery, ItemCountFromCollectionQueryVariables>;
export const ItemsInTitleDocument = gql`
    query ItemsInTitle($titleGuid: String!) {
  itemsInTitle(titleGuid: $titleGuid) {
    guid
    title
    heiti
    itemTypeGuid
    itemTypeName
    itemNumber
    isItemCopyOfConnectedItem
    hasContentAnalysis
  }
}
    `;

/**
 * __useItemsInTitleQuery__
 *
 * To run a query within a React component, call `useItemsInTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsInTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsInTitleQuery({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useItemsInTitleQuery(baseOptions: Apollo.QueryHookOptions<ItemsInTitleQuery, ItemsInTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsInTitleQuery, ItemsInTitleQueryVariables>(ItemsInTitleDocument, options);
      }
export function useItemsInTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsInTitleQuery, ItemsInTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsInTitleQuery, ItemsInTitleQueryVariables>(ItemsInTitleDocument, options);
        }
export type ItemsInTitleQueryHookResult = ReturnType<typeof useItemsInTitleQuery>;
export type ItemsInTitleLazyQueryHookResult = ReturnType<typeof useItemsInTitleLazyQuery>;
export type ItemsInTitleQueryResult = Apollo.QueryResult<ItemsInTitleQuery, ItemsInTitleQueryVariables>;
export const ItemsInOriginalTitleDocument = gql`
    query ItemsInOriginalTitle($originalTitleGuid: String!) {
  itemsInOriginalTitle(originalTitleGuid: $originalTitleGuid) {
    itemGuid
    itemNumber
    itemTypeName
    titleGuid
    titleName
    hasContentAnalysis
  }
}
    `;

/**
 * __useItemsInOriginalTitleQuery__
 *
 * To run a query within a React component, call `useItemsInOriginalTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsInOriginalTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsInOriginalTitleQuery({
 *   variables: {
 *      originalTitleGuid: // value for 'originalTitleGuid'
 *   },
 * });
 */
export function useItemsInOriginalTitleQuery(baseOptions: Apollo.QueryHookOptions<ItemsInOriginalTitleQuery, ItemsInOriginalTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsInOriginalTitleQuery, ItemsInOriginalTitleQueryVariables>(ItemsInOriginalTitleDocument, options);
      }
export function useItemsInOriginalTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsInOriginalTitleQuery, ItemsInOriginalTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsInOriginalTitleQuery, ItemsInOriginalTitleQueryVariables>(ItemsInOriginalTitleDocument, options);
        }
export type ItemsInOriginalTitleQueryHookResult = ReturnType<typeof useItemsInOriginalTitleQuery>;
export type ItemsInOriginalTitleLazyQueryHookResult = ReturnType<typeof useItemsInOriginalTitleLazyQuery>;
export type ItemsInOriginalTitleQueryResult = Apollo.QueryResult<ItemsInOriginalTitleQuery, ItemsInOriginalTitleQueryVariables>;
export const OriginForItemCollectionOptionDocument = gql`
    query OriginForItemCollectionOption($itemCollectionGuid: String!) {
  originForItemCollectionOption(itemCollectionGuid: $itemCollectionGuid) {
    id
    title
  }
}
    `;

/**
 * __useOriginForItemCollectionOptionQuery__
 *
 * To run a query within a React component, call `useOriginForItemCollectionOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginForItemCollectionOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginForItemCollectionOptionQuery({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *   },
 * });
 */
export function useOriginForItemCollectionOptionQuery(baseOptions: Apollo.QueryHookOptions<OriginForItemCollectionOptionQuery, OriginForItemCollectionOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginForItemCollectionOptionQuery, OriginForItemCollectionOptionQueryVariables>(OriginForItemCollectionOptionDocument, options);
      }
export function useOriginForItemCollectionOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginForItemCollectionOptionQuery, OriginForItemCollectionOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginForItemCollectionOptionQuery, OriginForItemCollectionOptionQueryVariables>(OriginForItemCollectionOptionDocument, options);
        }
export type OriginForItemCollectionOptionQueryHookResult = ReturnType<typeof useOriginForItemCollectionOptionQuery>;
export type OriginForItemCollectionOptionLazyQueryHookResult = ReturnType<typeof useOriginForItemCollectionOptionLazyQuery>;
export type OriginForItemCollectionOptionQueryResult = Apollo.QueryResult<OriginForItemCollectionOptionQuery, OriginForItemCollectionOptionQueryVariables>;
export const AutoCompleteOptionsDocument = gql`
    query AutoCompleteOptions($query: String) {
  originNumberOptions(query: $query) {
    id
    title
  }
  itemCollectionNumberOptions(query: $query) {
    id
    title
  }
  itemNumberOptions(query: $query) {
    id
    title
  }
}
    `;

/**
 * __useAutoCompleteOptionsQuery__
 *
 * To run a query within a React component, call `useAutoCompleteOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoCompleteOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoCompleteOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAutoCompleteOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AutoCompleteOptionsQuery, AutoCompleteOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutoCompleteOptionsQuery, AutoCompleteOptionsQueryVariables>(AutoCompleteOptionsDocument, options);
      }
export function useAutoCompleteOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutoCompleteOptionsQuery, AutoCompleteOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutoCompleteOptionsQuery, AutoCompleteOptionsQueryVariables>(AutoCompleteOptionsDocument, options);
        }
export type AutoCompleteOptionsQueryHookResult = ReturnType<typeof useAutoCompleteOptionsQuery>;
export type AutoCompleteOptionsLazyQueryHookResult = ReturnType<typeof useAutoCompleteOptionsLazyQuery>;
export type AutoCompleteOptionsQueryResult = Apollo.QueryResult<AutoCompleteOptionsQuery, AutoCompleteOptionsQueryVariables>;
export const BreadcrumbInfoDocument = gql`
    query BreadcrumbInfo($itemCollectionGuid: String!) {
  getCollectionAndOriginNumber(itemCollectionGuid: $itemCollectionGuid) {
    originGuid
    originNumber
    originName
    itemCollectionNumber
    itemCollectionName
  }
}
    `;

/**
 * __useBreadcrumbInfoQuery__
 *
 * To run a query within a React component, call `useBreadcrumbInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBreadcrumbInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBreadcrumbInfoQuery({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *   },
 * });
 */
export function useBreadcrumbInfoQuery(baseOptions: Apollo.QueryHookOptions<BreadcrumbInfoQuery, BreadcrumbInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BreadcrumbInfoQuery, BreadcrumbInfoQueryVariables>(BreadcrumbInfoDocument, options);
      }
export function useBreadcrumbInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BreadcrumbInfoQuery, BreadcrumbInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BreadcrumbInfoQuery, BreadcrumbInfoQueryVariables>(BreadcrumbInfoDocument, options);
        }
export type BreadcrumbInfoQueryHookResult = ReturnType<typeof useBreadcrumbInfoQuery>;
export type BreadcrumbInfoLazyQueryHookResult = ReturnType<typeof useBreadcrumbInfoLazyQuery>;
export type BreadcrumbInfoQueryResult = Apollo.QueryResult<BreadcrumbInfoQuery, BreadcrumbInfoQueryVariables>;
export const CreateItemDocument = gql`
    mutation CreateItem($item: ItemInput!) {
  createItem(item: $item) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;
export type CreateItemMutationFn = Apollo.MutationFunction<CreateItemMutation, CreateItemMutationVariables>;

/**
 * __useCreateItemMutation__
 *
 * To run a mutation, you first call `useCreateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemMutation, { data, loading, error }] = useCreateItemMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useCreateItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemMutation, CreateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemMutation, CreateItemMutationVariables>(CreateItemDocument, options);
      }
export type CreateItemMutationHookResult = ReturnType<typeof useCreateItemMutation>;
export type CreateItemMutationResult = Apollo.MutationResult<CreateItemMutation>;
export type CreateItemMutationOptions = Apollo.BaseMutationOptions<CreateItemMutation, CreateItemMutationVariables>;
export const UpdateItemDocument = gql`
    mutation UpdateItem($item: ItemInput!, $itemGuid: String) {
  updateItem(item: $item, itemGuid: $itemGuid) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;
export type UpdateItemMutationFn = Apollo.MutationFunction<UpdateItemMutation, UpdateItemMutationVariables>;

/**
 * __useUpdateItemMutation__
 *
 * To run a mutation, you first call `useUpdateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemMutation, { data, loading, error }] = useUpdateItemMutation({
 *   variables: {
 *      item: // value for 'item'
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useUpdateItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemMutation, UpdateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemMutation, UpdateItemMutationVariables>(UpdateItemDocument, options);
      }
export type UpdateItemMutationHookResult = ReturnType<typeof useUpdateItemMutation>;
export type UpdateItemMutationResult = Apollo.MutationResult<UpdateItemMutation>;
export type UpdateItemMutationOptions = Apollo.BaseMutationOptions<UpdateItemMutation, UpdateItemMutationVariables>;
export const ItemTypesForItemCollectionTypeDocument = gql`
    query ItemTypesForItemCollectionType($itemCollectionGuid: String) {
  itemTypesForItemCollectionType(itemCollectionGuid: $itemCollectionGuid) {
    id
    title
  }
}
    `;

/**
 * __useItemTypesForItemCollectionTypeQuery__
 *
 * To run a query within a React component, call `useItemTypesForItemCollectionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTypesForItemCollectionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTypesForItemCollectionTypeQuery({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *   },
 * });
 */
export function useItemTypesForItemCollectionTypeQuery(baseOptions?: Apollo.QueryHookOptions<ItemTypesForItemCollectionTypeQuery, ItemTypesForItemCollectionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemTypesForItemCollectionTypeQuery, ItemTypesForItemCollectionTypeQueryVariables>(ItemTypesForItemCollectionTypeDocument, options);
      }
export function useItemTypesForItemCollectionTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemTypesForItemCollectionTypeQuery, ItemTypesForItemCollectionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemTypesForItemCollectionTypeQuery, ItemTypesForItemCollectionTypeQueryVariables>(ItemTypesForItemCollectionTypeDocument, options);
        }
export type ItemTypesForItemCollectionTypeQueryHookResult = ReturnType<typeof useItemTypesForItemCollectionTypeQuery>;
export type ItemTypesForItemCollectionTypeLazyQueryHookResult = ReturnType<typeof useItemTypesForItemCollectionTypeLazyQuery>;
export type ItemTypesForItemCollectionTypeQueryResult = Apollo.QueryResult<ItemTypesForItemCollectionTypeQuery, ItemTypesForItemCollectionTypeQueryVariables>;
export const CreateManyItemsDocument = gql`
    mutation CreateManyItems($itemCount: Int!, $itemCollectionGuid: String!, $itemTypeGuid: String, $titleGuid: String, $locations: LocationsGuidInput, $comment: String) {
  createManyItems(
    itemCount: $itemCount
    itemCollectionGuid: $itemCollectionGuid
    itemTypeGuid: $itemTypeGuid
    titleGuid: $titleGuid
    locations: $locations
    comment: $comment
  ) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;
export type CreateManyItemsMutationFn = Apollo.MutationFunction<CreateManyItemsMutation, CreateManyItemsMutationVariables>;

/**
 * __useCreateManyItemsMutation__
 *
 * To run a mutation, you first call `useCreateManyItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyItemsMutation, { data, loading, error }] = useCreateManyItemsMutation({
 *   variables: {
 *      itemCount: // value for 'itemCount'
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *      titleGuid: // value for 'titleGuid'
 *      locations: // value for 'locations'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateManyItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateManyItemsMutation, CreateManyItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManyItemsMutation, CreateManyItemsMutationVariables>(CreateManyItemsDocument, options);
      }
export type CreateManyItemsMutationHookResult = ReturnType<typeof useCreateManyItemsMutation>;
export type CreateManyItemsMutationResult = Apollo.MutationResult<CreateManyItemsMutation>;
export type CreateManyItemsMutationOptions = Apollo.BaseMutationOptions<CreateManyItemsMutation, CreateManyItemsMutationVariables>;
export const UpdateItemsRegistrationDocument = gql`
    mutation UpdateItemsRegistration($itemCollectionGuid: String!, $state: Boolean!) {
  updateItemsRegistration(itemCollectionGuid: $itemCollectionGuid, state: $state) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;
export type UpdateItemsRegistrationMutationFn = Apollo.MutationFunction<UpdateItemsRegistrationMutation, UpdateItemsRegistrationMutationVariables>;

/**
 * __useUpdateItemsRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateItemsRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemsRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemsRegistrationMutation, { data, loading, error }] = useUpdateItemsRegistrationMutation({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateItemsRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemsRegistrationMutation, UpdateItemsRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemsRegistrationMutation, UpdateItemsRegistrationMutationVariables>(UpdateItemsRegistrationDocument, options);
      }
export type UpdateItemsRegistrationMutationHookResult = ReturnType<typeof useUpdateItemsRegistrationMutation>;
export type UpdateItemsRegistrationMutationResult = Apollo.MutationResult<UpdateItemsRegistrationMutation>;
export type UpdateItemsRegistrationMutationOptions = Apollo.BaseMutationOptions<UpdateItemsRegistrationMutation, UpdateItemsRegistrationMutationVariables>;
export const StickerTypesDocument = gql`
    query StickerTypes {
  stickerTypes {
    id
    title
  }
}
    `;

/**
 * __useStickerTypesQuery__
 *
 * To run a query within a React component, call `useStickerTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStickerTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStickerTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStickerTypesQuery(baseOptions?: Apollo.QueryHookOptions<StickerTypesQuery, StickerTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StickerTypesQuery, StickerTypesQueryVariables>(StickerTypesDocument, options);
      }
export function useStickerTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StickerTypesQuery, StickerTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StickerTypesQuery, StickerTypesQueryVariables>(StickerTypesDocument, options);
        }
export type StickerTypesQueryHookResult = ReturnType<typeof useStickerTypesQuery>;
export type StickerTypesLazyQueryHookResult = ReturnType<typeof useStickerTypesLazyQuery>;
export type StickerTypesQueryResult = Apollo.QueryResult<StickerTypesQuery, StickerTypesQueryVariables>;
export const ItemsWithItemTypeDocument = gql`
    query ItemsWithItemType($itemTypeGuid: String!) {
  itemsWithItemType(itemTypeGuid: $itemTypeGuid)
}
    `;

/**
 * __useItemsWithItemTypeQuery__
 *
 * To run a query within a React component, call `useItemsWithItemTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsWithItemTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsWithItemTypeQuery({
 *   variables: {
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useItemsWithItemTypeQuery(baseOptions: Apollo.QueryHookOptions<ItemsWithItemTypeQuery, ItemsWithItemTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsWithItemTypeQuery, ItemsWithItemTypeQueryVariables>(ItemsWithItemTypeDocument, options);
      }
export function useItemsWithItemTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsWithItemTypeQuery, ItemsWithItemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsWithItemTypeQuery, ItemsWithItemTypeQueryVariables>(ItemsWithItemTypeDocument, options);
        }
export type ItemsWithItemTypeQueryHookResult = ReturnType<typeof useItemsWithItemTypeQuery>;
export type ItemsWithItemTypeLazyQueryHookResult = ReturnType<typeof useItemsWithItemTypeLazyQuery>;
export type ItemsWithItemTypeQueryResult = Apollo.QueryResult<ItemsWithItemTypeQuery, ItemsWithItemTypeQueryVariables>;
export const ItemLocationsDocument = gql`
    query ItemLocations($itemGuid: String!) {
  getItemLocations(itemGuid: $itemGuid) {
    itemGuid
    itemName
    itemNumber
    itemType
  }
}
    `;

/**
 * __useItemLocationsQuery__
 *
 * To run a query within a React component, call `useItemLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemLocationsQuery({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useItemLocationsQuery(baseOptions: Apollo.QueryHookOptions<ItemLocationsQuery, ItemLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemLocationsQuery, ItemLocationsQueryVariables>(ItemLocationsDocument, options);
      }
export function useItemLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemLocationsQuery, ItemLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemLocationsQuery, ItemLocationsQueryVariables>(ItemLocationsDocument, options);
        }
export type ItemLocationsQueryHookResult = ReturnType<typeof useItemLocationsQuery>;
export type ItemLocationsLazyQueryHookResult = ReturnType<typeof useItemLocationsLazyQuery>;
export type ItemLocationsQueryResult = Apollo.QueryResult<ItemLocationsQuery, ItemLocationsQueryVariables>;
export const ItemLocationHistoryDocument = gql`
    query ItemLocationHistory($itemGuid: String!) {
  getItemLocationHistory(itemGuid: $itemGuid) {
    guid
    itemGuid
    locationGuid
    itemLocationGuid
    dateFrom
    dateTo
    locationName
    informationResponse {
      dateCreated
      createdBy
      dateModified
      modifiedBy
    }
  }
}
    `;

/**
 * __useItemLocationHistoryQuery__
 *
 * To run a query within a React component, call `useItemLocationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemLocationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemLocationHistoryQuery({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *   },
 * });
 */
export function useItemLocationHistoryQuery(baseOptions: Apollo.QueryHookOptions<ItemLocationHistoryQuery, ItemLocationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemLocationHistoryQuery, ItemLocationHistoryQueryVariables>(ItemLocationHistoryDocument, options);
      }
export function useItemLocationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemLocationHistoryQuery, ItemLocationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemLocationHistoryQuery, ItemLocationHistoryQueryVariables>(ItemLocationHistoryDocument, options);
        }
export type ItemLocationHistoryQueryHookResult = ReturnType<typeof useItemLocationHistoryQuery>;
export type ItemLocationHistoryLazyQueryHookResult = ReturnType<typeof useItemLocationHistoryLazyQuery>;
export type ItemLocationHistoryQueryResult = Apollo.QueryResult<ItemLocationHistoryQuery, ItemLocationHistoryQueryVariables>;
export const AddItemLocationToItemsDocument = gql`
    mutation AddItemLocationToItems($itemLocations: ItemLocationsInput!) {
  addItemLocationToItems(itemLocations: $itemLocations) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;
export type AddItemLocationToItemsMutationFn = Apollo.MutationFunction<AddItemLocationToItemsMutation, AddItemLocationToItemsMutationVariables>;

/**
 * __useAddItemLocationToItemsMutation__
 *
 * To run a mutation, you first call `useAddItemLocationToItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemLocationToItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemLocationToItemsMutation, { data, loading, error }] = useAddItemLocationToItemsMutation({
 *   variables: {
 *      itemLocations: // value for 'itemLocations'
 *   },
 * });
 */
export function useAddItemLocationToItemsMutation(baseOptions?: Apollo.MutationHookOptions<AddItemLocationToItemsMutation, AddItemLocationToItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemLocationToItemsMutation, AddItemLocationToItemsMutationVariables>(AddItemLocationToItemsDocument, options);
      }
export type AddItemLocationToItemsMutationHookResult = ReturnType<typeof useAddItemLocationToItemsMutation>;
export type AddItemLocationToItemsMutationResult = Apollo.MutationResult<AddItemLocationToItemsMutation>;
export type AddItemLocationToItemsMutationOptions = Apollo.BaseMutationOptions<AddItemLocationToItemsMutation, AddItemLocationToItemsMutationVariables>;
export const UpdateItemsLocationDocument = gql`
    mutation UpdateItemsLocation($itemGuids: [String!]!, $updateItemsLocationInput: UpdateItemsLocationInput!, $updateColdLocationInput: UpdateColdLocationInput!) {
  updateItemsLocation(
    itemGuids: $itemGuids
    updateItemsLocationInput: $updateItemsLocationInput
    updateColdLocationInput: $updateColdLocationInput
  ) {
    ...ItemFragments
  }
}
    ${ItemFragmentsFragmentDoc}`;
export type UpdateItemsLocationMutationFn = Apollo.MutationFunction<UpdateItemsLocationMutation, UpdateItemsLocationMutationVariables>;

/**
 * __useUpdateItemsLocationMutation__
 *
 * To run a mutation, you first call `useUpdateItemsLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemsLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemsLocationMutation, { data, loading, error }] = useUpdateItemsLocationMutation({
 *   variables: {
 *      itemGuids: // value for 'itemGuids'
 *      updateItemsLocationInput: // value for 'updateItemsLocationInput'
 *      updateColdLocationInput: // value for 'updateColdLocationInput'
 *   },
 * });
 */
export function useUpdateItemsLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemsLocationMutation, UpdateItemsLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemsLocationMutation, UpdateItemsLocationMutationVariables>(UpdateItemsLocationDocument, options);
      }
export type UpdateItemsLocationMutationHookResult = ReturnType<typeof useUpdateItemsLocationMutation>;
export type UpdateItemsLocationMutationResult = Apollo.MutationResult<UpdateItemsLocationMutation>;
export type UpdateItemsLocationMutationOptions = Apollo.BaseMutationOptions<UpdateItemsLocationMutation, UpdateItemsLocationMutationVariables>;
export const DeleteItemLocationFromItemDocument = gql`
    mutation DeleteItemLocationFromItem($itemGuid: String!, $itemLocationGuid: String!) {
  deleteItemLocationFromItem(
    itemGuid: $itemGuid
    itemLocationGuid: $itemLocationGuid
  )
}
    `;
export type DeleteItemLocationFromItemMutationFn = Apollo.MutationFunction<DeleteItemLocationFromItemMutation, DeleteItemLocationFromItemMutationVariables>;

/**
 * __useDeleteItemLocationFromItemMutation__
 *
 * To run a mutation, you first call `useDeleteItemLocationFromItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemLocationFromItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemLocationFromItemMutation, { data, loading, error }] = useDeleteItemLocationFromItemMutation({
 *   variables: {
 *      itemGuid: // value for 'itemGuid'
 *      itemLocationGuid: // value for 'itemLocationGuid'
 *   },
 * });
 */
export function useDeleteItemLocationFromItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemLocationFromItemMutation, DeleteItemLocationFromItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemLocationFromItemMutation, DeleteItemLocationFromItemMutationVariables>(DeleteItemLocationFromItemDocument, options);
      }
export type DeleteItemLocationFromItemMutationHookResult = ReturnType<typeof useDeleteItemLocationFromItemMutation>;
export type DeleteItemLocationFromItemMutationResult = Apollo.MutationResult<DeleteItemLocationFromItemMutation>;
export type DeleteItemLocationFromItemMutationOptions = Apollo.BaseMutationOptions<DeleteItemLocationFromItemMutation, DeleteItemLocationFromItemMutationVariables>;
export const SelectedItemsOptionsDocument = gql`
    query SelectedItemsOptions($itemGuids: [String!]!) {
  selectedItemsOptions(itemGuids: $itemGuids) {
    id
    title
  }
}
    `;

/**
 * __useSelectedItemsOptionsQuery__
 *
 * To run a query within a React component, call `useSelectedItemsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedItemsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedItemsOptionsQuery({
 *   variables: {
 *      itemGuids: // value for 'itemGuids'
 *   },
 * });
 */
export function useSelectedItemsOptionsQuery(baseOptions: Apollo.QueryHookOptions<SelectedItemsOptionsQuery, SelectedItemsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedItemsOptionsQuery, SelectedItemsOptionsQueryVariables>(SelectedItemsOptionsDocument, options);
      }
export function useSelectedItemsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedItemsOptionsQuery, SelectedItemsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedItemsOptionsQuery, SelectedItemsOptionsQueryVariables>(SelectedItemsOptionsDocument, options);
        }
export type SelectedItemsOptionsQueryHookResult = ReturnType<typeof useSelectedItemsOptionsQuery>;
export type SelectedItemsOptionsLazyQueryHookResult = ReturnType<typeof useSelectedItemsOptionsLazyQuery>;
export type SelectedItemsOptionsQueryResult = Apollo.QueryResult<SelectedItemsOptionsQuery, SelectedItemsOptionsQueryVariables>;
export const SelectedGuidsAsSelectItemsDocument = gql`
    query SelectedGuidsAsSelectItems($selectedGuids: [String!]!, $source: String!) {
  selectedGuidsAsSelectItems(selectedGuids: $selectedGuids, source: $source) {
    id
    title
  }
}
    `;

/**
 * __useSelectedGuidsAsSelectItemsQuery__
 *
 * To run a query within a React component, call `useSelectedGuidsAsSelectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedGuidsAsSelectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedGuidsAsSelectItemsQuery({
 *   variables: {
 *      selectedGuids: // value for 'selectedGuids'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useSelectedGuidsAsSelectItemsQuery(baseOptions: Apollo.QueryHookOptions<SelectedGuidsAsSelectItemsQuery, SelectedGuidsAsSelectItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedGuidsAsSelectItemsQuery, SelectedGuidsAsSelectItemsQueryVariables>(SelectedGuidsAsSelectItemsDocument, options);
      }
export function useSelectedGuidsAsSelectItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedGuidsAsSelectItemsQuery, SelectedGuidsAsSelectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedGuidsAsSelectItemsQuery, SelectedGuidsAsSelectItemsQueryVariables>(SelectedGuidsAsSelectItemsDocument, options);
        }
export type SelectedGuidsAsSelectItemsQueryHookResult = ReturnType<typeof useSelectedGuidsAsSelectItemsQuery>;
export type SelectedGuidsAsSelectItemsLazyQueryHookResult = ReturnType<typeof useSelectedGuidsAsSelectItemsLazyQuery>;
export type SelectedGuidsAsSelectItemsQueryResult = Apollo.QueryResult<SelectedGuidsAsSelectItemsQuery, SelectedGuidsAsSelectItemsQueryVariables>;
export const ItemStatisticsByCollectionTypeDocument = gql`
    query ItemStatisticsByCollectionType($collectionTypeGuids: [String!]!, $dateFrom: String!, $dateTo: String!, $skraninguLokid: String) {
  itemStatisticsByCollectionType(
    collectionTypeGuids: $collectionTypeGuids
    dateFrom: $dateFrom
    dateTo: $dateTo
    skraninguLokid: $skraninguLokid
  ) {
    statistics {
      collectionTypeCode
      collectionTypeName
      itemCount
    }
    year
    dateFrom
    dateTo
  }
}
    `;

/**
 * __useItemStatisticsByCollectionTypeQuery__
 *
 * To run a query within a React component, call `useItemStatisticsByCollectionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemStatisticsByCollectionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemStatisticsByCollectionTypeQuery({
 *   variables: {
 *      collectionTypeGuids: // value for 'collectionTypeGuids'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      skraninguLokid: // value for 'skraninguLokid'
 *   },
 * });
 */
export function useItemStatisticsByCollectionTypeQuery(baseOptions: Apollo.QueryHookOptions<ItemStatisticsByCollectionTypeQuery, ItemStatisticsByCollectionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemStatisticsByCollectionTypeQuery, ItemStatisticsByCollectionTypeQueryVariables>(ItemStatisticsByCollectionTypeDocument, options);
      }
export function useItemStatisticsByCollectionTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemStatisticsByCollectionTypeQuery, ItemStatisticsByCollectionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemStatisticsByCollectionTypeQuery, ItemStatisticsByCollectionTypeQueryVariables>(ItemStatisticsByCollectionTypeDocument, options);
        }
export type ItemStatisticsByCollectionTypeQueryHookResult = ReturnType<typeof useItemStatisticsByCollectionTypeQuery>;
export type ItemStatisticsByCollectionTypeLazyQueryHookResult = ReturnType<typeof useItemStatisticsByCollectionTypeLazyQuery>;
export type ItemStatisticsByCollectionTypeQueryResult = Apollo.QueryResult<ItemStatisticsByCollectionTypeQuery, ItemStatisticsByCollectionTypeQueryVariables>;
export const ItemCollectionsDocument = gql`
    query ItemCollections($search: SearchItemCollectionInput) {
  itemCollections(search: $search) {
    ...ItemCollectionFragments
  }
}
    ${ItemCollectionFragmentsFragmentDoc}`;

/**
 * __useItemCollectionsQuery__
 *
 * To run a query within a React component, call `useItemCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useItemCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionsQuery, ItemCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionsQuery, ItemCollectionsQueryVariables>(ItemCollectionsDocument, options);
      }
export function useItemCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionsQuery, ItemCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionsQuery, ItemCollectionsQueryVariables>(ItemCollectionsDocument, options);
        }
export type ItemCollectionsQueryHookResult = ReturnType<typeof useItemCollectionsQuery>;
export type ItemCollectionsLazyQueryHookResult = ReturnType<typeof useItemCollectionsLazyQuery>;
export type ItemCollectionsQueryResult = Apollo.QueryResult<ItemCollectionsQuery, ItemCollectionsQueryVariables>;
export const ItemCollectionDocument = gql`
    query ItemCollection($itemCollectionGuid: String, $dropDownItemId: Float) {
  itemCollection(itemCollectionGuid: $itemCollectionGuid) {
    ...ItemCollectionFragments
  }
  getCollectionTypesList {
    id
    title
  }
  getDeliveryConditions(dropDownItemId: $dropDownItemId) {
    id
    title
  }
}
    ${ItemCollectionFragmentsFragmentDoc}`;

/**
 * __useItemCollectionQuery__
 *
 * To run a query within a React component, call `useItemCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionQuery({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *      dropDownItemId: // value for 'dropDownItemId'
 *   },
 * });
 */
export function useItemCollectionQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionQuery, ItemCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionQuery, ItemCollectionQueryVariables>(ItemCollectionDocument, options);
      }
export function useItemCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionQuery, ItemCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionQuery, ItemCollectionQueryVariables>(ItemCollectionDocument, options);
        }
export type ItemCollectionQueryHookResult = ReturnType<typeof useItemCollectionQuery>;
export type ItemCollectionLazyQueryHookResult = ReturnType<typeof useItemCollectionLazyQuery>;
export type ItemCollectionQueryResult = Apollo.QueryResult<ItemCollectionQuery, ItemCollectionQueryVariables>;
export const DeliveryConditionsDocument = gql`
    query DeliveryConditions($dropDownItemId: Float) {
  getDeliveryConditions(dropDownItemId: $dropDownItemId) {
    id
    title
  }
}
    `;

/**
 * __useDeliveryConditionsQuery__
 *
 * To run a query within a React component, call `useDeliveryConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryConditionsQuery({
 *   variables: {
 *      dropDownItemId: // value for 'dropDownItemId'
 *   },
 * });
 */
export function useDeliveryConditionsQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryConditionsQuery, DeliveryConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryConditionsQuery, DeliveryConditionsQueryVariables>(DeliveryConditionsDocument, options);
      }
export function useDeliveryConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryConditionsQuery, DeliveryConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryConditionsQuery, DeliveryConditionsQueryVariables>(DeliveryConditionsDocument, options);
        }
export type DeliveryConditionsQueryHookResult = ReturnType<typeof useDeliveryConditionsQuery>;
export type DeliveryConditionsLazyQueryHookResult = ReturnType<typeof useDeliveryConditionsLazyQuery>;
export type DeliveryConditionsQueryResult = Apollo.QueryResult<DeliveryConditionsQuery, DeliveryConditionsQueryVariables>;
export const ItemCollectionsForOriginOptionsDocument = gql`
    query ItemCollectionsForOriginOptions($originGuid: String!) {
  itemCollectionsForOriginOptions(originGuid: $originGuid) {
    id
    title
    num
  }
}
    `;

/**
 * __useItemCollectionsForOriginOptionsQuery__
 *
 * To run a query within a React component, call `useItemCollectionsForOriginOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionsForOriginOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionsForOriginOptionsQuery({
 *   variables: {
 *      originGuid: // value for 'originGuid'
 *   },
 * });
 */
export function useItemCollectionsForOriginOptionsQuery(baseOptions: Apollo.QueryHookOptions<ItemCollectionsForOriginOptionsQuery, ItemCollectionsForOriginOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionsForOriginOptionsQuery, ItemCollectionsForOriginOptionsQueryVariables>(ItemCollectionsForOriginOptionsDocument, options);
      }
export function useItemCollectionsForOriginOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionsForOriginOptionsQuery, ItemCollectionsForOriginOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionsForOriginOptionsQuery, ItemCollectionsForOriginOptionsQueryVariables>(ItemCollectionsForOriginOptionsDocument, options);
        }
export type ItemCollectionsForOriginOptionsQueryHookResult = ReturnType<typeof useItemCollectionsForOriginOptionsQuery>;
export type ItemCollectionsForOriginOptionsLazyQueryHookResult = ReturnType<typeof useItemCollectionsForOriginOptionsLazyQuery>;
export type ItemCollectionsForOriginOptionsQueryResult = Apollo.QueryResult<ItemCollectionsForOriginOptionsQuery, ItemCollectionsForOriginOptionsQueryVariables>;
export const ItemCollectionsPaginatedDocument = gql`
    query ItemCollectionsPaginated($search: SearchItemCollectionInput, $filter: FilterItemCollectionInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  itemCollectionsPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...ItemCollectionFragments
      }
    }
    totalGuids
  }
}
    ${ItemCollectionFragmentsFragmentDoc}`;

/**
 * __useItemCollectionsPaginatedQuery__
 *
 * To run a query within a React component, call `useItemCollectionsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionsPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useItemCollectionsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionsPaginatedQuery, ItemCollectionsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionsPaginatedQuery, ItemCollectionsPaginatedQueryVariables>(ItemCollectionsPaginatedDocument, options);
      }
export function useItemCollectionsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionsPaginatedQuery, ItemCollectionsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionsPaginatedQuery, ItemCollectionsPaginatedQueryVariables>(ItemCollectionsPaginatedDocument, options);
        }
export type ItemCollectionsPaginatedQueryHookResult = ReturnType<typeof useItemCollectionsPaginatedQuery>;
export type ItemCollectionsPaginatedLazyQueryHookResult = ReturnType<typeof useItemCollectionsPaginatedLazyQuery>;
export type ItemCollectionsPaginatedQueryResult = Apollo.QueryResult<ItemCollectionsPaginatedQuery, ItemCollectionsPaginatedQueryVariables>;
export const ItemCollectionNumberOptionsDocument = gql`
    query ItemCollectionNumberOptions($query: String) {
  itemCollectionNumberOptions(query: $query) {
    id
    title
  }
}
    `;

/**
 * __useItemCollectionNumberOptionsQuery__
 *
 * To run a query within a React component, call `useItemCollectionNumberOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionNumberOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionNumberOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useItemCollectionNumberOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionNumberOptionsQuery, ItemCollectionNumberOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionNumberOptionsQuery, ItemCollectionNumberOptionsQueryVariables>(ItemCollectionNumberOptionsDocument, options);
      }
export function useItemCollectionNumberOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionNumberOptionsQuery, ItemCollectionNumberOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionNumberOptionsQuery, ItemCollectionNumberOptionsQueryVariables>(ItemCollectionNumberOptionsDocument, options);
        }
export type ItemCollectionNumberOptionsQueryHookResult = ReturnType<typeof useItemCollectionNumberOptionsQuery>;
export type ItemCollectionNumberOptionsLazyQueryHookResult = ReturnType<typeof useItemCollectionNumberOptionsLazyQuery>;
export type ItemCollectionNumberOptionsQueryResult = Apollo.QueryResult<ItemCollectionNumberOptionsQuery, ItemCollectionNumberOptionsQueryVariables>;
export const ItemCollectionOptionsDocument = gql`
    query ItemCollectionOptions {
  getCollectionTypesList {
    id
    title
  }
  getDeliveryConditions {
    id
    title
  }
}
    `;

/**
 * __useItemCollectionOptionsQuery__
 *
 * To run a query within a React component, call `useItemCollectionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemCollectionOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionOptionsQuery, ItemCollectionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionOptionsQuery, ItemCollectionOptionsQueryVariables>(ItemCollectionOptionsDocument, options);
      }
export function useItemCollectionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionOptionsQuery, ItemCollectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionOptionsQuery, ItemCollectionOptionsQueryVariables>(ItemCollectionOptionsDocument, options);
        }
export type ItemCollectionOptionsQueryHookResult = ReturnType<typeof useItemCollectionOptionsQuery>;
export type ItemCollectionOptionsLazyQueryHookResult = ReturnType<typeof useItemCollectionOptionsLazyQuery>;
export type ItemCollectionOptionsQueryResult = Apollo.QueryResult<ItemCollectionOptionsQuery, ItemCollectionOptionsQueryVariables>;
export const ItemCollectionsInOriginDocument = gql`
    query ItemCollectionsInOrigin($originGuid: String!) {
  itemCollectionsInOrigin(originGuid: $originGuid) {
    ...ItemCollectionFragments
  }
}
    ${ItemCollectionFragmentsFragmentDoc}`;

/**
 * __useItemCollectionsInOriginQuery__
 *
 * To run a query within a React component, call `useItemCollectionsInOriginQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionsInOriginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionsInOriginQuery({
 *   variables: {
 *      originGuid: // value for 'originGuid'
 *   },
 * });
 */
export function useItemCollectionsInOriginQuery(baseOptions: Apollo.QueryHookOptions<ItemCollectionsInOriginQuery, ItemCollectionsInOriginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionsInOriginQuery, ItemCollectionsInOriginQueryVariables>(ItemCollectionsInOriginDocument, options);
      }
export function useItemCollectionsInOriginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionsInOriginQuery, ItemCollectionsInOriginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionsInOriginQuery, ItemCollectionsInOriginQueryVariables>(ItemCollectionsInOriginDocument, options);
        }
export type ItemCollectionsInOriginQueryHookResult = ReturnType<typeof useItemCollectionsInOriginQuery>;
export type ItemCollectionsInOriginLazyQueryHookResult = ReturnType<typeof useItemCollectionsInOriginLazyQuery>;
export type ItemCollectionsInOriginQueryResult = Apollo.QueryResult<ItemCollectionsInOriginQuery, ItemCollectionsInOriginQueryVariables>;
export const CreateItemCollectionDocument = gql`
    mutation CreateItemCollection($itemCollection: ItemCollectionInput!) {
  createItemCollection(itemCollection: $itemCollection) {
    ...ItemCollectionFragments
  }
}
    ${ItemCollectionFragmentsFragmentDoc}`;
export type CreateItemCollectionMutationFn = Apollo.MutationFunction<CreateItemCollectionMutation, CreateItemCollectionMutationVariables>;

/**
 * __useCreateItemCollectionMutation__
 *
 * To run a mutation, you first call `useCreateItemCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemCollectionMutation, { data, loading, error }] = useCreateItemCollectionMutation({
 *   variables: {
 *      itemCollection: // value for 'itemCollection'
 *   },
 * });
 */
export function useCreateItemCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemCollectionMutation, CreateItemCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemCollectionMutation, CreateItemCollectionMutationVariables>(CreateItemCollectionDocument, options);
      }
export type CreateItemCollectionMutationHookResult = ReturnType<typeof useCreateItemCollectionMutation>;
export type CreateItemCollectionMutationResult = Apollo.MutationResult<CreateItemCollectionMutation>;
export type CreateItemCollectionMutationOptions = Apollo.BaseMutationOptions<CreateItemCollectionMutation, CreateItemCollectionMutationVariables>;
export const UpdateItemCollectionDocument = gql`
    mutation UpdateItemCollection($itemCollection: ItemCollectionInput!, $itemCollectionGuid: String) {
  updateItemCollection(
    itemCollection: $itemCollection
    itemCollectionGuid: $itemCollectionGuid
  ) {
    ...ItemCollectionFragments
  }
}
    ${ItemCollectionFragmentsFragmentDoc}`;
export type UpdateItemCollectionMutationFn = Apollo.MutationFunction<UpdateItemCollectionMutation, UpdateItemCollectionMutationVariables>;

/**
 * __useUpdateItemCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateItemCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemCollectionMutation, { data, loading, error }] = useUpdateItemCollectionMutation({
 *   variables: {
 *      itemCollection: // value for 'itemCollection'
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *   },
 * });
 */
export function useUpdateItemCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemCollectionMutation, UpdateItemCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemCollectionMutation, UpdateItemCollectionMutationVariables>(UpdateItemCollectionDocument, options);
      }
export type UpdateItemCollectionMutationHookResult = ReturnType<typeof useUpdateItemCollectionMutation>;
export type UpdateItemCollectionMutationResult = Apollo.MutationResult<UpdateItemCollectionMutation>;
export type UpdateItemCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateItemCollectionMutation, UpdateItemCollectionMutationVariables>;
export const DeleteItemCollectionDocument = gql`
    mutation DeleteItemCollection($itemCollectionGuid: String!) {
  deleteItemCollection(itemCollectionGuid: $itemCollectionGuid)
}
    `;
export type DeleteItemCollectionMutationFn = Apollo.MutationFunction<DeleteItemCollectionMutation, DeleteItemCollectionMutationVariables>;

/**
 * __useDeleteItemCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteItemCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemCollectionMutation, { data, loading, error }] = useDeleteItemCollectionMutation({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *   },
 * });
 */
export function useDeleteItemCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemCollectionMutation, DeleteItemCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemCollectionMutation, DeleteItemCollectionMutationVariables>(DeleteItemCollectionDocument, options);
      }
export type DeleteItemCollectionMutationHookResult = ReturnType<typeof useDeleteItemCollectionMutation>;
export type DeleteItemCollectionMutationResult = Apollo.MutationResult<DeleteItemCollectionMutation>;
export type DeleteItemCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteItemCollectionMutation, DeleteItemCollectionMutationVariables>;
export const ItemCollectionTypesListDocument = gql`
    query ItemCollectionTypesList {
  getCollectionTypesList {
    id
    title
  }
}
    `;

/**
 * __useItemCollectionTypesListQuery__
 *
 * To run a query within a React component, call `useItemCollectionTypesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionTypesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionTypesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemCollectionTypesListQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionTypesListQuery, ItemCollectionTypesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionTypesListQuery, ItemCollectionTypesListQueryVariables>(ItemCollectionTypesListDocument, options);
      }
export function useItemCollectionTypesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionTypesListQuery, ItemCollectionTypesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionTypesListQuery, ItemCollectionTypesListQueryVariables>(ItemCollectionTypesListDocument, options);
        }
export type ItemCollectionTypesListQueryHookResult = ReturnType<typeof useItemCollectionTypesListQuery>;
export type ItemCollectionTypesListLazyQueryHookResult = ReturnType<typeof useItemCollectionTypesListLazyQuery>;
export type ItemCollectionTypesListQueryResult = Apollo.QueryResult<ItemCollectionTypesListQuery, ItemCollectionTypesListQueryVariables>;
export const ImportItemsToItemCollectionDocument = gql`
    mutation ImportItemsToItemCollection($itemCollectionGuid: String!, $formTypeEnum: String!, $excelImportGuid: String!) {
  importItemsToItemCollection(
    itemCollectionGuid: $itemCollectionGuid
    formTypeEnum: $formTypeEnum
    excelImportGuid: $excelImportGuid
  )
}
    `;
export type ImportItemsToItemCollectionMutationFn = Apollo.MutationFunction<ImportItemsToItemCollectionMutation, ImportItemsToItemCollectionMutationVariables>;

/**
 * __useImportItemsToItemCollectionMutation__
 *
 * To run a mutation, you first call `useImportItemsToItemCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportItemsToItemCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importItemsToItemCollectionMutation, { data, loading, error }] = useImportItemsToItemCollectionMutation({
 *   variables: {
 *      itemCollectionGuid: // value for 'itemCollectionGuid'
 *      formTypeEnum: // value for 'formTypeEnum'
 *      excelImportGuid: // value for 'excelImportGuid'
 *   },
 * });
 */
export function useImportItemsToItemCollectionMutation(baseOptions?: Apollo.MutationHookOptions<ImportItemsToItemCollectionMutation, ImportItemsToItemCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportItemsToItemCollectionMutation, ImportItemsToItemCollectionMutationVariables>(ImportItemsToItemCollectionDocument, options);
      }
export type ImportItemsToItemCollectionMutationHookResult = ReturnType<typeof useImportItemsToItemCollectionMutation>;
export type ImportItemsToItemCollectionMutationResult = Apollo.MutationResult<ImportItemsToItemCollectionMutation>;
export type ImportItemsToItemCollectionMutationOptions = Apollo.BaseMutationOptions<ImportItemsToItemCollectionMutation, ImportItemsToItemCollectionMutationVariables>;
export const ReindexImportResultDocument = gql`
    mutation ReindexImportResult($importResultJson: String!) {
  reindexImportResult(importResultJson: $importResultJson)
}
    `;
export type ReindexImportResultMutationFn = Apollo.MutationFunction<ReindexImportResultMutation, ReindexImportResultMutationVariables>;

/**
 * __useReindexImportResultMutation__
 *
 * To run a mutation, you first call `useReindexImportResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReindexImportResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reindexImportResultMutation, { data, loading, error }] = useReindexImportResultMutation({
 *   variables: {
 *      importResultJson: // value for 'importResultJson'
 *   },
 * });
 */
export function useReindexImportResultMutation(baseOptions?: Apollo.MutationHookOptions<ReindexImportResultMutation, ReindexImportResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReindexImportResultMutation, ReindexImportResultMutationVariables>(ReindexImportResultDocument, options);
      }
export type ReindexImportResultMutationHookResult = ReturnType<typeof useReindexImportResultMutation>;
export type ReindexImportResultMutationResult = Apollo.MutationResult<ReindexImportResultMutation>;
export type ReindexImportResultMutationOptions = Apollo.BaseMutationOptions<ReindexImportResultMutation, ReindexImportResultMutationVariables>;
export const ItemCollectionFormTypeCodeDocument = gql`
    query ItemCollectionFormTypeCode($itemCollectionTypeGuid: String!) {
  itemCollectionFormTypeCode(itemCollectionTypeGuid: $itemCollectionTypeGuid)
}
    `;

/**
 * __useItemCollectionFormTypeCodeQuery__
 *
 * To run a query within a React component, call `useItemCollectionFormTypeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionFormTypeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionFormTypeCodeQuery({
 *   variables: {
 *      itemCollectionTypeGuid: // value for 'itemCollectionTypeGuid'
 *   },
 * });
 */
export function useItemCollectionFormTypeCodeQuery(baseOptions: Apollo.QueryHookOptions<ItemCollectionFormTypeCodeQuery, ItemCollectionFormTypeCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionFormTypeCodeQuery, ItemCollectionFormTypeCodeQueryVariables>(ItemCollectionFormTypeCodeDocument, options);
      }
export function useItemCollectionFormTypeCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionFormTypeCodeQuery, ItemCollectionFormTypeCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionFormTypeCodeQuery, ItemCollectionFormTypeCodeQueryVariables>(ItemCollectionFormTypeCodeDocument, options);
        }
export type ItemCollectionFormTypeCodeQueryHookResult = ReturnType<typeof useItemCollectionFormTypeCodeQuery>;
export type ItemCollectionFormTypeCodeLazyQueryHookResult = ReturnType<typeof useItemCollectionFormTypeCodeLazyQuery>;
export type ItemCollectionFormTypeCodeQueryResult = Apollo.QueryResult<ItemCollectionFormTypeCodeQuery, ItemCollectionFormTypeCodeQueryVariables>;
export const ItemCollectionTypeDocument = gql`
    query ItemCollectionType {
  getCollectionTypes {
    id
    code
    name
  }
  getCollectionTypesList {
    id
    title
  }
}
    `;

/**
 * __useItemCollectionTypeQuery__
 *
 * To run a query within a React component, call `useItemCollectionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemCollectionTypeQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionTypeQuery, ItemCollectionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionTypeQuery, ItemCollectionTypeQueryVariables>(ItemCollectionTypeDocument, options);
      }
export function useItemCollectionTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionTypeQuery, ItemCollectionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionTypeQuery, ItemCollectionTypeQueryVariables>(ItemCollectionTypeDocument, options);
        }
export type ItemCollectionTypeQueryHookResult = ReturnType<typeof useItemCollectionTypeQuery>;
export type ItemCollectionTypeLazyQueryHookResult = ReturnType<typeof useItemCollectionTypeLazyQuery>;
export type ItemCollectionTypeQueryResult = Apollo.QueryResult<ItemCollectionTypeQuery, ItemCollectionTypeQueryVariables>;
export const ItemCollectionTypeDetailsDocument = gql`
    query ItemCollectionTypeDetails {
  itemCollectionTypeDetails {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...ItemCollectionTypeDetailFragments
      }
    }
    totalGuids
  }
}
    ${ItemCollectionTypeDetailFragmentsFragmentDoc}`;

/**
 * __useItemCollectionTypeDetailsQuery__
 *
 * To run a query within a React component, call `useItemCollectionTypeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionTypeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionTypeDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemCollectionTypeDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionTypeDetailsQuery, ItemCollectionTypeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionTypeDetailsQuery, ItemCollectionTypeDetailsQueryVariables>(ItemCollectionTypeDetailsDocument, options);
      }
export function useItemCollectionTypeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionTypeDetailsQuery, ItemCollectionTypeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionTypeDetailsQuery, ItemCollectionTypeDetailsQueryVariables>(ItemCollectionTypeDetailsDocument, options);
        }
export type ItemCollectionTypeDetailsQueryHookResult = ReturnType<typeof useItemCollectionTypeDetailsQuery>;
export type ItemCollectionTypeDetailsLazyQueryHookResult = ReturnType<typeof useItemCollectionTypeDetailsLazyQuery>;
export type ItemCollectionTypeDetailsQueryResult = Apollo.QueryResult<ItemCollectionTypeDetailsQuery, ItemCollectionTypeDetailsQueryVariables>;
export const ItemCollectionTypeDetailsPaginatedDocument = gql`
    query ItemCollectionTypeDetailsPaginated($search: SearchAdminComponentInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  itemCollectionTypeDetailsPaginated(
    search: $search
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...ItemCollectionTypeDetailFragments
      }
    }
    totalGuids
  }
}
    ${ItemCollectionTypeDetailFragmentsFragmentDoc}`;

/**
 * __useItemCollectionTypeDetailsPaginatedQuery__
 *
 * To run a query within a React component, call `useItemCollectionTypeDetailsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionTypeDetailsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionTypeDetailsPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useItemCollectionTypeDetailsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionTypeDetailsPaginatedQuery, ItemCollectionTypeDetailsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionTypeDetailsPaginatedQuery, ItemCollectionTypeDetailsPaginatedQueryVariables>(ItemCollectionTypeDetailsPaginatedDocument, options);
      }
export function useItemCollectionTypeDetailsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionTypeDetailsPaginatedQuery, ItemCollectionTypeDetailsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionTypeDetailsPaginatedQuery, ItemCollectionTypeDetailsPaginatedQueryVariables>(ItemCollectionTypeDetailsPaginatedDocument, options);
        }
export type ItemCollectionTypeDetailsPaginatedQueryHookResult = ReturnType<typeof useItemCollectionTypeDetailsPaginatedQuery>;
export type ItemCollectionTypeDetailsPaginatedLazyQueryHookResult = ReturnType<typeof useItemCollectionTypeDetailsPaginatedLazyQuery>;
export type ItemCollectionTypeDetailsPaginatedQueryResult = Apollo.QueryResult<ItemCollectionTypeDetailsPaginatedQuery, ItemCollectionTypeDetailsPaginatedQueryVariables>;
export const ItemCollectionTypeDetailDocument = gql`
    query ItemCollectionTypeDetail($itemCollectionTypeDetailGuid: String) {
  itemCollectionTypeDetail(
    itemCollectionTypeDetailGuid: $itemCollectionTypeDetailGuid
  ) {
    ...ItemCollectionTypeDetailFragments
  }
}
    ${ItemCollectionTypeDetailFragmentsFragmentDoc}`;

/**
 * __useItemCollectionTypeDetailQuery__
 *
 * To run a query within a React component, call `useItemCollectionTypeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCollectionTypeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCollectionTypeDetailQuery({
 *   variables: {
 *      itemCollectionTypeDetailGuid: // value for 'itemCollectionTypeDetailGuid'
 *   },
 * });
 */
export function useItemCollectionTypeDetailQuery(baseOptions?: Apollo.QueryHookOptions<ItemCollectionTypeDetailQuery, ItemCollectionTypeDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCollectionTypeDetailQuery, ItemCollectionTypeDetailQueryVariables>(ItemCollectionTypeDetailDocument, options);
      }
export function useItemCollectionTypeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCollectionTypeDetailQuery, ItemCollectionTypeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCollectionTypeDetailQuery, ItemCollectionTypeDetailQueryVariables>(ItemCollectionTypeDetailDocument, options);
        }
export type ItemCollectionTypeDetailQueryHookResult = ReturnType<typeof useItemCollectionTypeDetailQuery>;
export type ItemCollectionTypeDetailLazyQueryHookResult = ReturnType<typeof useItemCollectionTypeDetailLazyQuery>;
export type ItemCollectionTypeDetailQueryResult = Apollo.QueryResult<ItemCollectionTypeDetailQuery, ItemCollectionTypeDetailQueryVariables>;
export const UpdateItemCollectionTypeDocument = gql`
    mutation UpdateItemCollectionType($itemCollectionType: ItemCollectionTypeInput!, $itemCollectionTypeGuid: String!) {
  updateItemCollectionType(
    itemCollectionType: $itemCollectionType
    itemCollectionTypeGuid: $itemCollectionTypeGuid
  ) {
    ...ItemCollectionTypeDetailFragments
  }
}
    ${ItemCollectionTypeDetailFragmentsFragmentDoc}`;
export type UpdateItemCollectionTypeMutationFn = Apollo.MutationFunction<UpdateItemCollectionTypeMutation, UpdateItemCollectionTypeMutationVariables>;

/**
 * __useUpdateItemCollectionTypeMutation__
 *
 * To run a mutation, you first call `useUpdateItemCollectionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemCollectionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemCollectionTypeMutation, { data, loading, error }] = useUpdateItemCollectionTypeMutation({
 *   variables: {
 *      itemCollectionType: // value for 'itemCollectionType'
 *      itemCollectionTypeGuid: // value for 'itemCollectionTypeGuid'
 *   },
 * });
 */
export function useUpdateItemCollectionTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemCollectionTypeMutation, UpdateItemCollectionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemCollectionTypeMutation, UpdateItemCollectionTypeMutationVariables>(UpdateItemCollectionTypeDocument, options);
      }
export type UpdateItemCollectionTypeMutationHookResult = ReturnType<typeof useUpdateItemCollectionTypeMutation>;
export type UpdateItemCollectionTypeMutationResult = Apollo.MutationResult<UpdateItemCollectionTypeMutation>;
export type UpdateItemCollectionTypeMutationOptions = Apollo.BaseMutationOptions<UpdateItemCollectionTypeMutation, UpdateItemCollectionTypeMutationVariables>;
export const CreateItemCollectionTypeDocument = gql`
    mutation CreateItemCollectionType($itemCollectionType: ItemCollectionTypeInput!, $originTypeGuid: String!) {
  createItemCollectionType(
    itemCollectionType: $itemCollectionType
    originTypeGuid: $originTypeGuid
  ) {
    ...ItemCollectionTypeDetailFragments
  }
}
    ${ItemCollectionTypeDetailFragmentsFragmentDoc}`;
export type CreateItemCollectionTypeMutationFn = Apollo.MutationFunction<CreateItemCollectionTypeMutation, CreateItemCollectionTypeMutationVariables>;

/**
 * __useCreateItemCollectionTypeMutation__
 *
 * To run a mutation, you first call `useCreateItemCollectionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemCollectionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemCollectionTypeMutation, { data, loading, error }] = useCreateItemCollectionTypeMutation({
 *   variables: {
 *      itemCollectionType: // value for 'itemCollectionType'
 *      originTypeGuid: // value for 'originTypeGuid'
 *   },
 * });
 */
export function useCreateItemCollectionTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemCollectionTypeMutation, CreateItemCollectionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemCollectionTypeMutation, CreateItemCollectionTypeMutationVariables>(CreateItemCollectionTypeDocument, options);
      }
export type CreateItemCollectionTypeMutationHookResult = ReturnType<typeof useCreateItemCollectionTypeMutation>;
export type CreateItemCollectionTypeMutationResult = Apollo.MutationResult<CreateItemCollectionTypeMutation>;
export type CreateItemCollectionTypeMutationOptions = Apollo.BaseMutationOptions<CreateItemCollectionTypeMutation, CreateItemCollectionTypeMutationVariables>;
export const DeleteItemCollectionTypeDocument = gql`
    mutation DeleteItemCollectionType($itemCollectionTypeGuid: String!) {
  deleteItemCollectionType(itemCollectionTypeGuid: $itemCollectionTypeGuid)
}
    `;
export type DeleteItemCollectionTypeMutationFn = Apollo.MutationFunction<DeleteItemCollectionTypeMutation, DeleteItemCollectionTypeMutationVariables>;

/**
 * __useDeleteItemCollectionTypeMutation__
 *
 * To run a mutation, you first call `useDeleteItemCollectionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemCollectionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemCollectionTypeMutation, { data, loading, error }] = useDeleteItemCollectionTypeMutation({
 *   variables: {
 *      itemCollectionTypeGuid: // value for 'itemCollectionTypeGuid'
 *   },
 * });
 */
export function useDeleteItemCollectionTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemCollectionTypeMutation, DeleteItemCollectionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemCollectionTypeMutation, DeleteItemCollectionTypeMutationVariables>(DeleteItemCollectionTypeDocument, options);
      }
export type DeleteItemCollectionTypeMutationHookResult = ReturnType<typeof useDeleteItemCollectionTypeMutation>;
export type DeleteItemCollectionTypeMutationResult = Apollo.MutationResult<DeleteItemCollectionTypeMutation>;
export type DeleteItemCollectionTypeMutationOptions = Apollo.BaseMutationOptions<DeleteItemCollectionTypeMutation, DeleteItemCollectionTypeMutationVariables>;
export const ItemTypesDocument = gql`
    query ItemTypes {
  itemTypes {
    guid
    code
    name
  }
}
    `;

/**
 * __useItemTypesQuery__
 *
 * To run a query within a React component, call `useItemTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemTypesQuery(baseOptions?: Apollo.QueryHookOptions<ItemTypesQuery, ItemTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemTypesQuery, ItemTypesQueryVariables>(ItemTypesDocument, options);
      }
export function useItemTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemTypesQuery, ItemTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemTypesQuery, ItemTypesQueryVariables>(ItemTypesDocument, options);
        }
export type ItemTypesQueryHookResult = ReturnType<typeof useItemTypesQuery>;
export type ItemTypesLazyQueryHookResult = ReturnType<typeof useItemTypesLazyQuery>;
export type ItemTypesQueryResult = Apollo.QueryResult<ItemTypesQuery, ItemTypesQueryVariables>;
export const ItemTypeDocument = gql`
    query ItemType($itemTypeGuid: String) {
  itemType(itemTypeGuid: $itemTypeGuid) {
    guid
    name
    visible
  }
}
    `;

/**
 * __useItemTypeQuery__
 *
 * To run a query within a React component, call `useItemTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTypeQuery({
 *   variables: {
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useItemTypeQuery(baseOptions?: Apollo.QueryHookOptions<ItemTypeQuery, ItemTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemTypeQuery, ItemTypeQueryVariables>(ItemTypeDocument, options);
      }
export function useItemTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemTypeQuery, ItemTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemTypeQuery, ItemTypeQueryVariables>(ItemTypeDocument, options);
        }
export type ItemTypeQueryHookResult = ReturnType<typeof useItemTypeQuery>;
export type ItemTypeLazyQueryHookResult = ReturnType<typeof useItemTypeLazyQuery>;
export type ItemTypeQueryResult = Apollo.QueryResult<ItemTypeQuery, ItemTypeQueryVariables>;
export const AllItemTypeOptionsDocument = gql`
    query AllItemTypeOptions {
  allItemTypeOptions {
    id
    title
  }
}
    `;

/**
 * __useAllItemTypeOptionsQuery__
 *
 * To run a query within a React component, call `useAllItemTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllItemTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllItemTypeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllItemTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AllItemTypeOptionsQuery, AllItemTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllItemTypeOptionsQuery, AllItemTypeOptionsQueryVariables>(AllItemTypeOptionsDocument, options);
      }
export function useAllItemTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllItemTypeOptionsQuery, AllItemTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllItemTypeOptionsQuery, AllItemTypeOptionsQueryVariables>(AllItemTypeOptionsDocument, options);
        }
export type AllItemTypeOptionsQueryHookResult = ReturnType<typeof useAllItemTypeOptionsQuery>;
export type AllItemTypeOptionsLazyQueryHookResult = ReturnType<typeof useAllItemTypeOptionsLazyQuery>;
export type AllItemTypeOptionsQueryResult = Apollo.QueryResult<AllItemTypeOptionsQuery, AllItemTypeOptionsQueryVariables>;
export const ItemFilterOptionsDocument = gql`
    query ItemFilterOptions($code: String) {
  itemTypeOptions(code: $code) {
    id
    title
  }
  languageOptions {
    id
    title
  }
  breiddOptions {
    id
    title
  }
}
    `;

/**
 * __useItemFilterOptionsQuery__
 *
 * To run a query within a React component, call `useItemFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemFilterOptionsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useItemFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ItemFilterOptionsQuery, ItemFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemFilterOptionsQuery, ItemFilterOptionsQueryVariables>(ItemFilterOptionsDocument, options);
      }
export function useItemFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemFilterOptionsQuery, ItemFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemFilterOptionsQuery, ItemFilterOptionsQueryVariables>(ItemFilterOptionsDocument, options);
        }
export type ItemFilterOptionsQueryHookResult = ReturnType<typeof useItemFilterOptionsQuery>;
export type ItemFilterOptionsLazyQueryHookResult = ReturnType<typeof useItemFilterOptionsLazyQuery>;
export type ItemFilterOptionsQueryResult = Apollo.QueryResult<ItemFilterOptionsQuery, ItemFilterOptionsQueryVariables>;
export const ItemTypeDetailDocument = gql`
    query ItemTypeDetail($itemTypeDetailGuid: String) {
  itemTypeDetail(itemTypeDetailGuid: $itemTypeDetailGuid) {
    ...ItemTypeDetailFragments
  }
}
    ${ItemTypeDetailFragmentsFragmentDoc}`;

/**
 * __useItemTypeDetailQuery__
 *
 * To run a query within a React component, call `useItemTypeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTypeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTypeDetailQuery({
 *   variables: {
 *      itemTypeDetailGuid: // value for 'itemTypeDetailGuid'
 *   },
 * });
 */
export function useItemTypeDetailQuery(baseOptions?: Apollo.QueryHookOptions<ItemTypeDetailQuery, ItemTypeDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemTypeDetailQuery, ItemTypeDetailQueryVariables>(ItemTypeDetailDocument, options);
      }
export function useItemTypeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemTypeDetailQuery, ItemTypeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemTypeDetailQuery, ItemTypeDetailQueryVariables>(ItemTypeDetailDocument, options);
        }
export type ItemTypeDetailQueryHookResult = ReturnType<typeof useItemTypeDetailQuery>;
export type ItemTypeDetailLazyQueryHookResult = ReturnType<typeof useItemTypeDetailLazyQuery>;
export type ItemTypeDetailQueryResult = Apollo.QueryResult<ItemTypeDetailQuery, ItemTypeDetailQueryVariables>;
export const ItemTypeDetailsDocument = gql`
    query ItemTypeDetails {
  itemTypeDetails {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...ItemTypeDetailFragments
      }
    }
    totalGuids
  }
}
    ${ItemTypeDetailFragmentsFragmentDoc}`;

/**
 * __useItemTypeDetailsQuery__
 *
 * To run a query within a React component, call `useItemTypeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTypeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTypeDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemTypeDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ItemTypeDetailsQuery, ItemTypeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemTypeDetailsQuery, ItemTypeDetailsQueryVariables>(ItemTypeDetailsDocument, options);
      }
export function useItemTypeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemTypeDetailsQuery, ItemTypeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemTypeDetailsQuery, ItemTypeDetailsQueryVariables>(ItemTypeDetailsDocument, options);
        }
export type ItemTypeDetailsQueryHookResult = ReturnType<typeof useItemTypeDetailsQuery>;
export type ItemTypeDetailsLazyQueryHookResult = ReturnType<typeof useItemTypeDetailsLazyQuery>;
export type ItemTypeDetailsQueryResult = Apollo.QueryResult<ItemTypeDetailsQuery, ItemTypeDetailsQueryVariables>;
export const ItemTypeDetailsPaginatedDocument = gql`
    query ItemTypeDetailsPaginated($search: SearchAdminComponentInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  itemTypeDetailsPaginated(
    search: $search
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...ItemTypeDetailFragments
      }
    }
    totalGuids
  }
}
    ${ItemTypeDetailFragmentsFragmentDoc}`;

/**
 * __useItemTypeDetailsPaginatedQuery__
 *
 * To run a query within a React component, call `useItemTypeDetailsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTypeDetailsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTypeDetailsPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useItemTypeDetailsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<ItemTypeDetailsPaginatedQuery, ItemTypeDetailsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemTypeDetailsPaginatedQuery, ItemTypeDetailsPaginatedQueryVariables>(ItemTypeDetailsPaginatedDocument, options);
      }
export function useItemTypeDetailsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemTypeDetailsPaginatedQuery, ItemTypeDetailsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemTypeDetailsPaginatedQuery, ItemTypeDetailsPaginatedQueryVariables>(ItemTypeDetailsPaginatedDocument, options);
        }
export type ItemTypeDetailsPaginatedQueryHookResult = ReturnType<typeof useItemTypeDetailsPaginatedQuery>;
export type ItemTypeDetailsPaginatedLazyQueryHookResult = ReturnType<typeof useItemTypeDetailsPaginatedLazyQuery>;
export type ItemTypeDetailsPaginatedQueryResult = Apollo.QueryResult<ItemTypeDetailsPaginatedQuery, ItemTypeDetailsPaginatedQueryVariables>;
export const UpdateItemTypeDocument = gql`
    mutation UpdateItemType($itemType: ItemTypeInput!, $itemTypeGuid: String!) {
  updateItemType(itemType: $itemType, itemTypeGuid: $itemTypeGuid) {
    ...ItemTypeDetailFragments
  }
}
    ${ItemTypeDetailFragmentsFragmentDoc}`;
export type UpdateItemTypeMutationFn = Apollo.MutationFunction<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>;

/**
 * __useUpdateItemTypeMutation__
 *
 * To run a mutation, you first call `useUpdateItemTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemTypeMutation, { data, loading, error }] = useUpdateItemTypeMutation({
 *   variables: {
 *      itemType: // value for 'itemType'
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useUpdateItemTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>(UpdateItemTypeDocument, options);
      }
export type UpdateItemTypeMutationHookResult = ReturnType<typeof useUpdateItemTypeMutation>;
export type UpdateItemTypeMutationResult = Apollo.MutationResult<UpdateItemTypeMutation>;
export type UpdateItemTypeMutationOptions = Apollo.BaseMutationOptions<UpdateItemTypeMutation, UpdateItemTypeMutationVariables>;
export const CreateItemTypeDocument = gql`
    mutation CreateItemType($itemType: ItemTypeInput!, $formGuid: String!, $itemCollectionTypeGuid: String!) {
  createItemType(
    itemType: $itemType
    formGuid: $formGuid
    itemCollectionTypeGuid: $itemCollectionTypeGuid
  ) {
    ...ItemTypeDetailFragments
  }
}
    ${ItemTypeDetailFragmentsFragmentDoc}`;
export type CreateItemTypeMutationFn = Apollo.MutationFunction<CreateItemTypeMutation, CreateItemTypeMutationVariables>;

/**
 * __useCreateItemTypeMutation__
 *
 * To run a mutation, you first call `useCreateItemTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemTypeMutation, { data, loading, error }] = useCreateItemTypeMutation({
 *   variables: {
 *      itemType: // value for 'itemType'
 *      formGuid: // value for 'formGuid'
 *      itemCollectionTypeGuid: // value for 'itemCollectionTypeGuid'
 *   },
 * });
 */
export function useCreateItemTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemTypeMutation, CreateItemTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemTypeMutation, CreateItemTypeMutationVariables>(CreateItemTypeDocument, options);
      }
export type CreateItemTypeMutationHookResult = ReturnType<typeof useCreateItemTypeMutation>;
export type CreateItemTypeMutationResult = Apollo.MutationResult<CreateItemTypeMutation>;
export type CreateItemTypeMutationOptions = Apollo.BaseMutationOptions<CreateItemTypeMutation, CreateItemTypeMutationVariables>;
export const DeleteItemTypeDocument = gql`
    mutation DeleteItemType($itemTypeGuid: String!) {
  deleteItemType(itemTypeGuid: $itemTypeGuid)
}
    `;
export type DeleteItemTypeMutationFn = Apollo.MutationFunction<DeleteItemTypeMutation, DeleteItemTypeMutationVariables>;

/**
 * __useDeleteItemTypeMutation__
 *
 * To run a mutation, you first call `useDeleteItemTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemTypeMutation, { data, loading, error }] = useDeleteItemTypeMutation({
 *   variables: {
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useDeleteItemTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemTypeMutation, DeleteItemTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemTypeMutation, DeleteItemTypeMutationVariables>(DeleteItemTypeDocument, options);
      }
export type DeleteItemTypeMutationHookResult = ReturnType<typeof useDeleteItemTypeMutation>;
export type DeleteItemTypeMutationResult = Apollo.MutationResult<DeleteItemTypeMutation>;
export type DeleteItemTypeMutationOptions = Apollo.BaseMutationOptions<DeleteItemTypeMutation, DeleteItemTypeMutationVariables>;
export const LocationsDocument = gql`
    query Locations($locationGuid: String) {
  location(locationGuid: $locationGuid) {
    ...LocationFragments
  }
}
    ${LocationFragmentsFragmentDoc}`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      locationGuid: // value for 'locationGuid'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($location: LocationInput!, $itemTypeGuid: String!) {
  createLocation(location: $location, itemTypeGuid: $itemTypeGuid) {
    ...LocationFragments
    guid
  }
}
    ${LocationFragmentsFragmentDoc}`;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const LocationOptionsDocument = gql`
    query LocationOptions($itemTypeGuid: String!) {
  locationOptions(itemTypeGuid: $itemTypeGuid) {
    id
    title
  }
}
    `;

/**
 * __useLocationOptionsQuery__
 *
 * To run a query within a React component, call `useLocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationOptionsQuery({
 *   variables: {
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useLocationOptionsQuery(baseOptions: Apollo.QueryHookOptions<LocationOptionsQuery, LocationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationOptionsQuery, LocationOptionsQueryVariables>(LocationOptionsDocument, options);
      }
export function useLocationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationOptionsQuery, LocationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationOptionsQuery, LocationOptionsQueryVariables>(LocationOptionsDocument, options);
        }
export type LocationOptionsQueryHookResult = ReturnType<typeof useLocationOptionsQuery>;
export type LocationOptionsLazyQueryHookResult = ReturnType<typeof useLocationOptionsLazyQuery>;
export type LocationOptionsQueryResult = Apollo.QueryResult<LocationOptionsQuery, LocationOptionsQueryVariables>;
export const LocationsForMuseumDocument = gql`
    query LocationsForMuseum {
  locationsForMuseum {
    ...LocationFragments
  }
}
    ${LocationFragmentsFragmentDoc}`;

/**
 * __useLocationsForMuseumQuery__
 *
 * To run a query within a React component, call `useLocationsForMuseumQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsForMuseumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsForMuseumQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsForMuseumQuery(baseOptions?: Apollo.QueryHookOptions<LocationsForMuseumQuery, LocationsForMuseumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsForMuseumQuery, LocationsForMuseumQueryVariables>(LocationsForMuseumDocument, options);
      }
export function useLocationsForMuseumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsForMuseumQuery, LocationsForMuseumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsForMuseumQuery, LocationsForMuseumQueryVariables>(LocationsForMuseumDocument, options);
        }
export type LocationsForMuseumQueryHookResult = ReturnType<typeof useLocationsForMuseumQuery>;
export type LocationsForMuseumLazyQueryHookResult = ReturnType<typeof useLocationsForMuseumLazyQuery>;
export type LocationsForMuseumQueryResult = Apollo.QueryResult<LocationsForMuseumQuery, LocationsForMuseumQueryVariables>;
export const LocationOptionsByFormDocument = gql`
    query LocationOptionsByForm($formCode: String) {
  locationOptionsByForm(formCode: $formCode) {
    id
    title
  }
  coldLocationOptionsByForm(formCode: $formCode) {
    id
    title
  }
}
    `;

/**
 * __useLocationOptionsByFormQuery__
 *
 * To run a query within a React component, call `useLocationOptionsByFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationOptionsByFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationOptionsByFormQuery({
 *   variables: {
 *      formCode: // value for 'formCode'
 *   },
 * });
 */
export function useLocationOptionsByFormQuery(baseOptions?: Apollo.QueryHookOptions<LocationOptionsByFormQuery, LocationOptionsByFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationOptionsByFormQuery, LocationOptionsByFormQueryVariables>(LocationOptionsByFormDocument, options);
      }
export function useLocationOptionsByFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationOptionsByFormQuery, LocationOptionsByFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationOptionsByFormQuery, LocationOptionsByFormQueryVariables>(LocationOptionsByFormDocument, options);
        }
export type LocationOptionsByFormQueryHookResult = ReturnType<typeof useLocationOptionsByFormQuery>;
export type LocationOptionsByFormLazyQueryHookResult = ReturnType<typeof useLocationOptionsByFormLazyQuery>;
export type LocationOptionsByFormQueryResult = Apollo.QueryResult<LocationOptionsByFormQuery, LocationOptionsByFormQueryVariables>;
export const ColdLocationOptionsDocument = gql`
    query ColdLocationOptions($itemTypeGuid: String!) {
  coldLocationOptions(itemTypeGuid: $itemTypeGuid) {
    id
    title
  }
}
    `;

/**
 * __useColdLocationOptionsQuery__
 *
 * To run a query within a React component, call `useColdLocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColdLocationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColdLocationOptionsQuery({
 *   variables: {
 *      itemTypeGuid: // value for 'itemTypeGuid'
 *   },
 * });
 */
export function useColdLocationOptionsQuery(baseOptions: Apollo.QueryHookOptions<ColdLocationOptionsQuery, ColdLocationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColdLocationOptionsQuery, ColdLocationOptionsQueryVariables>(ColdLocationOptionsDocument, options);
      }
export function useColdLocationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColdLocationOptionsQuery, ColdLocationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColdLocationOptionsQuery, ColdLocationOptionsQueryVariables>(ColdLocationOptionsDocument, options);
        }
export type ColdLocationOptionsQueryHookResult = ReturnType<typeof useColdLocationOptionsQuery>;
export type ColdLocationOptionsLazyQueryHookResult = ReturnType<typeof useColdLocationOptionsLazyQuery>;
export type ColdLocationOptionsQueryResult = Apollo.QueryResult<ColdLocationOptionsQuery, ColdLocationOptionsQueryVariables>;
export const OriginsDocument = gql`
    query Origins($search: SearchOriginsInput) {
  origins(search: $search) {
    ...OriginFragments
  }
}
    ${OriginFragmentsFragmentDoc}`;

/**
 * __useOriginsQuery__
 *
 * To run a query within a React component, call `useOriginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOriginsQuery(baseOptions?: Apollo.QueryHookOptions<OriginsQuery, OriginsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginsQuery, OriginsQueryVariables>(OriginsDocument, options);
      }
export function useOriginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginsQuery, OriginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginsQuery, OriginsQueryVariables>(OriginsDocument, options);
        }
export type OriginsQueryHookResult = ReturnType<typeof useOriginsQuery>;
export type OriginsLazyQueryHookResult = ReturnType<typeof useOriginsLazyQuery>;
export type OriginsQueryResult = Apollo.QueryResult<OriginsQuery, OriginsQueryVariables>;
export const OriginDocument = gql`
    query Origin($originGuid: String) {
  origin(originGuid: $originGuid) {
    ...OriginFragments
  }
  customerOptions {
    id
    title
  }
  userOptions {
    id
    title
  }
  originTypeOptions {
    id
    title
  }
}
    ${OriginFragmentsFragmentDoc}`;

/**
 * __useOriginQuery__
 *
 * To run a query within a React component, call `useOriginQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginQuery({
 *   variables: {
 *      originGuid: // value for 'originGuid'
 *   },
 * });
 */
export function useOriginQuery(baseOptions?: Apollo.QueryHookOptions<OriginQuery, OriginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginQuery, OriginQueryVariables>(OriginDocument, options);
      }
export function useOriginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginQuery, OriginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginQuery, OriginQueryVariables>(OriginDocument, options);
        }
export type OriginQueryHookResult = ReturnType<typeof useOriginQuery>;
export type OriginLazyQueryHookResult = ReturnType<typeof useOriginLazyQuery>;
export type OriginQueryResult = Apollo.QueryResult<OriginQuery, OriginQueryVariables>;
export const OriginsPaginatedDocument = gql`
    query OriginsPaginated($search: SearchOriginsInput, $filter: FilterOriginsInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  originsPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...OriginFragments
      }
    }
    totalGuids
  }
}
    ${OriginFragmentsFragmentDoc}`;

/**
 * __useOriginsPaginatedQuery__
 *
 * To run a query within a React component, call `useOriginsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginsPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useOriginsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<OriginsPaginatedQuery, OriginsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginsPaginatedQuery, OriginsPaginatedQueryVariables>(OriginsPaginatedDocument, options);
      }
export function useOriginsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginsPaginatedQuery, OriginsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginsPaginatedQuery, OriginsPaginatedQueryVariables>(OriginsPaginatedDocument, options);
        }
export type OriginsPaginatedQueryHookResult = ReturnType<typeof useOriginsPaginatedQuery>;
export type OriginsPaginatedLazyQueryHookResult = ReturnType<typeof useOriginsPaginatedLazyQuery>;
export type OriginsPaginatedQueryResult = Apollo.QueryResult<OriginsPaginatedQuery, OriginsPaginatedQueryVariables>;
export const OriginCreateOptionsDocument = gql`
    query OriginCreateOptions {
  customerOptions {
    id
    title
  }
  userOptions {
    id
    title
  }
  originTypeOptions {
    id
    title
  }
}
    `;

/**
 * __useOriginCreateOptionsQuery__
 *
 * To run a query within a React component, call `useOriginCreateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginCreateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginCreateOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOriginCreateOptionsQuery(baseOptions?: Apollo.QueryHookOptions<OriginCreateOptionsQuery, OriginCreateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginCreateOptionsQuery, OriginCreateOptionsQueryVariables>(OriginCreateOptionsDocument, options);
      }
export function useOriginCreateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginCreateOptionsQuery, OriginCreateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginCreateOptionsQuery, OriginCreateOptionsQueryVariables>(OriginCreateOptionsDocument, options);
        }
export type OriginCreateOptionsQueryHookResult = ReturnType<typeof useOriginCreateOptionsQuery>;
export type OriginCreateOptionsLazyQueryHookResult = ReturnType<typeof useOriginCreateOptionsLazyQuery>;
export type OriginCreateOptionsQueryResult = Apollo.QueryResult<OriginCreateOptionsQuery, OriginCreateOptionsQueryVariables>;
export const OriginOptionsDocument = gql`
    query OriginOptions {
  originOptions {
    id
    title
  }
}
    `;

/**
 * __useOriginOptionsQuery__
 *
 * To run a query within a React component, call `useOriginOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOriginOptionsQuery(baseOptions?: Apollo.QueryHookOptions<OriginOptionsQuery, OriginOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginOptionsQuery, OriginOptionsQueryVariables>(OriginOptionsDocument, options);
      }
export function useOriginOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginOptionsQuery, OriginOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginOptionsQuery, OriginOptionsQueryVariables>(OriginOptionsDocument, options);
        }
export type OriginOptionsQueryHookResult = ReturnType<typeof useOriginOptionsQuery>;
export type OriginOptionsLazyQueryHookResult = ReturnType<typeof useOriginOptionsLazyQuery>;
export type OriginOptionsQueryResult = Apollo.QueryResult<OriginOptionsQuery, OriginOptionsQueryVariables>;
export const OriginNumberAutoCompleteOptionsDocument = gql`
    query OriginNumberAutoCompleteOptions($query: String) {
  originNumberOptions(query: $query) {
    id
    title
  }
}
    `;

/**
 * __useOriginNumberAutoCompleteOptionsQuery__
 *
 * To run a query within a React component, call `useOriginNumberAutoCompleteOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginNumberAutoCompleteOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginNumberAutoCompleteOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useOriginNumberAutoCompleteOptionsQuery(baseOptions?: Apollo.QueryHookOptions<OriginNumberAutoCompleteOptionsQuery, OriginNumberAutoCompleteOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginNumberAutoCompleteOptionsQuery, OriginNumberAutoCompleteOptionsQueryVariables>(OriginNumberAutoCompleteOptionsDocument, options);
      }
export function useOriginNumberAutoCompleteOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginNumberAutoCompleteOptionsQuery, OriginNumberAutoCompleteOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginNumberAutoCompleteOptionsQuery, OriginNumberAutoCompleteOptionsQueryVariables>(OriginNumberAutoCompleteOptionsDocument, options);
        }
export type OriginNumberAutoCompleteOptionsQueryHookResult = ReturnType<typeof useOriginNumberAutoCompleteOptionsQuery>;
export type OriginNumberAutoCompleteOptionsLazyQueryHookResult = ReturnType<typeof useOriginNumberAutoCompleteOptionsLazyQuery>;
export type OriginNumberAutoCompleteOptionsQueryResult = Apollo.QueryResult<OriginNumberAutoCompleteOptionsQuery, OriginNumberAutoCompleteOptionsQueryVariables>;
export const CreateOriginDocument = gql`
    mutation CreateOrigin($origin: OriginInput!) {
  createOrigin(origin: $origin) {
    ...OriginFragments
  }
}
    ${OriginFragmentsFragmentDoc}`;
export type CreateOriginMutationFn = Apollo.MutationFunction<CreateOriginMutation, CreateOriginMutationVariables>;

/**
 * __useCreateOriginMutation__
 *
 * To run a mutation, you first call `useCreateOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOriginMutation, { data, loading, error }] = useCreateOriginMutation({
 *   variables: {
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useCreateOriginMutation(baseOptions?: Apollo.MutationHookOptions<CreateOriginMutation, CreateOriginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOriginMutation, CreateOriginMutationVariables>(CreateOriginDocument, options);
      }
export type CreateOriginMutationHookResult = ReturnType<typeof useCreateOriginMutation>;
export type CreateOriginMutationResult = Apollo.MutationResult<CreateOriginMutation>;
export type CreateOriginMutationOptions = Apollo.BaseMutationOptions<CreateOriginMutation, CreateOriginMutationVariables>;
export const UpdateOriginDocument = gql`
    mutation UpdateOrigin($origin: OriginInput!, $originGuid: String) {
  updateOrigin(origin: $origin, originGuid: $originGuid) {
    ...OriginFragments
  }
}
    ${OriginFragmentsFragmentDoc}`;
export type UpdateOriginMutationFn = Apollo.MutationFunction<UpdateOriginMutation, UpdateOriginMutationVariables>;

/**
 * __useUpdateOriginMutation__
 *
 * To run a mutation, you first call `useUpdateOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOriginMutation, { data, loading, error }] = useUpdateOriginMutation({
 *   variables: {
 *      origin: // value for 'origin'
 *      originGuid: // value for 'originGuid'
 *   },
 * });
 */
export function useUpdateOriginMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOriginMutation, UpdateOriginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOriginMutation, UpdateOriginMutationVariables>(UpdateOriginDocument, options);
      }
export type UpdateOriginMutationHookResult = ReturnType<typeof useUpdateOriginMutation>;
export type UpdateOriginMutationResult = Apollo.MutationResult<UpdateOriginMutation>;
export type UpdateOriginMutationOptions = Apollo.BaseMutationOptions<UpdateOriginMutation, UpdateOriginMutationVariables>;
export const DeleteOriginDocument = gql`
    mutation DeleteOrigin($originGuid: String!) {
  deleteOrigin(originGuid: $originGuid)
}
    `;
export type DeleteOriginMutationFn = Apollo.MutationFunction<DeleteOriginMutation, DeleteOriginMutationVariables>;

/**
 * __useDeleteOriginMutation__
 *
 * To run a mutation, you first call `useDeleteOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOriginMutation, { data, loading, error }] = useDeleteOriginMutation({
 *   variables: {
 *      originGuid: // value for 'originGuid'
 *   },
 * });
 */
export function useDeleteOriginMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOriginMutation, DeleteOriginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOriginMutation, DeleteOriginMutationVariables>(DeleteOriginDocument, options);
      }
export type DeleteOriginMutationHookResult = ReturnType<typeof useDeleteOriginMutation>;
export type DeleteOriginMutationResult = Apollo.MutationResult<DeleteOriginMutation>;
export type DeleteOriginMutationOptions = Apollo.BaseMutationOptions<DeleteOriginMutation, DeleteOriginMutationVariables>;
export const OriginNumberDocument = gql`
    query OriginNumber($originGuid: String!) {
  originNumber(originGuid: $originGuid)
}
    `;

/**
 * __useOriginNumberQuery__
 *
 * To run a query within a React component, call `useOriginNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginNumberQuery({
 *   variables: {
 *      originGuid: // value for 'originGuid'
 *   },
 * });
 */
export function useOriginNumberQuery(baseOptions: Apollo.QueryHookOptions<OriginNumberQuery, OriginNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginNumberQuery, OriginNumberQueryVariables>(OriginNumberDocument, options);
      }
export function useOriginNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginNumberQuery, OriginNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginNumberQuery, OriginNumberQueryVariables>(OriginNumberDocument, options);
        }
export type OriginNumberQueryHookResult = ReturnType<typeof useOriginNumberQuery>;
export type OriginNumberLazyQueryHookResult = ReturnType<typeof useOriginNumberLazyQuery>;
export type OriginNumberQueryResult = Apollo.QueryResult<OriginNumberQuery, OriginNumberQueryVariables>;
export const OriginTypesDocument = gql`
    query OriginTypes {
  originTypes {
    ...OriginTypeFragments
  }
}
    ${OriginTypeFragmentsFragmentDoc}`;

/**
 * __useOriginTypesQuery__
 *
 * To run a query within a React component, call `useOriginTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOriginTypesQuery(baseOptions?: Apollo.QueryHookOptions<OriginTypesQuery, OriginTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginTypesQuery, OriginTypesQueryVariables>(OriginTypesDocument, options);
      }
export function useOriginTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginTypesQuery, OriginTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginTypesQuery, OriginTypesQueryVariables>(OriginTypesDocument, options);
        }
export type OriginTypesQueryHookResult = ReturnType<typeof useOriginTypesQuery>;
export type OriginTypesLazyQueryHookResult = ReturnType<typeof useOriginTypesLazyQuery>;
export type OriginTypesQueryResult = Apollo.QueryResult<OriginTypesQuery, OriginTypesQueryVariables>;
export const OriginTypeDocument = gql`
    query OriginType($originTypeGuid: String) {
  originType(originTypeGuid: $originTypeGuid) {
    ...OriginTypeFragments
  }
}
    ${OriginTypeFragmentsFragmentDoc}`;

/**
 * __useOriginTypeQuery__
 *
 * To run a query within a React component, call `useOriginTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginTypeQuery({
 *   variables: {
 *      originTypeGuid: // value for 'originTypeGuid'
 *   },
 * });
 */
export function useOriginTypeQuery(baseOptions?: Apollo.QueryHookOptions<OriginTypeQuery, OriginTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginTypeQuery, OriginTypeQueryVariables>(OriginTypeDocument, options);
      }
export function useOriginTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginTypeQuery, OriginTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginTypeQuery, OriginTypeQueryVariables>(OriginTypeDocument, options);
        }
export type OriginTypeQueryHookResult = ReturnType<typeof useOriginTypeQuery>;
export type OriginTypeLazyQueryHookResult = ReturnType<typeof useOriginTypeLazyQuery>;
export type OriginTypeQueryResult = Apollo.QueryResult<OriginTypeQuery, OriginTypeQueryVariables>;
export const CreateOriginTypeDocument = gql`
    mutation CreateOriginType($originType: OriginTypeInput!) {
  createOriginType(originType: $originType) {
    ...OriginTypeFragments
  }
}
    ${OriginTypeFragmentsFragmentDoc}`;
export type CreateOriginTypeMutationFn = Apollo.MutationFunction<CreateOriginTypeMutation, CreateOriginTypeMutationVariables>;

/**
 * __useCreateOriginTypeMutation__
 *
 * To run a mutation, you first call `useCreateOriginTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOriginTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOriginTypeMutation, { data, loading, error }] = useCreateOriginTypeMutation({
 *   variables: {
 *      originType: // value for 'originType'
 *   },
 * });
 */
export function useCreateOriginTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOriginTypeMutation, CreateOriginTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOriginTypeMutation, CreateOriginTypeMutationVariables>(CreateOriginTypeDocument, options);
      }
export type CreateOriginTypeMutationHookResult = ReturnType<typeof useCreateOriginTypeMutation>;
export type CreateOriginTypeMutationResult = Apollo.MutationResult<CreateOriginTypeMutation>;
export type CreateOriginTypeMutationOptions = Apollo.BaseMutationOptions<CreateOriginTypeMutation, CreateOriginTypeMutationVariables>;
export const DeleteOriginTypeDocument = gql`
    mutation DeleteOriginType($originTypeGuid: String!) {
  deleteOriginType(originTypeGuid: $originTypeGuid)
}
    `;
export type DeleteOriginTypeMutationFn = Apollo.MutationFunction<DeleteOriginTypeMutation, DeleteOriginTypeMutationVariables>;

/**
 * __useDeleteOriginTypeMutation__
 *
 * To run a mutation, you first call `useDeleteOriginTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOriginTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOriginTypeMutation, { data, loading, error }] = useDeleteOriginTypeMutation({
 *   variables: {
 *      originTypeGuid: // value for 'originTypeGuid'
 *   },
 * });
 */
export function useDeleteOriginTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOriginTypeMutation, DeleteOriginTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOriginTypeMutation, DeleteOriginTypeMutationVariables>(DeleteOriginTypeDocument, options);
      }
export type DeleteOriginTypeMutationHookResult = ReturnType<typeof useDeleteOriginTypeMutation>;
export type DeleteOriginTypeMutationResult = Apollo.MutationResult<DeleteOriginTypeMutation>;
export type DeleteOriginTypeMutationOptions = Apollo.BaseMutationOptions<DeleteOriginTypeMutation, DeleteOriginTypeMutationVariables>;
export const OriginalTitlesDocument = gql`
    query OriginalTitles {
  originalTitles {
    ...OriginalTitleFragments
  }
  titles {
    ...TitleFragments
  }
  credits {
    ...CreditFragments
  }
}
    ${OriginalTitleFragmentsFragmentDoc}
${TitleFragmentsFragmentDoc}
${CreditFragmentsFragmentDoc}`;

/**
 * __useOriginalTitlesQuery__
 *
 * To run a query within a React component, call `useOriginalTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginalTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginalTitlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOriginalTitlesQuery(baseOptions?: Apollo.QueryHookOptions<OriginalTitlesQuery, OriginalTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginalTitlesQuery, OriginalTitlesQueryVariables>(OriginalTitlesDocument, options);
      }
export function useOriginalTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginalTitlesQuery, OriginalTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginalTitlesQuery, OriginalTitlesQueryVariables>(OriginalTitlesDocument, options);
        }
export type OriginalTitlesQueryHookResult = ReturnType<typeof useOriginalTitlesQuery>;
export type OriginalTitlesLazyQueryHookResult = ReturnType<typeof useOriginalTitlesLazyQuery>;
export type OriginalTitlesQueryResult = Apollo.QueryResult<OriginalTitlesQuery, OriginalTitlesQueryVariables>;
export const OriginalTitleDocument = gql`
    query OriginalTitle($originalTitleGuid: String) {
  originalTitle(originalTitleGuid: $originalTitleGuid) {
    ...OriginalTitleFragments
  }
  sourceOptions {
    id
    title
  }
  countryOfOriginOptions {
    id
    title
  }
  overClassificationOptions {
    id
    title
    groupCode
    displayOrder
  }
  subClassificationOptions {
    id
    title
    groupCode
    displayOrder
  }
}
    ${OriginalTitleFragmentsFragmentDoc}`;

/**
 * __useOriginalTitleQuery__
 *
 * To run a query within a React component, call `useOriginalTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginalTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginalTitleQuery({
 *   variables: {
 *      originalTitleGuid: // value for 'originalTitleGuid'
 *   },
 * });
 */
export function useOriginalTitleQuery(baseOptions?: Apollo.QueryHookOptions<OriginalTitleQuery, OriginalTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginalTitleQuery, OriginalTitleQueryVariables>(OriginalTitleDocument, options);
      }
export function useOriginalTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginalTitleQuery, OriginalTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginalTitleQuery, OriginalTitleQueryVariables>(OriginalTitleDocument, options);
        }
export type OriginalTitleQueryHookResult = ReturnType<typeof useOriginalTitleQuery>;
export type OriginalTitleLazyQueryHookResult = ReturnType<typeof useOriginalTitleLazyQuery>;
export type OriginalTitleQueryResult = Apollo.QueryResult<OriginalTitleQuery, OriginalTitleQueryVariables>;
export const OriginalTitlesPaginatedDocument = gql`
    query OriginalTitlesPaginated($search: SearchOriginalTitlesInput, $filter: FilterOriginalTitleInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  originalTitlesPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...OriginalTitleFragments
      }
    }
    totalGuids
  }
}
    ${OriginalTitleFragmentsFragmentDoc}`;

/**
 * __useOriginalTitlesPaginatedQuery__
 *
 * To run a query within a React component, call `useOriginalTitlesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginalTitlesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginalTitlesPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useOriginalTitlesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<OriginalTitlesPaginatedQuery, OriginalTitlesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginalTitlesPaginatedQuery, OriginalTitlesPaginatedQueryVariables>(OriginalTitlesPaginatedDocument, options);
      }
export function useOriginalTitlesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginalTitlesPaginatedQuery, OriginalTitlesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginalTitlesPaginatedQuery, OriginalTitlesPaginatedQueryVariables>(OriginalTitlesPaginatedDocument, options);
        }
export type OriginalTitlesPaginatedQueryHookResult = ReturnType<typeof useOriginalTitlesPaginatedQuery>;
export type OriginalTitlesPaginatedLazyQueryHookResult = ReturnType<typeof useOriginalTitlesPaginatedLazyQuery>;
export type OriginalTitlesPaginatedQueryResult = Apollo.QueryResult<OriginalTitlesPaginatedQuery, OriginalTitlesPaginatedQueryVariables>;
export const CreateOriginalTitleDocument = gql`
    mutation CreateOriginalTitle($originalTitle: OriginalTitleInput!) {
  createOriginalTitle(originalTitle: $originalTitle) {
    ...OriginalTitleFragments
  }
}
    ${OriginalTitleFragmentsFragmentDoc}`;
export type CreateOriginalTitleMutationFn = Apollo.MutationFunction<CreateOriginalTitleMutation, CreateOriginalTitleMutationVariables>;

/**
 * __useCreateOriginalTitleMutation__
 *
 * To run a mutation, you first call `useCreateOriginalTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOriginalTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOriginalTitleMutation, { data, loading, error }] = useCreateOriginalTitleMutation({
 *   variables: {
 *      originalTitle: // value for 'originalTitle'
 *   },
 * });
 */
export function useCreateOriginalTitleMutation(baseOptions?: Apollo.MutationHookOptions<CreateOriginalTitleMutation, CreateOriginalTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOriginalTitleMutation, CreateOriginalTitleMutationVariables>(CreateOriginalTitleDocument, options);
      }
export type CreateOriginalTitleMutationHookResult = ReturnType<typeof useCreateOriginalTitleMutation>;
export type CreateOriginalTitleMutationResult = Apollo.MutationResult<CreateOriginalTitleMutation>;
export type CreateOriginalTitleMutationOptions = Apollo.BaseMutationOptions<CreateOriginalTitleMutation, CreateOriginalTitleMutationVariables>;
export const UpdateOriginalTitleDocument = gql`
    mutation UpdateOriginalTitle($originalTitle: OriginalTitleInput!, $originalTitleGuid: String) {
  updateOriginalTitle(
    originalTitle: $originalTitle
    originalTitleGuid: $originalTitleGuid
  ) {
    ...OriginalTitleFragments
  }
}
    ${OriginalTitleFragmentsFragmentDoc}`;
export type UpdateOriginalTitleMutationFn = Apollo.MutationFunction<UpdateOriginalTitleMutation, UpdateOriginalTitleMutationVariables>;

/**
 * __useUpdateOriginalTitleMutation__
 *
 * To run a mutation, you first call `useUpdateOriginalTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOriginalTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOriginalTitleMutation, { data, loading, error }] = useUpdateOriginalTitleMutation({
 *   variables: {
 *      originalTitle: // value for 'originalTitle'
 *      originalTitleGuid: // value for 'originalTitleGuid'
 *   },
 * });
 */
export function useUpdateOriginalTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOriginalTitleMutation, UpdateOriginalTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOriginalTitleMutation, UpdateOriginalTitleMutationVariables>(UpdateOriginalTitleDocument, options);
      }
export type UpdateOriginalTitleMutationHookResult = ReturnType<typeof useUpdateOriginalTitleMutation>;
export type UpdateOriginalTitleMutationResult = Apollo.MutationResult<UpdateOriginalTitleMutation>;
export type UpdateOriginalTitleMutationOptions = Apollo.BaseMutationOptions<UpdateOriginalTitleMutation, UpdateOriginalTitleMutationVariables>;
export const DeleteOriginalTitleDocument = gql`
    mutation DeleteOriginalTitle($originalTitleGuid: String!) {
  deleteOriginalTitle(originalTitleGuid: $originalTitleGuid)
}
    `;
export type DeleteOriginalTitleMutationFn = Apollo.MutationFunction<DeleteOriginalTitleMutation, DeleteOriginalTitleMutationVariables>;

/**
 * __useDeleteOriginalTitleMutation__
 *
 * To run a mutation, you first call `useDeleteOriginalTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOriginalTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOriginalTitleMutation, { data, loading, error }] = useDeleteOriginalTitleMutation({
 *   variables: {
 *      originalTitleGuid: // value for 'originalTitleGuid'
 *   },
 * });
 */
export function useDeleteOriginalTitleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOriginalTitleMutation, DeleteOriginalTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOriginalTitleMutation, DeleteOriginalTitleMutationVariables>(DeleteOriginalTitleDocument, options);
      }
export type DeleteOriginalTitleMutationHookResult = ReturnType<typeof useDeleteOriginalTitleMutation>;
export type DeleteOriginalTitleMutationResult = Apollo.MutationResult<DeleteOriginalTitleMutation>;
export type DeleteOriginalTitleMutationOptions = Apollo.BaseMutationOptions<DeleteOriginalTitleMutation, DeleteOriginalTitleMutationVariables>;
export const OriginTitlesCreateOptionsDocument = gql`
    query OriginTitlesCreateOptions {
  sourceOptions {
    id
    title
  }
  countryOfOriginOptions {
    id
    title
  }
  overClassificationOptions {
    id
    title
    groupCode
    displayOrder
  }
  subClassificationOptions {
    id
    title
    groupCode
    displayOrder
  }
}
    `;

/**
 * __useOriginTitlesCreateOptionsQuery__
 *
 * To run a query within a React component, call `useOriginTitlesCreateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginTitlesCreateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginTitlesCreateOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOriginTitlesCreateOptionsQuery(baseOptions?: Apollo.QueryHookOptions<OriginTitlesCreateOptionsQuery, OriginTitlesCreateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginTitlesCreateOptionsQuery, OriginTitlesCreateOptionsQueryVariables>(OriginTitlesCreateOptionsDocument, options);
      }
export function useOriginTitlesCreateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginTitlesCreateOptionsQuery, OriginTitlesCreateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginTitlesCreateOptionsQuery, OriginTitlesCreateOptionsQueryVariables>(OriginTitlesCreateOptionsDocument, options);
        }
export type OriginTitlesCreateOptionsQueryHookResult = ReturnType<typeof useOriginTitlesCreateOptionsQuery>;
export type OriginTitlesCreateOptionsLazyQueryHookResult = ReturnType<typeof useOriginTitlesCreateOptionsLazyQuery>;
export type OriginTitlesCreateOptionsQueryResult = Apollo.QueryResult<OriginTitlesCreateOptionsQuery, OriginTitlesCreateOptionsQueryVariables>;
export const AutocompleteOriginalTitleOptionsDocument = gql`
    query AutocompleteOriginalTitleOptions($query: String) {
  originalTitleOptions(query: $query) {
    id
    title
  }
}
    `;

/**
 * __useAutocompleteOriginalTitleOptionsQuery__
 *
 * To run a query within a React component, call `useAutocompleteOriginalTitleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteOriginalTitleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteOriginalTitleOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAutocompleteOriginalTitleOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteOriginalTitleOptionsQuery, AutocompleteOriginalTitleOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteOriginalTitleOptionsQuery, AutocompleteOriginalTitleOptionsQueryVariables>(AutocompleteOriginalTitleOptionsDocument, options);
      }
export function useAutocompleteOriginalTitleOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteOriginalTitleOptionsQuery, AutocompleteOriginalTitleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteOriginalTitleOptionsQuery, AutocompleteOriginalTitleOptionsQueryVariables>(AutocompleteOriginalTitleOptionsDocument, options);
        }
export type AutocompleteOriginalTitleOptionsQueryHookResult = ReturnType<typeof useAutocompleteOriginalTitleOptionsQuery>;
export type AutocompleteOriginalTitleOptionsLazyQueryHookResult = ReturnType<typeof useAutocompleteOriginalTitleOptionsLazyQuery>;
export type AutocompleteOriginalTitleOptionsQueryResult = Apollo.QueryResult<AutocompleteOriginalTitleOptionsQuery, AutocompleteOriginalTitleOptionsQueryVariables>;
export const TitleCreditOptionsDocument = gql`
    query TitleCreditOptions($titleGuid: String) {
  titleCredits(titleGuid: $titleGuid) {
    ...CreditFragments
  }
}
    ${CreditFragmentsFragmentDoc}`;

/**
 * __useTitleCreditOptionsQuery__
 *
 * To run a query within a React component, call `useTitleCreditOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleCreditOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitleCreditOptionsQuery({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useTitleCreditOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TitleCreditOptionsQuery, TitleCreditOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitleCreditOptionsQuery, TitleCreditOptionsQueryVariables>(TitleCreditOptionsDocument, options);
      }
export function useTitleCreditOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitleCreditOptionsQuery, TitleCreditOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitleCreditOptionsQuery, TitleCreditOptionsQueryVariables>(TitleCreditOptionsDocument, options);
        }
export type TitleCreditOptionsQueryHookResult = ReturnType<typeof useTitleCreditOptionsQuery>;
export type TitleCreditOptionsLazyQueryHookResult = ReturnType<typeof useTitleCreditOptionsLazyQuery>;
export type TitleCreditOptionsQueryResult = Apollo.QueryResult<TitleCreditOptionsQuery, TitleCreditOptionsQueryVariables>;
export const OriginalTitleNameDocument = gql`
    query OriginalTitleName($originalTitleGuid: String!) {
  originalTitleTitle(originalTitleGuid: $originalTitleGuid)
}
    `;

/**
 * __useOriginalTitleNameQuery__
 *
 * To run a query within a React component, call `useOriginalTitleNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginalTitleNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginalTitleNameQuery({
 *   variables: {
 *      originalTitleGuid: // value for 'originalTitleGuid'
 *   },
 * });
 */
export function useOriginalTitleNameQuery(baseOptions: Apollo.QueryHookOptions<OriginalTitleNameQuery, OriginalTitleNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginalTitleNameQuery, OriginalTitleNameQueryVariables>(OriginalTitleNameDocument, options);
      }
export function useOriginalTitleNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginalTitleNameQuery, OriginalTitleNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginalTitleNameQuery, OriginalTitleNameQueryVariables>(OriginalTitleNameDocument, options);
        }
export type OriginalTitleNameQueryHookResult = ReturnType<typeof useOriginalTitleNameQuery>;
export type OriginalTitleNameLazyQueryHookResult = ReturnType<typeof useOriginalTitleNameLazyQuery>;
export type OriginalTitleNameQueryResult = Apollo.QueryResult<OriginalTitleNameQuery, OriginalTitleNameQueryVariables>;
export const CreateOriginalTitleTitleDocument = gql`
    mutation CreateOriginalTitleTitle($originalTitleTitle: OriginalTitleTitleInput!) {
  createOriginalTitleTitle(originalTitleTitle: $originalTitleTitle) {
    originalTitle {
      ...OriginalTitleFragments
    }
    title {
      ...TitleFragments
    }
  }
}
    ${OriginalTitleFragmentsFragmentDoc}
${TitleFragmentsFragmentDoc}`;
export type CreateOriginalTitleTitleMutationFn = Apollo.MutationFunction<CreateOriginalTitleTitleMutation, CreateOriginalTitleTitleMutationVariables>;

/**
 * __useCreateOriginalTitleTitleMutation__
 *
 * To run a mutation, you first call `useCreateOriginalTitleTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOriginalTitleTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOriginalTitleTitleMutation, { data, loading, error }] = useCreateOriginalTitleTitleMutation({
 *   variables: {
 *      originalTitleTitle: // value for 'originalTitleTitle'
 *   },
 * });
 */
export function useCreateOriginalTitleTitleMutation(baseOptions?: Apollo.MutationHookOptions<CreateOriginalTitleTitleMutation, CreateOriginalTitleTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOriginalTitleTitleMutation, CreateOriginalTitleTitleMutationVariables>(CreateOriginalTitleTitleDocument, options);
      }
export type CreateOriginalTitleTitleMutationHookResult = ReturnType<typeof useCreateOriginalTitleTitleMutation>;
export type CreateOriginalTitleTitleMutationResult = Apollo.MutationResult<CreateOriginalTitleTitleMutation>;
export type CreateOriginalTitleTitleMutationOptions = Apollo.BaseMutationOptions<CreateOriginalTitleTitleMutation, CreateOriginalTitleTitleMutationVariables>;
export const MergeOriginalTitlesDocument = gql`
    mutation MergeOriginalTitles($mergeOriginalTitleData: MergeOriginalTitleInput!) {
  mergeOriginalTitles(mergeOriginalTitleData: $mergeOriginalTitleData)
}
    `;
export type MergeOriginalTitlesMutationFn = Apollo.MutationFunction<MergeOriginalTitlesMutation, MergeOriginalTitlesMutationVariables>;

/**
 * __useMergeOriginalTitlesMutation__
 *
 * To run a mutation, you first call `useMergeOriginalTitlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeOriginalTitlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeOriginalTitlesMutation, { data, loading, error }] = useMergeOriginalTitlesMutation({
 *   variables: {
 *      mergeOriginalTitleData: // value for 'mergeOriginalTitleData'
 *   },
 * });
 */
export function useMergeOriginalTitlesMutation(baseOptions?: Apollo.MutationHookOptions<MergeOriginalTitlesMutation, MergeOriginalTitlesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeOriginalTitlesMutation, MergeOriginalTitlesMutationVariables>(MergeOriginalTitlesDocument, options);
      }
export type MergeOriginalTitlesMutationHookResult = ReturnType<typeof useMergeOriginalTitlesMutation>;
export type MergeOriginalTitlesMutationResult = Apollo.MutationResult<MergeOriginalTitlesMutation>;
export type MergeOriginalTitlesMutationOptions = Apollo.BaseMutationOptions<MergeOriginalTitlesMutation, MergeOriginalTitlesMutationVariables>;
export const OriginalTitlesOptionsDocument = gql`
    query OriginalTitlesOptions($originalTitleGuids: [String!]!) {
  originalTitlesOptions(originalTitleGuids: $originalTitleGuids) {
    id
    title
  }
}
    `;

/**
 * __useOriginalTitlesOptionsQuery__
 *
 * To run a query within a React component, call `useOriginalTitlesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginalTitlesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginalTitlesOptionsQuery({
 *   variables: {
 *      originalTitleGuids: // value for 'originalTitleGuids'
 *   },
 * });
 */
export function useOriginalTitlesOptionsQuery(baseOptions: Apollo.QueryHookOptions<OriginalTitlesOptionsQuery, OriginalTitlesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginalTitlesOptionsQuery, OriginalTitlesOptionsQueryVariables>(OriginalTitlesOptionsDocument, options);
      }
export function useOriginalTitlesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginalTitlesOptionsQuery, OriginalTitlesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginalTitlesOptionsQuery, OriginalTitlesOptionsQueryVariables>(OriginalTitlesOptionsDocument, options);
        }
export type OriginalTitlesOptionsQueryHookResult = ReturnType<typeof useOriginalTitlesOptionsQuery>;
export type OriginalTitlesOptionsLazyQueryHookResult = ReturnType<typeof useOriginalTitlesOptionsLazyQuery>;
export type OriginalTitlesOptionsQueryResult = Apollo.QueryResult<OriginalTitlesOptionsQuery, OriginalTitlesOptionsQueryVariables>;
export const RightsAgreementsDocument = gql`
    query RightsAgreements($customerGuid: String, $originalTitleGuid: String) {
  rightsAgreements(
    customerGuid: $customerGuid
    originalTitleGuid: $originalTitleGuid
  ) {
    blobFileGuid
    name
    dateCreated
    originalTitle
    originalTitleGuid
    customer
    customerGuid
    isDeleted
    rightsAgreementGuid
  }
}
    `;

/**
 * __useRightsAgreementsQuery__
 *
 * To run a query within a React component, call `useRightsAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRightsAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRightsAgreementsQuery({
 *   variables: {
 *      customerGuid: // value for 'customerGuid'
 *      originalTitleGuid: // value for 'originalTitleGuid'
 *   },
 * });
 */
export function useRightsAgreementsQuery(baseOptions?: Apollo.QueryHookOptions<RightsAgreementsQuery, RightsAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RightsAgreementsQuery, RightsAgreementsQueryVariables>(RightsAgreementsDocument, options);
      }
export function useRightsAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RightsAgreementsQuery, RightsAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RightsAgreementsQuery, RightsAgreementsQueryVariables>(RightsAgreementsDocument, options);
        }
export type RightsAgreementsQueryHookResult = ReturnType<typeof useRightsAgreementsQuery>;
export type RightsAgreementsLazyQueryHookResult = ReturnType<typeof useRightsAgreementsLazyQuery>;
export type RightsAgreementsQueryResult = Apollo.QueryResult<RightsAgreementsQuery, RightsAgreementsQueryVariables>;
export const ActivateOrDeactivateRightsAgreementDocument = gql`
    mutation ActivateOrDeactivateRightsAgreement($rightsAgreementGuid: String!, $active: Boolean!) {
  activateOrDeactivateRightsAgreement(
    rightsAgreementGuid: $rightsAgreementGuid
    active: $active
  )
}
    `;
export type ActivateOrDeactivateRightsAgreementMutationFn = Apollo.MutationFunction<ActivateOrDeactivateRightsAgreementMutation, ActivateOrDeactivateRightsAgreementMutationVariables>;

/**
 * __useActivateOrDeactivateRightsAgreementMutation__
 *
 * To run a mutation, you first call `useActivateOrDeactivateRightsAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateOrDeactivateRightsAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateOrDeactivateRightsAgreementMutation, { data, loading, error }] = useActivateOrDeactivateRightsAgreementMutation({
 *   variables: {
 *      rightsAgreementGuid: // value for 'rightsAgreementGuid'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useActivateOrDeactivateRightsAgreementMutation(baseOptions?: Apollo.MutationHookOptions<ActivateOrDeactivateRightsAgreementMutation, ActivateOrDeactivateRightsAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateOrDeactivateRightsAgreementMutation, ActivateOrDeactivateRightsAgreementMutationVariables>(ActivateOrDeactivateRightsAgreementDocument, options);
      }
export type ActivateOrDeactivateRightsAgreementMutationHookResult = ReturnType<typeof useActivateOrDeactivateRightsAgreementMutation>;
export type ActivateOrDeactivateRightsAgreementMutationResult = Apollo.MutationResult<ActivateOrDeactivateRightsAgreementMutation>;
export type ActivateOrDeactivateRightsAgreementMutationOptions = Apollo.BaseMutationOptions<ActivateOrDeactivateRightsAgreementMutation, ActivateOrDeactivateRightsAgreementMutationVariables>;
export const TagsDocument = gql`
    query Tags {
  tags {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...TagFragments
      }
    }
    totalGuids
  }
}
    ${TagFragmentsFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const TagDocument = gql`
    query Tag($tagGuid: String) {
  tag(tagGuid: $tagGuid) {
    ...TagFragments
  }
}
    ${TagFragmentsFragmentDoc}`;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      tagGuid: // value for 'tagGuid'
 *   },
 * });
 */
export function useTagQuery(baseOptions?: Apollo.QueryHookOptions<TagQuery, TagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagQuery, TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagQueryResult = Apollo.QueryResult<TagQuery, TagQueryVariables>;
export const TagsPaginatedDocument = gql`
    query TagsPaginated($search: SearchAdminComponentInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  tagsPaginated(
    search: $search
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...TagFragments
      }
    }
    totalGuids
  }
}
    ${TagFragmentsFragmentDoc}`;

/**
 * __useTagsPaginatedQuery__
 *
 * To run a query within a React component, call `useTagsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useTagsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<TagsPaginatedQuery, TagsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsPaginatedQuery, TagsPaginatedQueryVariables>(TagsPaginatedDocument, options);
      }
export function useTagsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsPaginatedQuery, TagsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsPaginatedQuery, TagsPaginatedQueryVariables>(TagsPaginatedDocument, options);
        }
export type TagsPaginatedQueryHookResult = ReturnType<typeof useTagsPaginatedQuery>;
export type TagsPaginatedLazyQueryHookResult = ReturnType<typeof useTagsPaginatedLazyQuery>;
export type TagsPaginatedQueryResult = Apollo.QueryResult<TagsPaginatedQuery, TagsPaginatedQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($tag: TagInput!) {
  createTag(tag: $tag) {
    ...TagFragments
  }
}
    ${TagFragmentsFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($tag: TagInput!, $tagGuid: String!) {
  updateTag(tag: $tag, tagGuid: $tagGuid) {
    ...TagFragments
  }
}
    ${TagFragmentsFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *      tagGuid: // value for 'tagGuid'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($tagGuid: String!) {
  deleteTag(tagGuid: $tagGuid)
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      tagGuid: // value for 'tagGuid'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const CustomerTagsOptionsDocument = gql`
    query CustomerTagsOptions {
  customerTagsOptions {
    id
    title
  }
}
    `;

/**
 * __useCustomerTagsOptionsQuery__
 *
 * To run a query within a React component, call `useCustomerTagsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTagsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTagsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerTagsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerTagsOptionsQuery, CustomerTagsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerTagsOptionsQuery, CustomerTagsOptionsQueryVariables>(CustomerTagsOptionsDocument, options);
      }
export function useCustomerTagsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerTagsOptionsQuery, CustomerTagsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerTagsOptionsQuery, CustomerTagsOptionsQueryVariables>(CustomerTagsOptionsDocument, options);
        }
export type CustomerTagsOptionsQueryHookResult = ReturnType<typeof useCustomerTagsOptionsQuery>;
export type CustomerTagsOptionsLazyQueryHookResult = ReturnType<typeof useCustomerTagsOptionsLazyQuery>;
export type CustomerTagsOptionsQueryResult = Apollo.QueryResult<CustomerTagsOptionsQuery, CustomerTagsOptionsQueryVariables>;
export const TitlesDocument = gql`
    query Titles {
  titles {
    ...TitleFragments
  }
}
    ${TitleFragmentsFragmentDoc}`;

/**
 * __useTitlesQuery__
 *
 * To run a query within a React component, call `useTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTitlesQuery(baseOptions?: Apollo.QueryHookOptions<TitlesQuery, TitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitlesQuery, TitlesQueryVariables>(TitlesDocument, options);
      }
export function useTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitlesQuery, TitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitlesQuery, TitlesQueryVariables>(TitlesDocument, options);
        }
export type TitlesQueryHookResult = ReturnType<typeof useTitlesQuery>;
export type TitlesLazyQueryHookResult = ReturnType<typeof useTitlesLazyQuery>;
export type TitlesQueryResult = Apollo.QueryResult<TitlesQuery, TitlesQueryVariables>;
export const TitleDocument = gql`
    query Title($titleGuid: String) {
  title(titleGuid: $titleGuid) {
    ...TitleFragments
  }
  languageOptions {
    id
    title
  }
}
    ${TitleFragmentsFragmentDoc}`;

/**
 * __useTitleQuery__
 *
 * To run a query within a React component, call `useTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitleQuery({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useTitleQuery(baseOptions?: Apollo.QueryHookOptions<TitleQuery, TitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitleQuery, TitleQueryVariables>(TitleDocument, options);
      }
export function useTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitleQuery, TitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitleQuery, TitleQueryVariables>(TitleDocument, options);
        }
export type TitleQueryHookResult = ReturnType<typeof useTitleQuery>;
export type TitleLazyQueryHookResult = ReturnType<typeof useTitleLazyQuery>;
export type TitleQueryResult = Apollo.QueryResult<TitleQuery, TitleQueryVariables>;
export const TitlesPaginatedDocument = gql`
    query TitlesPaginated($search: SearchTitlesInput, $filter: FilterTitlesInput, $pagination: PaginationInput, $sort: String, $sortBy: String) {
  titlesPaginated(
    search: $search
    filter: $filter
    pagination: $pagination
    sort: $sort
    sortBy: $sortBy
  ) {
    list {
      pageInfo {
        totalResults
      }
      items {
        ...TitleFragments
      }
    }
    totalGuids
  }
}
    ${TitleFragmentsFragmentDoc}`;

/**
 * __useTitlesPaginatedQuery__
 *
 * To run a query within a React component, call `useTitlesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useTitlesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<TitlesPaginatedQuery, TitlesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitlesPaginatedQuery, TitlesPaginatedQueryVariables>(TitlesPaginatedDocument, options);
      }
export function useTitlesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitlesPaginatedQuery, TitlesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitlesPaginatedQuery, TitlesPaginatedQueryVariables>(TitlesPaginatedDocument, options);
        }
export type TitlesPaginatedQueryHookResult = ReturnType<typeof useTitlesPaginatedQuery>;
export type TitlesPaginatedLazyQueryHookResult = ReturnType<typeof useTitlesPaginatedLazyQuery>;
export type TitlesPaginatedQueryResult = Apollo.QueryResult<TitlesPaginatedQuery, TitlesPaginatedQueryVariables>;
export const TitlesInOriginalTitleDocument = gql`
    query TitlesInOriginalTitle($originalTitleGuid: String!) {
  titlesInOriginalTitle(originalTitleGuid: $originalTitleGuid) {
    guid
    originalTitleGuid
    titleJsonResponse {
      titill
      frumsyning
      stadsetningFrumsyningar
      timabilEfnisFra
      timabilEfnisTil
      tungumal
      athugasemdir
      kreditFullskradur
    }
  }
}
    `;

/**
 * __useTitlesInOriginalTitleQuery__
 *
 * To run a query within a React component, call `useTitlesInOriginalTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesInOriginalTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesInOriginalTitleQuery({
 *   variables: {
 *      originalTitleGuid: // value for 'originalTitleGuid'
 *   },
 * });
 */
export function useTitlesInOriginalTitleQuery(baseOptions: Apollo.QueryHookOptions<TitlesInOriginalTitleQuery, TitlesInOriginalTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitlesInOriginalTitleQuery, TitlesInOriginalTitleQueryVariables>(TitlesInOriginalTitleDocument, options);
      }
export function useTitlesInOriginalTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitlesInOriginalTitleQuery, TitlesInOriginalTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitlesInOriginalTitleQuery, TitlesInOriginalTitleQueryVariables>(TitlesInOriginalTitleDocument, options);
        }
export type TitlesInOriginalTitleQueryHookResult = ReturnType<typeof useTitlesInOriginalTitleQuery>;
export type TitlesInOriginalTitleLazyQueryHookResult = ReturnType<typeof useTitlesInOriginalTitleLazyQuery>;
export type TitlesInOriginalTitleQueryResult = Apollo.QueryResult<TitlesInOriginalTitleQuery, TitlesInOriginalTitleQueryVariables>;
export const CreateTitleDocument = gql`
    mutation CreateTitle($title: TitleInput!) {
  createTitle(title: $title) {
    ...TitleFragments
  }
}
    ${TitleFragmentsFragmentDoc}`;
export type CreateTitleMutationFn = Apollo.MutationFunction<CreateTitleMutation, CreateTitleMutationVariables>;

/**
 * __useCreateTitleMutation__
 *
 * To run a mutation, you first call `useCreateTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTitleMutation, { data, loading, error }] = useCreateTitleMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateTitleMutation(baseOptions?: Apollo.MutationHookOptions<CreateTitleMutation, CreateTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTitleMutation, CreateTitleMutationVariables>(CreateTitleDocument, options);
      }
export type CreateTitleMutationHookResult = ReturnType<typeof useCreateTitleMutation>;
export type CreateTitleMutationResult = Apollo.MutationResult<CreateTitleMutation>;
export type CreateTitleMutationOptions = Apollo.BaseMutationOptions<CreateTitleMutation, CreateTitleMutationVariables>;
export const UpdateTitleDocument = gql`
    mutation UpdateTitle($title: TitleInput!, $titleGuid: String) {
  updateTitle(title: $title, titleGuid: $titleGuid) {
    ...TitleFragments
  }
}
    ${TitleFragmentsFragmentDoc}`;
export type UpdateTitleMutationFn = Apollo.MutationFunction<UpdateTitleMutation, UpdateTitleMutationVariables>;

/**
 * __useUpdateTitleMutation__
 *
 * To run a mutation, you first call `useUpdateTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTitleMutation, { data, loading, error }] = useUpdateTitleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useUpdateTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTitleMutation, UpdateTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTitleMutation, UpdateTitleMutationVariables>(UpdateTitleDocument, options);
      }
export type UpdateTitleMutationHookResult = ReturnType<typeof useUpdateTitleMutation>;
export type UpdateTitleMutationResult = Apollo.MutationResult<UpdateTitleMutation>;
export type UpdateTitleMutationOptions = Apollo.BaseMutationOptions<UpdateTitleMutation, UpdateTitleMutationVariables>;
export const PatchTitleDocument = gql`
    mutation PatchTitle($title: PatchTitleInput!, $titleGuid: String!) {
  patchTitle(title: $title, titleGuid: $titleGuid) {
    ...TitleFragments
  }
}
    ${TitleFragmentsFragmentDoc}`;
export type PatchTitleMutationFn = Apollo.MutationFunction<PatchTitleMutation, PatchTitleMutationVariables>;

/**
 * __usePatchTitleMutation__
 *
 * To run a mutation, you first call `usePatchTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchTitleMutation, { data, loading, error }] = usePatchTitleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function usePatchTitleMutation(baseOptions?: Apollo.MutationHookOptions<PatchTitleMutation, PatchTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchTitleMutation, PatchTitleMutationVariables>(PatchTitleDocument, options);
      }
export type PatchTitleMutationHookResult = ReturnType<typeof usePatchTitleMutation>;
export type PatchTitleMutationResult = Apollo.MutationResult<PatchTitleMutation>;
export type PatchTitleMutationOptions = Apollo.BaseMutationOptions<PatchTitleMutation, PatchTitleMutationVariables>;
export const DeleteTitleDocument = gql`
    mutation DeleteTitle($titleGuid: String!) {
  deleteTitle(titleGuid: $titleGuid)
}
    `;
export type DeleteTitleMutationFn = Apollo.MutationFunction<DeleteTitleMutation, DeleteTitleMutationVariables>;

/**
 * __useDeleteTitleMutation__
 *
 * To run a mutation, you first call `useDeleteTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTitleMutation, { data, loading, error }] = useDeleteTitleMutation({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useDeleteTitleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTitleMutation, DeleteTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTitleMutation, DeleteTitleMutationVariables>(DeleteTitleDocument, options);
      }
export type DeleteTitleMutationHookResult = ReturnType<typeof useDeleteTitleMutation>;
export type DeleteTitleMutationResult = Apollo.MutationResult<DeleteTitleMutation>;
export type DeleteTitleMutationOptions = Apollo.BaseMutationOptions<DeleteTitleMutation, DeleteTitleMutationVariables>;
export const ValidateTitleDeletionDocument = gql`
    query ValidateTitleDeletion($titleGuid: String!) {
  validateTitleDeletion(titleGuid: $titleGuid)
}
    `;

/**
 * __useValidateTitleDeletionQuery__
 *
 * To run a query within a React component, call `useValidateTitleDeletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTitleDeletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateTitleDeletionQuery({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useValidateTitleDeletionQuery(baseOptions: Apollo.QueryHookOptions<ValidateTitleDeletionQuery, ValidateTitleDeletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateTitleDeletionQuery, ValidateTitleDeletionQueryVariables>(ValidateTitleDeletionDocument, options);
      }
export function useValidateTitleDeletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateTitleDeletionQuery, ValidateTitleDeletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateTitleDeletionQuery, ValidateTitleDeletionQueryVariables>(ValidateTitleDeletionDocument, options);
        }
export type ValidateTitleDeletionQueryHookResult = ReturnType<typeof useValidateTitleDeletionQuery>;
export type ValidateTitleDeletionLazyQueryHookResult = ReturnType<typeof useValidateTitleDeletionLazyQuery>;
export type ValidateTitleDeletionQueryResult = Apollo.QueryResult<ValidateTitleDeletionQuery, ValidateTitleDeletionQueryVariables>;
export const TitlesCreateOptionsDocument = gql`
    query TitlesCreateOptions {
  languageOptions {
    id
    title
  }
}
    `;

/**
 * __useTitlesCreateOptionsQuery__
 *
 * To run a query within a React component, call `useTitlesCreateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesCreateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesCreateOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTitlesCreateOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TitlesCreateOptionsQuery, TitlesCreateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitlesCreateOptionsQuery, TitlesCreateOptionsQueryVariables>(TitlesCreateOptionsDocument, options);
      }
export function useTitlesCreateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitlesCreateOptionsQuery, TitlesCreateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitlesCreateOptionsQuery, TitlesCreateOptionsQueryVariables>(TitlesCreateOptionsDocument, options);
        }
export type TitlesCreateOptionsQueryHookResult = ReturnType<typeof useTitlesCreateOptionsQuery>;
export type TitlesCreateOptionsLazyQueryHookResult = ReturnType<typeof useTitlesCreateOptionsLazyQuery>;
export type TitlesCreateOptionsQueryResult = Apollo.QueryResult<TitlesCreateOptionsQuery, TitlesCreateOptionsQueryVariables>;
export const AutocompleteTitleOptionsDocument = gql`
    query AutocompleteTitleOptions($query: String) {
  titleOptions(query: $query) {
    id
    title
  }
}
    `;

/**
 * __useAutocompleteTitleOptionsQuery__
 *
 * To run a query within a React component, call `useAutocompleteTitleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteTitleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteTitleOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAutocompleteTitleOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AutocompleteTitleOptionsQuery, AutocompleteTitleOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteTitleOptionsQuery, AutocompleteTitleOptionsQueryVariables>(AutocompleteTitleOptionsDocument, options);
      }
export function useAutocompleteTitleOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteTitleOptionsQuery, AutocompleteTitleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteTitleOptionsQuery, AutocompleteTitleOptionsQueryVariables>(AutocompleteTitleOptionsDocument, options);
        }
export type AutocompleteTitleOptionsQueryHookResult = ReturnType<typeof useAutocompleteTitleOptionsQuery>;
export type AutocompleteTitleOptionsLazyQueryHookResult = ReturnType<typeof useAutocompleteTitleOptionsLazyQuery>;
export type AutocompleteTitleOptionsQueryResult = Apollo.QueryResult<AutocompleteTitleOptionsQuery, AutocompleteTitleOptionsQueryVariables>;
export const TitleDirectorDocument = gql`
    query TitleDirector($titleGuid: String!) {
  titleDirector(titleGuid: $titleGuid)
}
    `;

/**
 * __useTitleDirectorQuery__
 *
 * To run a query within a React component, call `useTitleDirectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleDirectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitleDirectorQuery({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *   },
 * });
 */
export function useTitleDirectorQuery(baseOptions: Apollo.QueryHookOptions<TitleDirectorQuery, TitleDirectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitleDirectorQuery, TitleDirectorQueryVariables>(TitleDirectorDocument, options);
      }
export function useTitleDirectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitleDirectorQuery, TitleDirectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitleDirectorQuery, TitleDirectorQueryVariables>(TitleDirectorDocument, options);
        }
export type TitleDirectorQueryHookResult = ReturnType<typeof useTitleDirectorQuery>;
export type TitleDirectorLazyQueryHookResult = ReturnType<typeof useTitleDirectorLazyQuery>;
export type TitleDirectorQueryResult = Apollo.QueryResult<TitleDirectorQuery, TitleDirectorQueryVariables>;
export const TitleOptionsDocument = gql`
    query TitleOptions {
  titleOptions {
    id
    title
    extraInfo
  }
}
    `;

/**
 * __useTitleOptionsQuery__
 *
 * To run a query within a React component, call `useTitleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitleOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTitleOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TitleOptionsQuery, TitleOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitleOptionsQuery, TitleOptionsQueryVariables>(TitleOptionsDocument, options);
      }
export function useTitleOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitleOptionsQuery, TitleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitleOptionsQuery, TitleOptionsQueryVariables>(TitleOptionsDocument, options);
        }
export type TitleOptionsQueryHookResult = ReturnType<typeof useTitleOptionsQuery>;
export type TitleOptionsLazyQueryHookResult = ReturnType<typeof useTitleOptionsLazyQuery>;
export type TitleOptionsQueryResult = Apollo.QueryResult<TitleOptionsQuery, TitleOptionsQueryVariables>;
export const TmDbInfoForTitleDocument = gql`
    query TMDbInfoForTitle($titleGuid: String!, $tmdbId: Int!) {
  tmdbInfoForTitle(titleGuid: $titleGuid, tmdbId: $tmdbId) {
    titleGuid
    title
    releaseDate
    overview
    runtime
    spokenLanguages
    id
    page
  }
}
    `;

/**
 * __useTmDbInfoForTitleQuery__
 *
 * To run a query within a React component, call `useTmDbInfoForTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTmDbInfoForTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTmDbInfoForTitleQuery({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *      tmdbId: // value for 'tmdbId'
 *   },
 * });
 */
export function useTmDbInfoForTitleQuery(baseOptions: Apollo.QueryHookOptions<TmDbInfoForTitleQuery, TmDbInfoForTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TmDbInfoForTitleQuery, TmDbInfoForTitleQueryVariables>(TmDbInfoForTitleDocument, options);
      }
export function useTmDbInfoForTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TmDbInfoForTitleQuery, TmDbInfoForTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TmDbInfoForTitleQuery, TmDbInfoForTitleQueryVariables>(TmDbInfoForTitleDocument, options);
        }
export type TmDbInfoForTitleQueryHookResult = ReturnType<typeof useTmDbInfoForTitleQuery>;
export type TmDbInfoForTitleLazyQueryHookResult = ReturnType<typeof useTmDbInfoForTitleLazyQuery>;
export type TmDbInfoForTitleQueryResult = Apollo.QueryResult<TmDbInfoForTitleQuery, TmDbInfoForTitleQueryVariables>;
export const SearchTmDbMoviesDocument = gql`
    query SearchTMDbMovies($name: String!) {
  searchTMDbMovies(name: $name) {
    id
    title
  }
}
    `;

/**
 * __useSearchTmDbMoviesQuery__
 *
 * To run a query within a React component, call `useSearchTmDbMoviesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTmDbMoviesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTmDbMoviesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSearchTmDbMoviesQuery(baseOptions: Apollo.QueryHookOptions<SearchTmDbMoviesQuery, SearchTmDbMoviesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTmDbMoviesQuery, SearchTmDbMoviesQueryVariables>(SearchTmDbMoviesDocument, options);
      }
export function useSearchTmDbMoviesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTmDbMoviesQuery, SearchTmDbMoviesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTmDbMoviesQuery, SearchTmDbMoviesQueryVariables>(SearchTmDbMoviesDocument, options);
        }
export type SearchTmDbMoviesQueryHookResult = ReturnType<typeof useSearchTmDbMoviesQuery>;
export type SearchTmDbMoviesLazyQueryHookResult = ReturnType<typeof useSearchTmDbMoviesLazyQuery>;
export type SearchTmDbMoviesQueryResult = Apollo.QueryResult<SearchTmDbMoviesQuery, SearchTmDbMoviesQueryVariables>;
export const KmiInfoForTitleDocument = gql`
    query KMIInfoForTitle($titleGuid: String!, $kmiId: String!) {
  kmiInfoForTitle(titleGuid: $titleGuid, kmiId: $kmiId) {
    titleGuid
    title
    date
    synopsis
    productionYear
    languages
    genres
  }
}
    `;

/**
 * __useKmiInfoForTitleQuery__
 *
 * To run a query within a React component, call `useKmiInfoForTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useKmiInfoForTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKmiInfoForTitleQuery({
 *   variables: {
 *      titleGuid: // value for 'titleGuid'
 *      kmiId: // value for 'kmiId'
 *   },
 * });
 */
export function useKmiInfoForTitleQuery(baseOptions: Apollo.QueryHookOptions<KmiInfoForTitleQuery, KmiInfoForTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KmiInfoForTitleQuery, KmiInfoForTitleQueryVariables>(KmiInfoForTitleDocument, options);
      }
export function useKmiInfoForTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KmiInfoForTitleQuery, KmiInfoForTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KmiInfoForTitleQuery, KmiInfoForTitleQueryVariables>(KmiInfoForTitleDocument, options);
        }
export type KmiInfoForTitleQueryHookResult = ReturnType<typeof useKmiInfoForTitleQuery>;
export type KmiInfoForTitleLazyQueryHookResult = ReturnType<typeof useKmiInfoForTitleLazyQuery>;
export type KmiInfoForTitleQueryResult = Apollo.QueryResult<KmiInfoForTitleQuery, KmiInfoForTitleQueryVariables>;
export const SearchKmiMoviesDocument = gql`
    query SearchKMIMovies($name: String!) {
  searchKMIMovies(name: $name) {
    id
    title
  }
}
    `;

/**
 * __useSearchKmiMoviesQuery__
 *
 * To run a query within a React component, call `useSearchKmiMoviesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchKmiMoviesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchKmiMoviesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSearchKmiMoviesQuery(baseOptions: Apollo.QueryHookOptions<SearchKmiMoviesQuery, SearchKmiMoviesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchKmiMoviesQuery, SearchKmiMoviesQueryVariables>(SearchKmiMoviesDocument, options);
      }
export function useSearchKmiMoviesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchKmiMoviesQuery, SearchKmiMoviesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchKmiMoviesQuery, SearchKmiMoviesQueryVariables>(SearchKmiMoviesDocument, options);
        }
export type SearchKmiMoviesQueryHookResult = ReturnType<typeof useSearchKmiMoviesQuery>;
export type SearchKmiMoviesLazyQueryHookResult = ReturnType<typeof useSearchKmiMoviesLazyQuery>;
export type SearchKmiMoviesQueryResult = Apollo.QueryResult<SearchKmiMoviesQuery, SearchKmiMoviesQueryVariables>;